var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlagMex(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_587",
    "data-name": "Ret\\xE2ngulo 587",
    width: 60,
    height: 60,
    transform: "translate(2501 3187)",
    fill: "#fff",
    opacity: 0.41
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_518",
    "data-name": "Ret\\xE2ngulo 518",
    width: 102.833,
    height: 59.988,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7657",
    "data-name": "Caminho 7657",
    d: "M595.31,18.986c-.058.374.1.713.35.754s.5-.231.57-.61-.1-.713-.354-.756c-.017,0-.034-.005-.049-.005-.237,0-.46.264-.517.617",
    transform: "translate(-595.298 -18.369)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.5,
    cy: 0.493,
    r: 0.282,
    gradientTransform: "matrix(0.986, 0.381, 0.407, -0.925, -12.598, 218.563)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#df5072"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7674",
    "data-name": "Caminho 7674",
    d: "M593.028,17.246c-.243.127-.287.531-.094.9s.539.549.782.417.288-.526.1-.89a.776.776,0,0,0-.617-.466.337.337,0,0,0-.167.043",
    transform: "translate(-592.814 -17.203)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 0.476,
    r: 0.349,
    gradientTransform: "matrix(-0.106, -0.996, -1.039, 0.088, -714.414, -643.373)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8072",
    "data-name": "Caminho 8072",
    d: "M602.1,19.483c-.293.261-.436.595-.319.751s.468.072.766-.183.438-.6.317-.756a.229.229,0,0,0-.192-.075.917.917,0,0,0-.572.264",
    transform: "translate(-601.742 -19.219)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.498,
    cy: 0.485,
    r: 0.126,
    gradientTransform: "matrix(0.656, 0.762, 1.517, -1.271, -160.865, 344.502)",
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag_MEX",
    transform: "translate(-2501 -3187)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "flag_mexico",
    transform: "translate(2479.583 3187)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_515",
    "data-name": "Ret\\xE2ngulo 515",
    width: 102.833,
    height: 59.988,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_516",
    "data-name": "Ret\\xE2ngulo 516",
    width: 34.234,
    height: 59.988,
    transform: "translate(0.144)",
    fill: "#2c6949"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_517",
    "data-name": "Ret\\xE2ngulo 517",
    width: 34.229,
    height: 59.988,
    transform: "translate(68.604)",
    fill: "#bc0030"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_820",
    "data-name": "Grupo 820",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_819",
    "data-name": "Grupo 819",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7325",
    "data-name": "Caminho 7325",
    d: "M595.5,14.764a4.9,4.9,0,0,1-1.043-.024c-.429-.075-.336-1.167-.345-1.193s-.264-.3-.221-.54.831-.885.943-.921a.475.475,0,0,1,.226.041s.2-.194.258-.194.147.113.12.168-.286.2-.31.319a.8.8,0,0,1-.079.362c-.074.123-.227.283-.242.384s-.069.192.008.225a.906.906,0,0,0,.55-.093c.225-.1.321-.24.352-.228s-.132.278-.375.386-.406.228-.528.2c0,0-.132.322.286.338a1.449,1.449,0,0,0,.65-.086Z",
    transform: "translate(-549.576 8.524)",
    fill: "#a5ab72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7326",
    "data-name": "Caminho 7326",
    d: "M593.532,15.362a.533.533,0,0,1,.324.485c0,.362-.356.663-.348,1.3s.113.643.955,1.322a.937.937,0,0,1,.249.406c.044.211.2,1.425,1,1.416s.922-.509.922-.509l-.348-.514a1.114,1.114,0,0,1-.43.051.565.565,0,0,1-.381-.333,5.948,5.948,0,0,0-.249-.871c-.337-.509-.945-.595-.952-1.125s.372-.595.271-1.231-.859-.939-.859-.939l-.312-.125-.1.641Z",
    transform: "translate(-550.013 10.494)",
    fill: "#a5ab72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7327",
    "data-name": "Caminho 7327",
    d: "M594.758,12.815c.266-.065.114-.775.114-.775l-.19.158a.586.586,0,0,1,.118.309,1.269,1.269,0,0,1-.042.309",
    transform: "translate(-549.009 8.6)",
    fill: "#e4a532"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7328",
    "data-name": "Caminho 7328",
    d: "M595.567,18.9s-.122-.1-.134-.111c-.1-.062-.528-.406-.456-1.426.079-1.152,1.753-1.757,1.861-2.22.122-.509.5-.727-.835-1.769l-.312.362.549.413s.119-.069.125.084-.144.29-.18.413a8.336,8.336,0,0,1-.928.747l-.481.381a2.5,2.5,0,0,0-.422.658,2.034,2.034,0,0,0-.093,1.023,1.508,1.508,0,0,0,1.305,1.445",
    transform: "translate(-549.327 9.555)",
    fill: "#a5ab72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7329",
    "data-name": "Caminho 7329",
    d: "M594.833,16.98l.089.43-.266.1h-.116l-.081.034-.207.194-.05-.012s-.031.012-.043-.117-.033-.237-.033-.237l.252.1.093.007.056-.022.114-.238Z",
    transform: "translate(-549.405 12.129)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7330",
    "data-name": "Caminho 7330",
    d: "M594.193,17.19s-.081-.1-.125-.159-.055-.065-.14-.134l.178-.1h.2l-.034.237Z",
    transform: "translate(-549.548 11.994)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7331",
    "data-name": "Caminho 7331",
    d: "M594.465,16.619a.382.382,0,0,1,.158.153c.038.093.1.206.1.206l-.309-.021-.238-.072.149-.218Z",
    transform: "translate(-549.371 11.871)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7332",
    "data-name": "Caminho 7332",
    d: "M594.345,17.919a.269.269,0,0,1-.1-.135,2.372,2.372,0,0,1-.07-.266l.206-.036.242.1.07,0s-.058.12-.063.129-.236.2-.236.2Z",
    transform: "translate(-549.371 12.487)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7333",
    "data-name": "Caminho 7333",
    d: "M594.916,17.445s-.182-.06-.213-.144-.053-.077-.053-.077l-.057.254-.076.225s.017.039.024.039.173-.043.186-.045.14-.141.14-.147l.048-.1",
    transform: "translate(-549.126 12.302)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7334",
    "data-name": "Caminho 7334",
    d: "M594.3,17.853s.1.048.218.122a.478.478,0,0,0,.21.075l.093-.1.1-.194.016-.021-.494.045Z",
    transform: "translate(-549.28 12.665)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7335",
    "data-name": "Caminho 7335",
    d: "M594.721,17.914l.412-.247.032-.23-.081-.065s.017.01-.1.01h-.148l-.076.279Z",
    transform: "translate(-548.98 12.409)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7336",
    "data-name": "Caminho 7336",
    d: "M594.544,18.061a1.179,1.179,0,0,0,.8-.057c.23-.084.272-.2.272-.2l-.2-.084-.19.178Z",
    transform: "translate(-549.107 12.661)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7337",
    "data-name": "Caminho 7337",
    d: "M594.343,16.188s-.031-.1-.056-.225a.532.532,0,0,1-.024-.173l.146.074.216.163-.152.125Z",
    transform: "translate(-549.309 11.279)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7338",
    "data-name": "Caminho 7338",
    d: "M594.617,16.516a1.342,1.342,0,0,1-.133-.168c-.062-.1-.112-.185-.112-.185l.167.031.183.089-.081.242Z",
    transform: "translate(-549.23 11.545)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7339",
    "data-name": "Caminho 7339",
    d: "M593.976,12.734c-.027.1-.065.288.076.324.077.024.382-.01.732-.4a.628.628,0,0,0,.164-.377l.069-.216s-.134-.1-.354.045a6.371,6.371,0,0,0-.686.629",
    transform: "translate(-549.532 8.591)",
    fill: "#c3c6a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7340",
    "data-name": "Caminho 7340",
    d: "M594.545,12.077a.068.068,0,0,1,.063.065.067.067,0,0,1-.063.069.071.071,0,0,1-.065-.069.074.074,0,0,1,.065-.065",
    transform: "translate(-549.153 8.626)",
    fill: "#232832"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7341",
    "data-name": "Caminho 7341",
    d: "M594.378,12.244a3.215,3.215,0,0,0-.288.264,1.241,1.241,0,0,0,.422-.237.57.57,0,0,1,.423-.111c.058.019.038-.053.008-.077a.344.344,0,0,0-.267-.043,2.791,2.791,0,0,0-.3.2",
    transform: "translate(-549.432 8.591)",
    fill: "#a5ab72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7342",
    "data-name": "Caminho 7342",
    d: "M594.791,16.1s-.008-.051-.015-.173a.519.519,0,0,1,.007-.185l-.145.122-.132.185.208.069Z",
    transform: "translate(-549.134 11.244)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7343",
    "data-name": "Caminho 7343",
    d: "M594.255,16.071a3.535,3.535,0,0,1-.009-.365,4.048,4.048,0,0,1,.083-.509l.089.216.252.4.081.063-.219.156-.212.069Z",
    transform: "translate(-549.321 10.855)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7344",
    "data-name": "Caminho 7344",
    d: "M594.764,15.807a1.1,1.1,0,0,1,.033-.173,1.529,1.529,0,0,1,.08-.209s.007.012,0,.017a2.817,2.817,0,0,0-.229.185c0,.007-.1.091-.1.091l.128.1.088-.012",
    transform: "translate(-549.102 11.018)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7345",
    "data-name": "Caminho 7345",
    d: "M594.335,15.332a.921.921,0,0,1,.141-.264c.113-.141.225-.286.225-.286l.093.389.06.322.005.069a.46.46,0,0,1-.1.034c-.033-.007-.266-.015-.295-.058s-.124-.206-.124-.206",
    transform: "translate(-549.256 10.559)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7346",
    "data-name": "Caminho 7346",
    d: "M594.866,15.494l.132-.132c.065-.062.161-.177.161-.177l-.509.093.068.177Z",
    transform: "translate(-549.031 10.846)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7347",
    "data-name": "Caminho 7347",
    d: "M594.6,14.862a.733.733,0,0,0,.185-.159c.139-.142.209-.122.209-.122l.06.55-.274-.081Z",
    transform: "translate(-549.071 10.414)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7348",
    "data-name": "Caminho 7348",
    d: "M595.052,15.359l.308-.314-.509-.147.089.362Z",
    transform: "translate(-548.887 10.641)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7349",
    "data-name": "Caminho 7349",
    d: "M595.263,14.9l.033-.533a1.6,1.6,0,0,0-.241.163,1.192,1.192,0,0,1-.192.142l.063.1.18.113Z",
    transform: "translate(-548.88 10.263)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7350",
    "data-name": "Caminho 7350",
    d: "M595.487,14.554v-.42l-.017.007a1.193,1.193,0,0,1-.163.183.872.872,0,0,0-.119.122l.134.089Z",
    transform: "translate(-548.646 10.096)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7351",
    "data-name": "Caminho 7351",
    d: "M595.546,14.925l.252-.206a1.128,1.128,0,0,0,.238-.261l-.664-.057.021.271Z",
    transform: "translate(-548.515 10.287)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7352",
    "data-name": "Caminho 7352",
    d: "M594.56,13.779l.55,0-.133-.189-.171-.1-.158-.161-.072.168Z",
    transform: "translate(-549.095 9.515)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7353",
    "data-name": "Caminho 7353",
    d: "M595.236,15.113c.027-.021.176-.132.244-.2a1.068,1.068,0,0,1,.187-.149l-.523-.07.008.353Z",
    transform: "translate(-548.679 10.497)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7354",
    "data-name": "Caminho 7354",
    d: "M595.943,14.679a1.863,1.863,0,0,0,.057-.413,1.385,1.385,0,0,0-.039-.3l-.4.271.057.2.153.166Z",
    transform: "translate(-548.38 9.978)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7355",
    "data-name": "Caminho 7355",
    d: "M595.389,14.215a.548.548,0,0,0,.122-.225c.012-.077.012-.057.012-.057l.305.009.192.019.03.014-.144.168-.2.111-.243.026Z",
    transform: "translate(-548.503 9.951)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7356",
    "data-name": "Caminho 7356",
    d: "M595.964,14.119s-.12-.209-.192-.322a.748.748,0,0,0-.134-.171l-.153.453-.019.041Z",
    transform: "translate(-548.448 9.732)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7357",
    "data-name": "Caminho 7357",
    d: "M593.58,18.328l-.053.132a.868.868,0,0,1,.366-.1c.161,0,.339.2.339.2l.043-.146s-.216-.2-.356-.213a.648.648,0,0,0-.338.125m.1-.927.055.069a.407.407,0,0,1,.23-.249.353.353,0,0,1,.32-.012.267.267,0,0,0-.128-.154.338.338,0,0,0-.3.081.562.562,0,0,0-.173.266m.715.7a.513.513,0,0,0-.269-.252.655.655,0,0,0-.391.089l-.034.111a.576.576,0,0,1,.4-.067.491.491,0,0,1,.242.267Zm-.8-.814a.241.241,0,0,0,.056.077.534.534,0,0,1,.076-.341,1.02,1.02,0,0,1,.185-.158l-.1-.048a.672.672,0,0,0-.188.192.618.618,0,0,0-.032.278m-.091-.377a.372.372,0,0,1,.191-.161.129.129,0,0,0-.044-.043.065.065,0,0,0-.065,0,.425.425,0,0,0-.156.177.8.8,0,0,0-.042.309l.083.051a.9.9,0,0,1,.033-.333m1.267-3.067a.431.431,0,0,1,.23-.057.471.471,0,0,0-.1.459,1.55,1.55,0,0,0-.151.377h.108s.033-.165.076-.3a1.011,1.011,0,0,0,.3.346l.161-.012a1.082,1.082,0,0,1,.081-.391l.012.012a.792.792,0,0,0,.324.225v-.051a1.252,1.252,0,0,1-.29-.252l-.006-.009v-.012a.64.64,0,0,1,.3-.261l.108.091.025-.036-.081-.1h-.1s-.171.151-.285.273a1.255,1.255,0,0,1-.124-.257l-.074-.024a.538.538,0,0,0-.327.276c-.018-.187.191-.389.191-.389l-.012-.075s-.212.043-.377.093a.55.55,0,0,0-.273.2l0,.117a1.461,1.461,0,0,1,.285-.242m.23.338a.839.839,0,0,1,.312-.233.5.5,0,0,0,.125.266,1.32,1.32,0,0,0-.117.369,1.334,1.334,0,0,1-.314-.324c-.012-.017-.019-.029-.031-.045.006-.014.019-.021.024-.033m-1.216,3.4.006.125a.478.478,0,0,1,.317-.149.611.611,0,0,1,.362.149s0-.17-.024-.185a.756.756,0,0,0-.331-.1.659.659,0,0,0-.331.165m3.439-1.8c-.028-.051-.054-.113-.077-.168a.3.3,0,0,0,.089-.048,1.942,1.942,0,0,0,.278-.25l-.062-.1h-.261c-.051,0-.159-.012-.219-.017.012-.043.046-.151.084-.271a1.905,1.905,0,0,1,.084-.221l-.084-.086s.012.081-.137.1a1.045,1.045,0,0,1-.443-.129v.063a3.681,3.681,0,0,0,.4.1.305.305,0,0,0,.194-.043,1.164,1.164,0,0,0-.084.216.437.437,0,0,0-.044.146c0,.022.027.039.027.039l-.012.135s.152.021.23.021.268.015.268.015a1.029,1.029,0,0,1-.273.221.432.432,0,0,1-.06.027c-.007-.024-.165-.259-.165-.259l-.012.087a1.479,1.479,0,0,1,.122.185.753.753,0,0,1-.246-.024l-.061.072s-.008.2,0,.4a2.835,2.835,0,0,1-.282-.091l-.058.045V15.94L596.35,16a1.783,1.783,0,0,0-.049.5v.014a.783.783,0,0,1-.385-.213l-.062.057a1.6,1.6,0,0,0,.014.511.982.982,0,0,1-.41-.23l-.081.065s.048.458.1.7a.309.309,0,0,0,.013.06.677.677,0,0,1-.118,0,.492.492,0,0,1-.36-.213l-.068.163a1.235,1.235,0,0,0,.329.631l.053.045a.925.925,0,0,1-.458.2l.019.141s.146.117.294.219a.177.177,0,0,0,.044.024.72.72,0,0,1-.257.149l.04.087s.19-.129.281-.2a1.571,1.571,0,0,0,.3.075v-.075a2.5,2.5,0,0,1-.245-.051l.021-.017a2.811,2.811,0,0,0,.216-.29l.015-.159a.507.507,0,0,1-.19-.089c.3-.2.3-.293.3-.293l.061-.1a.458.458,0,0,1-.173-.194,2.968,2.968,0,0,0,.466-.115c0-.014.036-.033.036-.033a1.557,1.557,0,0,1-.163-.413c.237.06.47.1.47.1l.079-.065a2.094,2.094,0,0,1-.079-.393c.275.015.516.036.516.036l.044-.051a1.3,1.3,0,0,1-.153-.466l0-.019a.708.708,0,0,0,.153.019c.231-.007.485,0,.485,0l.04-.091a1.225,1.225,0,0,1-.272-.242m-1.687,2.489a2.27,2.27,0,0,1-.225.324.089.089,0,0,0-.04.039c-.023-.012-.048-.024-.075-.039a.484.484,0,0,1-.225-.216s.1-.048.4-.249a1.758,1.758,0,0,1,.165.141m.14-.506a4.238,4.238,0,0,1-.312.305.963.963,0,0,0-.072-.077c-.134-.182-.311-.333-.293-.607a.359.359,0,0,0,.35.17c.047-.005.107-.015.163-.021a.623.623,0,0,0,.165.23m.322-.41a3.8,3.8,0,0,1-.43.108c-.012-.021-.016-.045-.027-.072a2.727,2.727,0,0,1-.077-.639,1.626,1.626,0,0,0,.422.19c.068.281.113.413.113.413m-.077-.47a1.752,1.752,0,0,1,.011-.473.734.734,0,0,0,.371.168,2.583,2.583,0,0,0,.044.333,2.93,2.93,0,0,1-.426-.027m.936-.365a.961.961,0,0,1-.454.024c0-.033-.007-.06-.007-.089a3.888,3.888,0,0,1,.015-.489,2.77,2.77,0,0,0,.35.12V16.1a1.688,1.688,0,0,0,.1.422m-.017-.5-.023,0c.011-.173.011-.429.011-.429a.728.728,0,0,0,.257.027.85.85,0,0,0,.083.207,1.305,1.305,0,0,0,.186.2,2.9,2.9,0,0,1-.514,0m-1.212,2.991-.023-.086a.587.587,0,0,0-.187.221c-.017,0-.029-.01-.046-.01-.094-.034-.32-.129-.32-.129l.023.067a2.685,2.685,0,0,0,.309.12l.017.005c-.029.1-.081.228-.081.228l.041.057a1.077,1.077,0,0,1,.079-.278c.084.009.2.014.2.014a.5.5,0,0,1-.04.13c-.014.07-.057.238-.057.238l.068.048.333,0-.051-.06s-.012-.021-.122-.021a.6.6,0,0,0-.173,0s.014-.058.053-.19.051-.127.051-.127l-.046-.122a.866.866,0,0,1-.177.029.442.442,0,0,1,.15-.141m-1.813-.206a.716.716,0,0,1,.377.134l-.012-.1a.535.535,0,0,0-.344-.209.812.812,0,0,0-.4.187v.2a.6.6,0,0,1,.381-.213m2.14,3.118a1.284,1.284,0,0,1-.442.089.972.972,0,0,0,.125-.249.662.662,0,0,0,.493-.382l-.031-.1a.766.766,0,0,1-.423.386c.06-.194.119-.516.119-.516l-.106-.034a.91.91,0,0,1-.317.257,1.209,1.209,0,0,0,.118-.43l-.053-.089a.588.588,0,0,1-.278.134.4.4,0,0,1-.091,0,4.242,4.242,0,0,0,.281-.514l-.029-.072a2.537,2.537,0,0,1-.281.5c-.019.024-.039.045-.057.067a1.954,1.954,0,0,1-.344-.168l.017.063a.983.983,0,0,0,.288.142c-.1.108-.218.211-.218.211l.012.154s.263.048.482.072a1.293,1.293,0,0,1-.312.329l.065.1a2.807,2.807,0,0,0,.6-.094,1.579,1.579,0,0,1-.19.3,1.35,1.35,0,0,0,.588-.1.782.782,0,0,0,.312-.25l-.065-.079a.469.469,0,0,1-.264.267m-1.107-.658s.1-.117.192-.237l.012.005c.242.053.31-.021.31-.021a.474.474,0,0,1-.108.37,1.178,1.178,0,0,1-.406-.118m.216.487.221-.252c.015-.017.028-.034.041-.05a.531.531,0,0,0,.375-.213,1,1,0,0,1-.079.449,1.2,1.2,0,0,1-.559.065m-.293-1.574a2.361,2.361,0,0,1,.523.125l-.04-.125s-.278-.069-.458-.093a.609.609,0,0,1,.256-.254l-.079-.043s-.093.012-.226.237a.593.593,0,0,1-.031.053l-.047,0a.707.707,0,0,0-.386.118l.032.06a1.143,1.143,0,0,1,.364-.081,3.969,3.969,0,0,0-.116.386l.048.108s.093-.29.153-.49Zm-.488-.984-.045-.123a.652.652,0,0,0-.434,0,.918.918,0,0,0-.329.3l.077.153a.751.751,0,0,1,.305-.3,1.28,1.28,0,0,1,.426-.033m.481.367-.165-.077a1.12,1.12,0,0,0-.358.168.628.628,0,0,0-.144.413.3.3,0,0,0,.111.11.766.766,0,0,1,.175-.377,1.629,1.629,0,0,1,.38-.237m-.622-.07a.714.714,0,0,1,.3-.147l-.1-.089a.9.9,0,0,0-.367.141,3.147,3.147,0,0,0-.284.338l.137.141a4.107,4.107,0,0,1,.305-.382m.826-7.188.009-.012a.291.291,0,0,1,.3-.147h.072l.005-.005.015,0,.019.009a1.56,1.56,0,0,0-.135.387c-.029.177-.114.2-.174.31a1.4,1.4,0,0,0-.173.453c-.007.161.033.245.074.266s.117-.069.117-.1c-.012-.051-.048,0-.081,0s-.029-.051-.039-.149a1.167,1.167,0,0,1,.156-.446.857.857,0,0,0,.171-.327c.021-.125.106-.4.106-.4s-.068-.036-.2-.039a.389.389,0,0,0-.309.182.7.7,0,0,1-.272.183.48.48,0,0,0,.344-.153",
    transform: "translate(-549.934 8.635)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7358",
    "data-name": "Caminho 7358",
    d: "M594.934,13.136l-.395,0,.114.307Z",
    transform: "translate(-549.11 9.383)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7359",
    "data-name": "Caminho 7359",
    d: "M594.644,13.171s-.051-.036-.083-.065a.489.489,0,0,0-.052-.048l-.141.093-.082.3.038.041Z",
    transform: "translate(-549.291 9.327)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7360",
    "data-name": "Caminho 7360",
    d: "M594.658,13.774l-.293-.43-.168.353.084.029s.075.007.2.027a1.252,1.252,0,0,0,.18.021",
    transform: "translate(-549.354 9.531)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7361",
    "data-name": "Caminho 7361",
    d: "M596.493,19.768l-.012.012a1.461,1.461,0,0,1-.75.23,1.113,1.113,0,0,1-.559-.153.609.609,0,0,1-.236-.286,2.494,2.494,0,0,1-.165-.634,1.7,1.7,0,0,0-.176-.59,2.662,2.662,0,0,0-.6-.525,1.2,1.2,0,0,1-.458-.843.85.85,0,0,1-.006-.125,1.973,1.973,0,0,1,.174-.73,1.569,1.569,0,0,0,.187-.554.4.4,0,0,0,0-.077.611.611,0,0,0-.242-.305,1.433,1.433,0,0,0-.191-.132h0l-.152-.039-.012.045.153.048.006-.033-.01.031.01,0a1.441,1.441,0,0,1,.213.141.549.549,0,0,1,.172.252.275.275,0,0,1,.012.069,1.624,1.624,0,0,1-.18.537,1.926,1.926,0,0,0-.182.747,1.113,1.113,0,0,0,.005.132,1.259,1.259,0,0,0,.478.876,2.659,2.659,0,0,1,.59.518,2.768,2.768,0,0,1,.212.794,2.074,2.074,0,0,0,.12.422.7.7,0,0,0,.266.307,1.147,1.147,0,0,0,.581.153,1.465,1.465,0,0,0,.8-.25Z",
    transform: "translate(-550.008 10.726)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7362",
    "data-name": "Caminho 7362",
    d: "M596.024,19.175v0a.442.442,0,0,1-.2.053.381.381,0,0,1-.278-.122.653.653,0,0,1-.189-.372,2.565,2.565,0,0,0-.152-.533,1.709,1.709,0,0,0-.566-.588c-.225-.177-.434-.357-.47-.545a.557.557,0,0,1-.012-.111,1.5,1.5,0,0,1,.144-.5,1.706,1.706,0,0,0,.146-.643.793.793,0,0,0-.012-.125,1.055,1.055,0,0,0-.5-.717,2.083,2.083,0,0,0-.458-.235l-.019.045a.155.155,0,0,1,.036.012,2.383,2.383,0,0,1,.5.283.926.926,0,0,1,.4.614c0,.051.007.084.007.123a1.694,1.694,0,0,1-.141.622,1.415,1.415,0,0,0-.147.523.54.54,0,0,0,.016.127,1.166,1.166,0,0,0,.487.567,1.75,1.75,0,0,1,.55.574,2.713,2.713,0,0,1,.151.521.676.676,0,0,0,.194.393.443.443,0,0,0,.317.141.449.449,0,0,0,.228-.063Z",
    transform: "translate(-549.884 10.527)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7363",
    "data-name": "Caminho 7363",
    d: "M595.923,16.61s.281.069.272.3a2.186,2.186,0,0,1-.137.543l-.39-.35.221-.189.081-.117Z",
    transform: "translate(-548.303 11.864)",
    fill: "#a5ab72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7364",
    "data-name": "Caminho 7364",
    d: "M593.223,15.37s-.273.093-.334-.031a.572.572,0,0,1-.036-.242c0-.026-.165-.039-.152-.194s.221-.153.259-.153.059-.243.2-.231.209.177.209.177Z",
    transform: "translate(-550.424 10.371)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7365",
    "data-name": "Caminho 7365",
    d: "M593.232,15.379l-.007-.021-.017.009c-.029,0-.108.027-.17.027a.24.24,0,0,1-.079-.015c-.018-.012-.036-.021-.04-.041a.348.348,0,0,1-.038-.159V15.1l-.015-.021a.418.418,0,0,0-.04-.022.114.114,0,0,1-.065-.045.1.1,0,0,1-.031-.084v-.017a.131.131,0,0,1,.084-.111.366.366,0,0,1,.139-.021h.014c.024,0,.031-.007.034-.019a.155.155,0,0,0,.029-.057.375.375,0,0,1,.048-.1.074.074,0,0,1,.077-.048h.01a.208.208,0,0,1,.143.079.36.36,0,0,1,.034.057l.012.017v0l.019,0-.02,0-.143.663.019.012-.007-.021.007.021h.021l.14-.675v-.01a.287.287,0,0,0-.057-.086.235.235,0,0,0-.17-.1l-.01,0a.142.142,0,0,0-.1.045.456.456,0,0,0-.068.127.231.231,0,0,1-.017.05l-.007.012v0h-.014a.419.419,0,0,0-.147.021.162.162,0,0,0-.113.144.037.037,0,0,0-.007.024.174.174,0,0,0,.087.151c.021.009.036.017.06.026l.012.007.009-.007-.009,0v0l.009-.007-.009,0v.069a.441.441,0,0,0,.029.18.156.156,0,0,0,.072.06.447.447,0,0,0,.091.012.73.73,0,0,0,.2-.031l.017,0v-.019Z",
    transform: "translate(-550.433 10.363)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7366",
    "data-name": "Caminho 7366",
    d: "M593.385,15.4s-.233.12-.311,0,0-.267-.023-.288-.165-.077-.141-.213.166-.094.223-.122.091-.233.236-.2a.22.22,0,0,1,.168.156s-.114.55-.153.663",
    transform: "translate(-550.276 10.413)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7367",
    "data-name": "Caminho 7367",
    d: "M593.394,15.409l-.008-.021-.019.009a.5.5,0,0,1-.173.045.087.087,0,0,1-.089-.045.164.164,0,0,1-.033-.113c0-.057.014-.1.014-.139a.064.064,0,0,0-.014-.041.117.117,0,0,0-.031-.021.548.548,0,0,1-.072-.051.118.118,0,0,1-.032-.089l0-.027a.065.065,0,0,1,.029-.057.138.138,0,0,1,.084-.036.3.3,0,0,0,.1-.015.114.114,0,0,0,.039-.048.687.687,0,0,1,.063-.1.107.107,0,0,1,.084-.055.059.059,0,0,1,.033.01.206.206,0,0,1,.125.077.4.4,0,0,1,.027.039v.014l.021,0-.021-.007s-.027.141-.06.293-.072.321-.093.365l.021.012-.008-.021.008.021.015.007c.024-.058.061-.225.1-.377s.064-.291.064-.291v-.009a.131.131,0,0,0-.032-.065.247.247,0,0,0-.159-.1.06.06,0,0,0-.038-.009.119.119,0,0,0-.084.036.442.442,0,0,0-.081.1.329.329,0,0,1-.022.043l-.024.026c-.009,0-.02,0-.044.01a.254.254,0,0,0-.108.017.145.145,0,0,0-.081.108v.036a.175.175,0,0,0,.073.141.49.49,0,0,0,.048.036l.031.017v.009a1.093,1.093,0,0,0-.019.139.349.349,0,0,0,.036.144.148.148,0,0,0,.128.058.526.526,0,0,0,.2-.057l.011-.009v-.005Z",
    transform: "translate(-550.285 10.404)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7368",
    "data-name": "Caminho 7368",
    d: "M593.623,15.42a.209.209,0,0,1-.233.12c-.161-.027-.117-.276-.145-.321s-.14-.069-.119-.225.171-.134.231-.153.119-.261.227-.218.216.173.192.237c0,0-.229.074-.266.23a.5.5,0,0,0,.113.329",
    transform: "translate(-550.122 10.442)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7369",
    "data-name": "Caminho 7369",
    d: "M593.633,15.43l-.016-.007a.258.258,0,0,1-.048.063.174.174,0,0,1-.122.045.115.115,0,0,1-.043-.005.1.1,0,0,1-.077-.043.235.235,0,0,1-.033-.141.251.251,0,0,1-.007-.072.092.092,0,0,0-.014-.05c-.019-.031-.048-.043-.072-.067a.143.143,0,0,1-.048-.117v-.033a.108.108,0,0,1,.033-.069.131.131,0,0,1,.087-.048c.038-.009.07-.009.1-.017a.194.194,0,0,0,.051-.048.912.912,0,0,1,.068-.118.209.209,0,0,1,.045-.045.049.049,0,0,1,.032-.012h.015a.274.274,0,0,1,.125.087.191.191,0,0,1,.055.113v.01l.021.012,0-.022a1.052,1.052,0,0,0-.125.058.313.313,0,0,0-.159.19c0,.015-.005.033-.005.048a.565.565,0,0,0,.125.3l.016-.017-.016-.007.016.007.017-.009-.005-.01a.52.52,0,0,1-.107-.266.121.121,0,0,1,.006-.045.254.254,0,0,1,.134-.156.341.341,0,0,1,.077-.041c.011-.009.023-.009.028-.015h.008l.012,0,.007-.012v-.024a.242.242,0,0,0-.063-.137.421.421,0,0,0-.146-.1.086.086,0,0,0-.03,0,.124.124,0,0,0-.078.036.5.5,0,0,0-.081.123c-.012.017-.02.033-.032.048a.073.073,0,0,1-.019.021c-.015.005-.032.005-.06.012a.274.274,0,0,0-.108.033.162.162,0,0,0-.078.129.084.084,0,0,0,0,.033.177.177,0,0,0,.059.144c.034.031.07.048.072.06l0,.015a.947.947,0,0,0,.019.166.577.577,0,0,0,.038.1.178.178,0,0,0,.093.045.131.131,0,0,0,.055.009.231.231,0,0,0,.158-.065.69.69,0,0,1,.051-.065V15.43l-.006-.009Z",
    transform: "translate(-550.131 10.431)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7370",
    "data-name": "Caminho 7370",
    d: "M596.226,17.546s-.208-.23-.356-.43a3.992,3.992,0,0,0-.37-.434l-.354-.175-.229-.379-.031-.444.1-.261.128-.2s-.735.267-.357,1.682a.879.879,0,0,0,.568.7l.683-.045Z",
    transform: "translate(-549.031 10.876)",
    fill: "#a46f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7371",
    "data-name": "Caminho 7371",
    d: "M596.188,13.834a.139.139,0,0,1,.125.051.193.193,0,0,1,.031.11l0,.045,0,.015v.007l.021.005-.021-.012c-.247.545-.763.8-1.228,1.137a2.127,2.127,0,0,0-.614.617,1.9,1.9,0,0,0-.269,1.041.258.258,0,0,0,.007.069A1.689,1.689,0,0,0,594.9,18.4a1.57,1.57,0,0,0,.84.255h.06s.092-.015.233-.031.312-.021.481-.021c.1,0,.2.009.276.015a.248.248,0,0,1,.152.062.124.124,0,0,1,.033.082.334.334,0,0,1-.1.194.682.682,0,0,1-.142.108l.024.048a.611.611,0,0,0,.152-.129.343.343,0,0,0,.118-.221.212.212,0,0,0-.046-.118.31.31,0,0,0-.177-.072,1.565,1.565,0,0,0-.291-.017,6.715,6.715,0,0,0-.718.048v0h-.057a1.533,1.533,0,0,1-.814-.249,1.64,1.64,0,0,1-.643-1.44V16.85a1.882,1.882,0,0,1,.248-1.008,2.947,2.947,0,0,1,.952-.852,2.291,2.291,0,0,0,.9-.914l0,0c0-.007,0-.039,0-.079a.241.241,0,0,0-.033-.137.193.193,0,0,0-.168-.077Z",
    transform: "translate(-549.335 9.844)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7372",
    "data-name": "Caminho 7372",
    d: "M596.116,16.764s-.176.324-.219.326c0,0,.154.048.2.129l-.041.075a.912.912,0,0,0-.312-.144l-.015-.113a.54.54,0,0,0,.18-.113.648.648,0,0,0,.141-.276Z",
    transform: "translate(-548.264 11.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7373",
    "data-name": "Caminho 7373",
    d: "M597.261,17.413l-.437.122-.218-.137s.014-.185-.087-.262a.932.932,0,0,0-.245-.142,2.177,2.177,0,0,0-.406-.041l-.79-.859.3.031.464-.06.431-.033.23.033.249.074.127.1.13.12.137.225.083.249.037.269Z",
    transform: "translate(-548.726 11.451)",
    fill: "#f2c948"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7374",
    "data-name": "Caminho 7374",
    d: "M596.692,16.821a1.475,1.475,0,0,1-.358.045,1.747,1.747,0,0,1-.317-.033s.01.009-.034.137a1.57,1.57,0,0,1-.081.216l.013.514.413.081.217-.089.115-.557Z",
    transform: "translate(-548.137 12.015)",
    fill: "#a46f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7375",
    "data-name": "Caminho 7375",
    d: "M596.3,16.7l.017.2.083.021-.007-.18Z",
    transform: "translate(-547.855 11.925)",
    fill: "#f2c948"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7376",
    "data-name": "Caminho 7376",
    d: "M596.649,14.385l-.052-.353-.141-.228-.17-.238-.187-.211-.1-.086-.042-.075-.461.019-.239.283a3.215,3.215,0,0,1,.856.931,1.285,1.285,0,0,1,.458.269l.016-.033Z",
    transform: "translate(-548.599 9.424)",
    fill: "#f2c948"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7377",
    "data-name": "Caminho 7377",
    d: "M595.854,14.254a1.2,1.2,0,0,1-.116.61l.281-.317.2-.365a1.259,1.259,0,0,0-.458-.269.771.771,0,0,1,.089.341",
    transform: "translate(-548.254 9.938)",
    fill: "#a46f32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7378",
    "data-name": "Caminho 7378",
    d: "M596.372,17.369a2.386,2.386,0,0,0-.221-.252.854.854,0,0,0-.218-.149l-.015.048s0,0,.015.012a.594.594,0,0,1,.182.129,1.883,1.883,0,0,1,.14.159c.042.045.076.086.076.086Z",
    transform: "translate(-548.126 12.12)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7379",
    "data-name": "Caminho 7379",
    d: "M596.568,16.978a.675.675,0,0,1-.2.3,1.613,1.613,0,0,1-.35.231l.445.168.3-.279Z",
    transform: "translate(-548.052 12.127)",
    fill: "#6b5c2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7380",
    "data-name": "Caminho 7380",
    d: "M596.387,17.045l.077.137.012.079-.02.045-.029.053-.081.084-.072.063Z",
    transform: "translate(-547.871 12.175)",
    fill: "#42441f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7381",
    "data-name": "Caminho 7381",
    d: "M601.387,22.056l.039.722.266-.18L601.486,22Z",
    transform: "translate(-544.22 15.718)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7382",
    "data-name": "Caminho 7382",
    d: "M601.4,22.07h-.021l.038.754.317-.2-.223-.634-.132.072v.012h.021l.012.017.075-.041.2.557-.231.149-.029-.686-.024,0,.012.017Z",
    transform: "translate(-544.228 15.704)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7383",
    "data-name": "Caminho 7383",
    d: "M601.708,22.015a.237.237,0,0,1-.242.23.233.233,0,0,1-.237-.23.237.237,0,0,1,.237-.228.24.24,0,0,1,.242.228",
    transform: "translate(-544.331 15.562)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7384",
    "data-name": "Caminho 7384",
    d: "M601.718,22.02h-.02a.221.221,0,0,1-.441,0,.221.221,0,0,1,.441,0h.036a.259.259,0,0,0-.516,0,.258.258,0,0,0,.516,0Z",
    transform: "translate(-544.34 15.557)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7385",
    "data-name": "Caminho 7385",
    d: "M601.513,22.094a.2.2,0,0,0-.072.072c-.021.048-.048.144-.048.144l.006-.233.074-.046Z",
    transform: "translate(-544.215 15.736)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7386",
    "data-name": "Caminho 7386",
    d: "M601.661,22.091a.2.2,0,0,1-.18.081.205.205,0,0,1-.209-.132.239.239,0,0,1,.024-.19c.042-.075-.063.077-.063.077v.144l.1.108.081.026.083.007.1-.036.065-.051Z",
    transform: "translate(-544.329 15.592)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7387",
    "data-name": "Caminho 7387",
    d: "M602.21,22.9l-.53-.506-.236.2.715.413Z",
    transform: "translate(-544.178 15.995)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7388",
    "data-name": "Caminho 7388",
    d: "M602.227,22.91l.012-.009-.542-.525-.276.225.761.449.065-.144-.008-.005-.012.009L602.2,22.9l-.036.084L601.5,22.6l.2-.163.511.5.019-.024L602.2,22.9Z",
    transform: "translate(-544.195 15.983)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7389",
    "data-name": "Caminho 7389",
    d: "M601.878,23.012a.238.238,0,0,1,.057-.326.222.222,0,1,1,.266.355.223.223,0,0,1-.322-.029",
    transform: "translate(-543.897 16.168)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7390",
    "data-name": "Caminho 7390",
    d: "M601.886,23.021l.017-.015a.192.192,0,0,1-.038-.117.221.221,0,0,1,.089-.182.254.254,0,0,1,.136-.045.238.238,0,0,1,.164.074.286.286,0,0,1,.038.123.229.229,0,0,1-.089.182.244.244,0,0,1-.141.045.182.182,0,0,1-.159-.081l-.017.015-.016.012a.237.237,0,0,0,.192.093.3.3,0,0,0,.161-.053.276.276,0,0,0,.1-.213.235.235,0,0,0-.047-.141.229.229,0,0,0-.19-.1.244.244,0,0,0-.16.057.271.271,0,0,0-.1.209.276.276,0,0,0,.045.144Z",
    transform: "translate(-543.905 16.159)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7391",
    "data-name": "Caminho 7391",
    d: "M602.156,22.786a.172.172,0,0,1-.115.012,2.358,2.358,0,0,1-.555-.285l.605.374Z",
    transform: "translate(-544.149 16.081)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7392",
    "data-name": "Caminho 7392",
    d: "M602.293,22.8a.215.215,0,0,1-.129.158.211.211,0,0,1-.246-.024.216.216,0,0,1-.06-.182c0-.087-.024.1-.024.1l.068.122.129.063.084-.017.075-.034.072-.074.038-.081Z",
    transform: "translate(-543.899 16.237)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7393",
    "data-name": "Caminho 7393",
    d: "M604.249,18.327l.533.535.068-.269-.494-.331Z",
    transform: "translate(-542.174 13.044)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7394",
    "data-name": "Caminho 7394",
    d: "M604.263,18.337l-.009.012.559.569.079-.324-.521-.346-.141.086.024.015.009-.012.011.019.1-.063.47.321-.048.221-.511-.513-.018.015.011.019Z",
    transform: "translate(-542.188 13.034)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7395",
    "data-name": "Caminho 7395",
    d: "M604.525,18.312a.229.229,0,0,1-.225.228.228.228,0,0,1,0-.456.229.229,0,0,1,.225.228",
    transform: "translate(-542.298 12.917)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7396",
    "data-name": "Caminho 7396",
    d: "M604.534,18.322h-.016a.215.215,0,0,1-.209.209.209.209,0,0,1,0-.418.215.215,0,0,1,.209.209h.033a.244.244,0,1,0-.487,0,.244.244,0,1,0,.487,0Z",
    transform: "translate(-542.307 12.907)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7397",
    "data-name": "Caminho 7397",
    d: "M604.434,18.336a.137.137,0,0,0-.018.069v.108l-.128-.146.065-.094Z",
    transform: "translate(-542.147 13.052)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7398",
    "data-name": "Caminho 7398",
    d: "M604.512,18.251c.008.1-.149.257-.266.209a.217.217,0,0,1-.136-.286c.065-.12-.027.041-.027.041l.015.177.108.1.141,0,.108-.06.065-.117Z",
    transform: "translate(-542.293 12.949)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7399",
    "data-name": "Caminho 7399",
    d: "M605.42,18.525l-.82.24.065-.273.7-.069Z",
    transform: "translate(-541.924 13.16)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7400",
    "data-name": "Caminho 7400",
    d: "M605.435,18.535l-.007-.019-.787.228.057-.225.677-.062.042.086.019-.009-.007-.019.007.019.016-.009-.051-.117-.736.072-.084.322.888-.254-.017-.024Z",
    transform: "translate(-541.939 13.15)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7401",
    "data-name": "Caminho 7401",
    d: "M605.468,18.512a.218.218,0,0,1-.218.221.223.223,0,1,1,.218-.221",
    transform: "translate(-541.619 13.062)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7402",
    "data-name": "Caminho 7402",
    d: "M605.475,18.52h-.015a.211.211,0,0,1-.2.206.2.2,0,0,1,0-.41.209.209,0,0,1,.2.2h.034a.238.238,0,1,0-.477,0,.238.238,0,1,0,.477,0Z",
    transform: "translate(-541.626 13.054)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7403",
    "data-name": "Caminho 7403",
    d: "M605.451,18.382s-.029-.075-.018.005-.094.259-.22.243a.2.2,0,0,1-.167-.221c.015-.1-.017.036-.017.036l.017.129.068.062.094.055.1-.015.1-.069.042-.087v-.069Z",
    transform: "translate(-541.618 13.107)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7404",
    "data-name": "Caminho 7404",
    d: "M605.064,18.45s.007.053-.063.093-.214.125-.214.125l.454-.134-.039-.111Z",
    transform: "translate(-541.79 13.159)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7405",
    "data-name": "Caminho 7405",
    d: "M603.671,21.2l-.5-.787.081-.041.567.675Z",
    transform: "translate(-542.946 14.551)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7406",
    "data-name": "Caminho 7406",
    d: "M603.683,21.211l.017-.015-.49-.756.044-.027.548.646-.132.137.012.015.017-.015-.017.015.017.015.16-.165-.594-.706-.113.06.53.828.017-.017Z",
    transform: "translate(-542.958 14.54)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7407",
    "data-name": "Caminho 7407",
    d: "M603.238,20.155a.233.233,0,1,1-.233.233.237.237,0,0,1,.233-.233",
    transform: "translate(-543.063 14.396)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7408",
    "data-name": "Caminho 7408",
    d: "M603.481,20.4h-.021a.212.212,0,0,1-.212.213.215.215,0,0,1-.216-.213.22.22,0,0,1,.216-.216.217.217,0,0,1,.212.216h.036a.252.252,0,0,0-.249-.257.255.255,0,1,0,0,.509.249.249,0,0,0,.249-.252Z",
    transform: "translate(-543.072 14.386)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7409",
    "data-name": "Caminho 7409",
    d: "M603.465,20.635a.127.127,0,0,0-.027.087.843.843,0,0,0,.012.122l-.261-.4.079-.048Z",
    transform: "translate(-542.932 14.568)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7410",
    "data-name": "Caminho 7410",
    d: "M603.46,20.408a.27.27,0,0,1-.317.12c-.093-.057-.171-.245-.06-.333l-.057.055-.027.106.04.115.092.1.081.027.125-.027.1-.075s.075-.2.027-.089",
    transform: "translate(-543.067 14.425)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7411",
    "data-name": "Caminho 7411",
    d: "M603.481,20.94l.641.117.021-.084-.536-.213Z",
    transform: "translate(-542.724 14.829)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7412",
    "data-name": "Caminho 7412",
    d: "M603.495,20.951l0,.027.653.118.038-.129-.567-.223-.153.223.029.01,0-.027.016.015.122-.171.5.2-.013.048-.619-.108,0,.015.016.015Z",
    transform: "translate(-542.737 14.818)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7413",
    "data-name": "Caminho 7413",
    d: "M604.287,21.033a.226.226,0,1,1-.451,0,.226.226,0,1,1,.451,0",
    transform: "translate(-542.469 14.859)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7414",
    "data-name": "Caminho 7414",
    d: "M604.295,21.041h-.017a.208.208,0,0,1-.208.218.218.218,0,0,1-.213-.218.216.216,0,0,1,.213-.213.205.205,0,0,1,.208.213h.037a.245.245,0,0,0-.245-.249.242.242,0,0,0-.246.249.247.247,0,0,0,.246.257.251.251,0,0,0,.245-.257Z",
    transform: "translate(-542.477 14.851)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7415",
    "data-name": "Caminho 7415",
    d: "M603.934,20.857s.005.045-.081.045-.264,0-.264,0l.429.081.021-.084Z",
    transform: "translate(-542.646 14.898)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7416",
    "data-name": "Caminho 7416",
    d: "M604.269,20.934a.185.185,0,0,1-.242.233.211.211,0,0,1-.153-.293l-.039.1.028.129.094.1.106.017.1-.021.1-.1.029-.12Z",
    transform: "translate(-542.47 14.91)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7417",
    "data-name": "Caminho 7417",
    d: "M610.654,18.133c-.051.614-.658.924-.976,1.157a1.829,1.829,0,0,0-.473.516l-.1.362-.057.23-.009.081a1.086,1.086,0,0,1,.049.341c.01.276-.017.677-.017.677l.434-.309.31-.113.091-.012a2.307,2.307,0,0,0-.478.708c-.14.369-.39,1.159-.859,1.416s-.758.144-.919.278-.161.183-.161.183l-.2.273-.158.2-.149.1-.09.077a1.458,1.458,0,0,1-.042.267c-.051.182-.113.382-.113.382a.744.744,0,0,1,.208-.077c.114-.009.218-.007.218-.007a.671.671,0,0,0-.116.213,1.368,1.368,0,0,1-.581,1.119,5.26,5.26,0,0,1-2.151.322l-.287.118-.278.206-.255.276-.015.074a2.036,2.036,0,0,1-.322.317c-.136.093-.453.3-.453.3a1.808,1.808,0,0,1,.356.019c.089.034.561.247.561.247a1.728,1.728,0,0,0-.578.087,6.551,6.551,0,0,1-1.841.679c-.521-.017-1.265-.78-1.265-.78l-.338-.233-.553-.108-.695-.043.009-.089.018-.111a3.075,3.075,0,0,1,.6.019c.329.038.434.146.706.177a1.057,1.057,0,0,0,.569-.055c.1-.045.939-.754.939-.754l.939-.329.358.055.16.041.146.036a.875.875,0,0,1-.158.18,1.132,1.132,0,0,1-.228.168l.113.089.593-.1.194.051a.192.192,0,0,1,.058.029.531.531,0,0,1,.085-.2,3.061,3.061,0,0,1,.545-.459,2.239,2.239,0,0,0,.229-.159c.039-.053.237-.554.237-.554l.027-.25.651-.629.445-.477.192-.538-.016-.108a.68.68,0,0,1,.129.5,1.051,1.051,0,0,1-.1.442,6.852,6.852,0,0,1,.689-.413.739.739,0,0,1,.379-.074.979.979,0,0,0,.345-.295c.132-.194.165-.247.165-.326s.021-.439.021-.439l-.048-1.143.393-.854.559-.5.108-.06a.84.84,0,0,0-.057.2c0,.084,0,.225,0,.225a2.186,2.186,0,0,1,.428-.458c.04-.017.065-.033.089-.045a1.1,1.1,0,0,0,.117-.312,2.787,2.787,0,0,0,.048-.5l.012-.475-.092-.36-.262-.7-.007-.919-.194-.266s.182-.019.412.314a2.182,2.182,0,0,1,.3.8l.529-1.637a1.9,1.9,0,0,1,.242.513,4.188,4.188,0,0,1,.136.547l.209-.454a.48.48,0,0,0,.024.158,1.4,1.4,0,0,1,.314.958M599.841,28.582s-.1-.254-.61-.506a3.13,3.13,0,0,0-.9-.3l0,.189.807.353.4.326Z",
    transform: "translate(-546.405 11.723)",
    fill: "#99a069"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7418",
    "data-name": "Caminho 7418",
    d: "M603.513,27.043a3.8,3.8,0,0,1,.705-.569,1.589,1.589,0,0,1,.513-.137,2.2,2.2,0,0,0,1.063-.394,2.9,2.9,0,0,0,.993-.946.928.928,0,0,1,.382-.132s-.295.345-.55.626a4.682,4.682,0,0,1-.931.73,2.855,2.855,0,0,1-1.217.285,1.183,1.183,0,0,0-.658.329,2.19,2.19,0,0,0-.326.358.2.2,0,0,1,.027-.149m1.941-2.038a3.431,3.431,0,0,0-.864,1.143s.578-.5.876-.783.713-.417.9-.593.192-.319.317-.434a1.554,1.554,0,0,1,.211-.165s-.292-.225-1.444.831m-1.373,1.371a.77.77,0,0,0,.384-.369,2.644,2.644,0,0,1,.158-.446s.679-.651.915-.936a.886.886,0,0,0,.241-.915.583.583,0,0,1-.129.434c-.184.218-1.06.819-1.164,1.167a3.465,3.465,0,0,0-.1.54c-.1.425-.305.525-.305.525m-.454,1.7a1.328,1.328,0,0,0-.718-.206c-.775.048-1.44.53-1.955.545s-.718-.245-1.113-.514a3.3,3.3,0,0,0-1.476-.249l0,.024-.007.033a5.645,5.645,0,0,1,1.027.093c.583.165.907.771,1.57.734.864-.048,1.574-.578,1.931-.578.613.009.742.118.742.118m-3.861-.4a1.555,1.555,0,0,0,1.075-.233,4.419,4.419,0,0,1,1.333-.831,2.65,2.65,0,0,1,.632.053,1.951,1.951,0,0,0-.7-.161,1.808,1.808,0,0,0-.921.219c-.3.175-.432.5-.754.691a2.034,2.034,0,0,1-.662.262m-.109.811a1.244,1.244,0,0,0-.2.051,3.736,3.736,0,0,0-.474-.334,2.974,2.974,0,0,0-.646-.216s-.048.005.039.036a6.5,6.5,0,0,1,.61.237,1.478,1.478,0,0,1,.427.343.253.253,0,0,0,.239.127c.153,0,.216-.091.2-.147s-.108-.1-.19-.1m.433-.583a1.278,1.278,0,0,0,.631.125c.847-.021,1.373-.591,1.927-.807a.947.947,0,0,1,.838-.027s.014-.033,0-.045a1.174,1.174,0,0,0-.622-.194,5.667,5.667,0,0,0-2.175.756,2.787,2.787,0,0,1-.6.192m8.979-6.4a16.351,16.351,0,0,0-.9,1.491c-.188.257-.428.331-.524.437s-.434.547-.508.66-.1.079-.163.127-.081.053.012.026.123-.081.259-.238a2.871,2.871,0,0,1,.362-.432,6.98,6.98,0,0,0,.829-.675c.2-.249.609-1.2.826-1.437a2.046,2.046,0,0,1,.643-.4s-.319-.1-.84.439m-1.443,1.781a.669.669,0,0,1,.2-.413c.206-.254.278-.221.449-.586s.239-.715.375-1.1a4.548,4.548,0,0,1,.365-.773.727.727,0,0,0-.441.327,5.45,5.45,0,0,0-.756,1.385,4.013,4.013,0,0,0-.19,1.161m-.271.353s.081-.039.092-.509a5.4,5.4,0,0,1,.108-1.466,7.189,7.189,0,0,1,.859-1.111,2.078,2.078,0,0,0-.717.4,1.371,1.371,0,0,0-.574,1.071c.024.317.2.675.213.987s.019.622.019.622M609.05,20.4s.184-.636.256-.8a1.724,1.724,0,0,1,.437-.651,1.687,1.687,0,0,0,.5-.7,7.462,7.462,0,0,0,.084-1.229.736.736,0,0,0-.17.24,7.765,7.765,0,0,1-.152,1.02,6.76,6.76,0,0,1-.6,1.049,5.244,5.244,0,0,1,.021-.921,4.9,4.9,0,0,1,.285-.91,6.305,6.305,0,0,0,.027-1.082,1.975,1.975,0,0,0-.369.54,3.89,3.89,0,0,0-.2,1.215,7.3,7.3,0,0,0,.1.943,1.06,1.06,0,0,1-.059.581,1.26,1.26,0,0,0-.1.317,4.279,4.279,0,0,1-.121.418Zm-.559-3.461a.9.9,0,0,1,.177.583,2.253,2.253,0,0,0-.024,1.042c.12.322.3.355.344.538a3.149,3.149,0,0,1,.053.55,3.192,3.192,0,0,0,.033-.879c-.072-.192-.1-.1-.2-.305s.005-.749-.075-1.066a.739.739,0,0,0-.306-.463",
    transform: "translate(-546.411 11.724)",
    fill: "#707837"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7419",
    "data-name": "Caminho 7419",
    d: "M594.856,21.99a.181.181,0,0,1-.171.189c-.083,0-.153-.084-.153-.2a.177.177,0,0,1,.153-.194.2.2,0,0,1,.171.206",
    transform: "translate(-549.115 15.56)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7420",
    "data-name": "Caminho 7420",
    d: "M594.864,22h-.025a.171.171,0,0,1-.05.125.129.129,0,0,1-.1.048.12.12,0,0,1-.1-.048.262.262,0,0,1,0-.266.13.13,0,0,1,.1-.053.134.134,0,0,1,.1.06.214.214,0,0,1,.05.13h.039a.234.234,0,0,0-.058-.153.17.17,0,0,0-.127-.072.136.136,0,0,0-.118.067.221.221,0,0,0-.053.149.233.233,0,0,0,.053.156.134.134,0,0,0,.118.069.2.2,0,0,0,.185-.216h-.014Z",
    transform: "translate(-549.123 15.551)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7421",
    "data-name": "Caminho 7421",
    d: "M594.767,22.117l.146.8-.2-.075-.068-.7Z",
    transform: "translate(-549.034 15.798)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7422",
    "data-name": "Caminho 7422",
    d: "M594.777,22.13h-.024l.144.768-.151-.058-.069-.665.1-.029,0-.015h0l-.007-.024-.138.033.076.734.241.093-.158-.866-.022.007Z",
    transform: "translate(-549.043 15.785)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7423",
    "data-name": "Caminho 7423",
    d: "M595.07,21.977c.1.12-.065.305-.229.35s-.374-.029-.374-.182c0-.173.242-.087.305-.108.1-.029.2-.189.3-.06",
    transform: "translate(-549.163 15.662)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7424",
    "data-name": "Caminho 7424",
    d: "M595.077,21.987,595.06,22a.082.082,0,0,1,.029.069.217.217,0,0,1-.077.147.316.316,0,0,1-.171.1.344.344,0,0,1-.1.017.387.387,0,0,1-.182-.053.156.156,0,0,1-.079-.129.082.082,0,0,1,.04-.075.14.14,0,0,1,.084-.017c.048,0,.1.009.147.009a.152.152,0,0,0,.036,0A1.058,1.058,0,0,0,594.9,22a.132.132,0,0,1,.089-.045.07.07,0,0,1,.067.041l.017-.012.018-.015a.143.143,0,0,0-.1-.06.2.2,0,0,0-.113.058.438.438,0,0,1-.108.062h-.018c-.039,0-.094-.009-.147-.009a.3.3,0,0,0-.1.017.141.141,0,0,0-.047.115.175.175,0,0,0,.092.161.366.366,0,0,0,.2.06.307.307,0,0,0,.107-.021.382.382,0,0,0,.186-.115.233.233,0,0,0,.091-.173.148.148,0,0,0-.035-.1Z",
    transform: "translate(-549.171 15.651)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7425",
    "data-name": "Caminho 7425",
    d: "M595.058,21.963c.044.045-.021.228-.2.3s-.278,0-.322-.057a.209.209,0,0,1-.052-.125l-.017.033.017.093.1.081.161.033.12-.014.114-.069.068-.067.051-.075,0-.094-.027-.046h-.012Z",
    transform: "translate(-549.163 15.683)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7426",
    "data-name": "Caminho 7426",
    d: "M594.771,22.228a.117.117,0,0,0-.065.053.536.536,0,0,0-.036.13l-.018-.211.093-.057Z",
    transform: "translate(-549.03 15.817)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7427",
    "data-name": "Caminho 7427",
    d: "M594.359,22.746c0,.1-.117.183-.254.183s-.249-.082-.249-.183.113-.177.249-.177.254.081.254.177",
    transform: "translate(-549.597 16.121)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7428",
    "data-name": "Caminho 7428",
    d: "M594.367,22.754h-.024a.129.129,0,0,1-.06.113.285.285,0,0,1-.169.055.266.266,0,0,1-.163-.055.138.138,0,0,1-.072-.113.157.157,0,0,1,.072-.111.253.253,0,0,1,.163-.045.271.271,0,0,1,.169.045.144.144,0,0,1,.06.111h.04a.183.183,0,0,0-.084-.144.383.383,0,0,0-.185-.053.425.425,0,0,0-.187.053.174.174,0,0,0,0,.293.336.336,0,0,0,.187.051.308.308,0,0,0,.185-.051.182.182,0,0,0,.084-.149Z",
    transform: "translate(-549.605 16.112)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7429",
    "data-name": "Caminho 7429",
    d: "M594.251,22.728l.768-.036-.128-.153-.635.065Z",
    transform: "translate(-549.316 16.099)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7430",
    "data-name": "Caminho 7430",
    d: "M594.26,22.736v.024l.814-.041-.165-.192-.666.069,0,.168.021,0v-.024l.016,0,.011-.108.607-.065.092.118-.733.034.007.017.016,0Z",
    transform: "translate(-549.324 16.091)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7431",
    "data-name": "Caminho 7431",
    d: "M594.47,22.721c.064.2.064.466-.153.441s-.177-.228-.192-.3c-.032-.137-.165-.262-.025-.4s.305.067.371.261",
    transform: "translate(-549.469 16.014)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7432",
    "data-name": "Caminho 7432",
    d: "M594.479,22.729l-.017.007a.834.834,0,0,1,.032.221.3.3,0,0,1-.027.141.126.126,0,0,1-.108.057.074.074,0,0,1-.029-.005.236.236,0,0,1-.115-.046.208.208,0,0,1-.053-.117.609.609,0,0,0-.012-.125c-.021-.1-.087-.183-.087-.257a.157.157,0,0,1,.055-.115.1.1,0,0,1,.084-.046.21.21,0,0,1,.145.093.583.583,0,0,1,.116.2l.017-.007h.016a.547.547,0,0,0-.12-.216.24.24,0,0,0-.173-.106.137.137,0,0,0-.108.053.175.175,0,0,0-.069.144c0,.089.074.177.089.269.008.027,0,.1.021.17a.232.232,0,0,0,.06.087.224.224,0,0,0,.132.057h.032a.144.144,0,0,0,.136-.069.328.328,0,0,0,.038-.161.739.739,0,0,0-.038-.228Z",
    transform: "translate(-549.478 16.005)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7433",
    "data-name": "Caminho 7433",
    d: "M594.415,22.569a.056.056,0,0,0,.036.065.9.9,0,0,0,.161.057l-.3.01-.027-.117Z",
    transform: "translate(-549.291 16.121)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7434",
    "data-name": "Caminho 7434",
    d: "M594.462,22.683v.033a.205.205,0,0,1-.024.087c-.029.072-.044.158-.156.137a.2.2,0,0,1-.165-.168.185.185,0,0,0-.033-.108v.1l.067.163.106.053h.1l.076-.033.032-.093.015-.079Z",
    transform: "translate(-549.435 16.189)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7435",
    "data-name": "Caminho 7435",
    d: "M593.868,22.665a.191.191,0,0,0,.185.141c.156,0,.192-.045.192-.045l.015.06-.051.024-.136.014-.118-.021L593.9,22.8l-.038-.072Z",
    transform: "translate(-549.594 16.189)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7436",
    "data-name": "Caminho 7436",
    d: "M592.884,20c.084,0,.152.1.152.23s-.068.231-.152.231-.153-.1-.153-.231.072-.23.153-.23",
    transform: "translate(-550.402 14.288)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7437",
    "data-name": "Caminho 7437",
    d: "M593.044,20.242h-.015a.257.257,0,0,1-.05.153.1.1,0,0,1-.087.06.105.105,0,0,1-.087-.06.282.282,0,0,1,0-.305.1.1,0,0,1,.174,0,.257.257,0,0,1,.05.153h.032a.282.282,0,0,0-.048-.17.13.13,0,0,0-.242,0,.276.276,0,0,0-.051.17.285.285,0,0,0,.051.171.136.136,0,0,0,.242,0,.291.291,0,0,0,.048-.171Z",
    transform: "translate(-550.41 14.279)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7438",
    "data-name": "Caminho 7438",
    d: "M592.9,20.444l.015.744-.2-.173.017-.595Z",
    transform: "translate(-550.412 14.586)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7439",
    "data-name": "Caminho 7439",
    d: "M592.905,20.454h-.023l.018.7-.153-.132.014-.566.139.021.005-.021h0V20.43l-.188-.024-.009.629.237.214-.019-.814-.021-.005Z",
    transform: "translate(-550.418 14.576)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7440",
    "data-name": "Caminho 7440",
    d: "M593.271,20.362c.039.177-.216.276-.387.24s-.3-.12-.281-.279.242-.12.319-.077.292-.117.349.117",
    transform: "translate(-550.495 14.434)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7441",
    "data-name": "Caminho 7441",
    d: "M593.277,20.372l-.019.012c.007.005.007.024.007.024a.173.173,0,0,1-.1.141.422.422,0,0,1-.208.051.175.175,0,0,1-.06-.007.38.38,0,0,1-.19-.072.183.183,0,0,1-.079-.149.079.079,0,0,1,.006-.036.094.094,0,0,1,.05-.077.162.162,0,0,1,.092-.019.387.387,0,0,1,.145.027.046.046,0,0,0,.04.015c.051,0,.111-.024.164-.024a.124.124,0,0,1,.084.024.209.209,0,0,1,.05.1l.019-.012h.017a.173.173,0,0,0-.064-.117.149.149,0,0,0-.1-.033c-.056,0-.125.021-.164.021l-.024,0a.415.415,0,0,0-.16-.045.276.276,0,0,0-.116.033.144.144,0,0,0-.062.1c0,.01-.007.026-.007.041a.208.208,0,0,0,.093.177.554.554,0,0,0,.2.087c.031,0,.052.005.072.005a.464.464,0,0,0,.231-.06.191.191,0,0,0,.114-.17.22.22,0,0,1-.008-.039Z",
    transform: "translate(-550.502 14.425)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7442",
    "data-name": "Caminho 7442",
    d: "M593.249,20.287a.143.143,0,0,1-.006.069.3.3,0,0,1-.281.168.324.324,0,0,1-.295-.111.331.331,0,0,1-.056-.137l-.005.081.072.115.169.077.165,0,.168-.051.076-.079.012-.089Z",
    transform: "translate(-550.492 14.482)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7443",
    "data-name": "Caminho 7443",
    d: "M592.886,20.547a.2.2,0,0,0-.1.038.246.246,0,0,0-.053.057l-.006-.207.159.007Z",
    transform: "translate(-550.405 14.596)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7444",
    "data-name": "Caminho 7444",
    d: "M592.417,20.865c0,.069-.116.123-.257.123s-.261-.055-.261-.123.121-.117.261-.117.257.053.257.117",
    transform: "translate(-550.995 14.82)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7445",
    "data-name": "Caminho 7445",
    d: "M592.428,20.875h-.016a.051.051,0,0,1-.017.036.333.333,0,0,1-.225.065.474.474,0,0,1-.18-.033.186.186,0,0,1-.048-.033.05.05,0,0,1-.017-.036.143.143,0,0,1,.017-.039.382.382,0,0,1,.228-.06.43.43,0,0,1,.173.036c.024.01.04.024.052.024a.15.15,0,0,1,.017.039h.037a.1.1,0,0,0-.028-.057.362.362,0,0,0-.25-.084.482.482,0,0,0-.192.041.139.139,0,0,0-.062.043.086.086,0,0,0-.031.057.071.071,0,0,0,.031.057.325.325,0,0,0,.253.084.492.492,0,0,0,.192-.039.134.134,0,0,0,.059-.045.08.08,0,0,0,.028-.057Z",
    transform: "translate(-551.005 14.81)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7446",
    "data-name": "Caminho 7446",
    d: "M592.326,20.835l.591-.041.249.19-.847-.026Z",
    transform: "translate(-550.697 14.853)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7447",
    "data-name": "Caminho 7447",
    d: "M592.333,20.843v.021l.586-.039.192.147-.761-.024,0-.1-.02,0v0h-.016l-.008.144.928.036-.305-.24-.614.041v.019Z",
    transform: "translate(-550.703 14.845)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7448",
    "data-name": "Caminho 7448",
    d: "M592.28,20.633a.305.305,0,0,1,.246.365c-.021.189-.169.341-.311.31a.14.14,0,0,1-.128-.182c0-.036.077-.1.089-.165s-.042-.189-.021-.252.053-.077.125-.077",
    transform: "translate(-550.865 14.738)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7449",
    "data-name": "Caminho 7449",
    d: "M592.289,20.639v.017a.265.265,0,0,1,.164.091.351.351,0,0,1,.065.209V21a.322.322,0,0,1-.269.3h-.026a.106.106,0,0,1-.093-.06.132.132,0,0,1-.022-.075v-.029a.138.138,0,0,0,.012-.031.289.289,0,0,0,.046-.057.381.381,0,0,0,.042-.077v-.019c0-.057-.036-.146-.036-.2a.059.059,0,0,1,0-.033.075.075,0,0,1,.034-.051.157.157,0,0,1,.069-.015h.009v-.033h-.009a.166.166,0,0,0-.091.015.125.125,0,0,0-.046.075v.041c0,.057.024.153.024.2l0,.012a.164.164,0,0,1-.043.084.112.112,0,0,0-.026.043c-.011.014-.023.021-.023.041v.033a.192.192,0,0,0,.023.1.165.165,0,0,0,.129.075l.017,0a.353.353,0,0,0,.312-.331l0-.051a.377.377,0,0,0-.074-.23.243.243,0,0,0-.191-.1Z",
    transform: "translate(-550.874 14.731)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7450",
    "data-name": "Caminho 7450",
    d: "M592.414,20.82s-.008.009.081.051a3.273,3.273,0,0,0,.5.086l-.658-.017.027-.115Z",
    transform: "translate(-550.686 14.871)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7451",
    "data-name": "Caminho 7451",
    d: "M592.515,20.825a.267.267,0,0,1-.033.1c-.03.065-.115.242-.255.216s-.119-.12-.119-.132v-.051l-.027.1.032.067.052.036.117.012.073-.036.091-.075.042-.087.033-.089Z",
    transform: "translate(-550.866 14.875)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7452",
    "data-name": "Caminho 7452",
    d: "M592.282,20.841s0,.033-.113.036a.989.989,0,0,1-.261-.045l.048.062.1.027h.113l.086-.005Z",
    transform: "translate(-550.989 14.88)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7453",
    "data-name": "Caminho 7453",
    d: "M592.044,18.093c-.063.1-.192.185-.254.144s-.044-.183.024-.29.166-.156.233-.118.06.163,0,.264",
    transform: "translate(-551.102 12.726)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7454",
    "data-name": "Caminho 7454",
    d: "M592.053,18.1l-.018-.012a.3.3,0,0,1-.1.108.176.176,0,0,1-.1.045.061.061,0,0,1-.026-.012.1.1,0,0,1-.034-.084.4.4,0,0,1,.06-.182.237.237,0,0,1,.171-.12.067.067,0,0,1,.04.015.109.109,0,0,1,.035.084.286.286,0,0,1-.048.146l.018.012.012.009a.273.273,0,0,0,.057-.166.135.135,0,0,0-.057-.12.109.109,0,0,0-.057-.019.285.285,0,0,0-.2.139.506.506,0,0,0-.065.2.12.12,0,0,0,.048.115.081.081,0,0,0,.049.012.226.226,0,0,0,.127-.048.336.336,0,0,0,.1-.115Z",
    transform: "translate(-551.11 12.718)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7455",
    "data-name": "Caminho 7455",
    d: "M591.583,19l.321-.775-.048-.043-.371.549Z",
    transform: "translate(-551.292 12.991)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7456",
    "data-name": "Caminho 7456",
    d: "M591.592,19.016l.016.012.334-.79-.077-.065-.393.567.115.341.021-.053-.016-.012.016-.005-.087-.264.349-.514.024.017-.322.761.021.005.016-.005Z",
    transform: "translate(-551.301 12.98)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7457",
    "data-name": "Caminho 7457",
    d: "M591.771,18.389c-.165-.113-.2-.242-.149-.357s.169-.041.169-.041a1.514,1.514,0,0,0,.141.12c.06.033.159-.007.225.086a.145.145,0,0,1-.027.223.363.363,0,0,1-.358-.031",
    transform: "translate(-551.211 12.832)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7458",
    "data-name": "Caminho 7458",
    d: "M591.778,18.4l0-.015a.3.3,0,0,1-.156-.237.213.213,0,0,1,.019-.1c.024-.05.044-.053.077-.053a.274.274,0,0,1,.052,0l.013.012.007,0L591.8,18l-.012.012a.939.939,0,0,0,.144.125.3.3,0,0,0,.113.019.143.143,0,0,1,.105.057.206.206,0,0,1,.03.1.113.113,0,0,1-.051.1.428.428,0,0,1-.154.033.317.317,0,0,1-.192-.063l0,.015-.012.021a.341.341,0,0,0,.207.063.41.41,0,0,0,.169-.033.154.154,0,0,0,.076-.135.2.2,0,0,0-.04-.117.2.2,0,0,0-.128-.077c-.045-.007-.078,0-.1-.022a.4.4,0,0,1-.089-.062l-.044-.051a.206.206,0,0,0-.1-.027.11.11,0,0,0-.107.079.224.224,0,0,0-.024.11.351.351,0,0,0,.177.273Z",
    transform: "translate(-551.217 12.825)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7459",
    "data-name": "Caminho 7459",
    d: "M592.163,18.16a.1.1,0,0,1-.036.12.3.3,0,0,1-.284.021,1.7,1.7,0,0,1-.239-.213l.068.137.117.1.157.048.153-.029.07-.06.022-.055Z",
    transform: "translate(-551.207 12.92)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7460",
    "data-name": "Caminho 7460",
    d: "M591.672,18.29a.306.306,0,0,1,0,.089.985.985,0,0,1-.032.187l.145-.312-.056-.051Z",
    transform: "translate(-551.181 13.002)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7461",
    "data-name": "Caminho 7461",
    d: "M591.024,18.179c.12.06.18.173.14.242s-.167.079-.281.019-.181-.183-.144-.254.168-.079.285-.007",
    transform: "translate(-551.832 12.949)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7462",
    "data-name": "Caminho 7462",
    d: "M591.031,18.188l-.012.012a.243.243,0,0,1,.144.185.24.24,0,0,1-.006.036.108.108,0,0,1-.106.055.324.324,0,0,1-.156-.046.252.252,0,0,1-.141-.19.069.069,0,0,1,.012-.033.1.1,0,0,1,.1-.048.3.3,0,0,1,.152.041l.012-.012.007-.021a.343.343,0,0,0-.171-.051.149.149,0,0,0-.134.072.076.076,0,0,0-.012.051.273.273,0,0,0,.158.225.3.3,0,0,0,.171.045.163.163,0,0,0,.141-.067.192.192,0,0,0,.012-.057.3.3,0,0,0-.16-.218Z",
    transform: "translate(-551.838 12.94)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7463",
    "data-name": "Caminho 7463",
    d: "M591.132,18.354l.6.365-.019.285-.655-.569Z",
    transform: "translate(-551.595 13.11)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7464",
    "data-name": "Caminho 7464",
    d: "M591.144,18.363l-.016.021.593.353-.012.231-.61-.525.057-.069-.012-.012-.016.021.016-.021-.021-.015-.079.1.7.605.021-.345-.627-.374-.016.009Z",
    transform: "translate(-551.607 13.1)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7465",
    "data-name": "Caminho 7465",
    d: "M591.276,18.575c-.135.149-.264.173-.37.108s-.022-.18-.022-.18a.451.451,0,0,0,.128-.132c.04-.05.012-.154.117-.209a.143.143,0,0,1,.216.055.424.424,0,0,1-.068.358",
    transform: "translate(-551.745 12.954)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7466",
    "data-name": "Caminho 7466",
    d: "M591.286,18.581l-.021-.012a.318.318,0,0,1-.231.135.229.229,0,0,1-.113-.034.089.089,0,0,1-.045-.074.106.106,0,0,1,.018-.055l.01-.014v0l.005,0-.015-.012.01.015a.545.545,0,0,0,.137-.132.2.2,0,0,0,.032-.111.144.144,0,0,1,.073-.094.148.148,0,0,1,.081-.027.125.125,0,0,1,.111.065.567.567,0,0,1,.012.117.327.327,0,0,1-.084.228l.021.012.012.015a.389.389,0,0,0,.087-.255.308.308,0,0,0-.019-.125.139.139,0,0,0-.14-.089.223.223,0,0,0-.1.024.206.206,0,0,0-.093.118.266.266,0,0,1-.026.1.424.424,0,0,1-.079.084.314.314,0,0,0-.048.041h0a.169.169,0,0,0-.04.1.111.111,0,0,0,.067.108.273.273,0,0,0,.13.034.353.353,0,0,0,.264-.142Z",
    transform: "translate(-551.755 12.948)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7467",
    "data-name": "Caminho 7467",
    d: "M591.213,18.423s-.024-.024.021.069a3.732,3.732,0,0,0,.384.42l-.542-.458.062-.094Z",
    transform: "translate(-551.583 13.114)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7468",
    "data-name": "Caminho 7468",
    d: "M591.19,18.486a.3.3,0,0,1-.128.041c-.065.007-.17,0-.18-.077a.123.123,0,0,1,.022-.1l-.051.1.024.057.078.043.107.014.1-.05Z",
    transform: "translate(-551.744 13.104)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7469",
    "data-name": "Caminho 7469",
    d: "M591.056,18.343s.012.019-.093.007a.619.619,0,0,1-.225-.132l.076.132.176.069Z",
    transform: "translate(-551.825 13.013)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7470",
    "data-name": "Caminho 7470",
    d: "M596.789,23.837s.063-.185.5-.394a4.976,4.976,0,0,1,1.164-.465c.06.036-.036.269-.036.269l-.426.132-.337.2-.4.25Z",
    transform: "translate(-547.503 16.411)",
    fill: "#99a069"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7471",
    "data-name": "Caminho 7471",
    d: "M602.237,27.374a3.347,3.347,0,0,0-.972.185c-.037.005-.113.065-.185.029a.779.779,0,0,1-.245-.245l-.124-.1-.027.4-.812-.706-.087.466-.112.216-.808-.759.04.588a2.159,2.159,0,0,1-.218.024c-.012-.012-.577-.406-.577-.406l-.172.057.185.35-.732.055a1.006,1.006,0,0,0-.152.125,1.377,1.377,0,0,0-.159.177s-.021.036.006.051a.637.637,0,0,0,.29,0c.06-.027.1-.117.12-.075s.042.2.134.18.44-.276.681-.165c.271.129-.345.312-.285.5s.509.108.623.045.449-.483.595-.322c.192.225-.41.4-.293.622.1.218.437.165.593.075s.543-.674.626-.545c.146.216-.317.422-.2.593s.375-.01.539-.129.241-.4.475-.537.22-.075.284-.081.245-.183.245-.183l.551-.23.269.019.144.062.272.043.033-.235a1.557,1.557,0,0,0-.542-.142m-4.416.009.123-.213-.072-.1a2.168,2.168,0,0,1-.372-.286,1.017,1.017,0,0,0-.322-.264c-.081-.039-.357-.216-.357-.216l-.12-.454-.072-.137-.213.086-.274-.977-.056-.18-.117,0-.228.6-.252-.375-.065-.811-.158.183-.208.206L594.7,23.7s-.027-.015-.051.051a1.378,1.378,0,0,0-.021.422,3.163,3.163,0,0,1-.49-.365,2.16,2.16,0,0,1-.456-.478l-.173-.386.165-.339.084-.411-.362.142-.063-.915-.053-.3-.425.61a2.431,2.431,0,0,1-.165-.259c0-.024,0-.581,0-.581l-.113-.039-.176.333a2.575,2.575,0,0,0-.245-.41,2.118,2.118,0,0,0-.045-.722,1.647,1.647,0,0,1-.176-.765c.041-.267.153-.291.14-.411s-.192.075-.128-.081.614-.511.5-.7-.659.3-.53-.027.641-.326.674-.778c.012-.273-.489.173-.535.039s.311-.425.311-.607.066-.207-.036-.3-.413.377-.413.377l-.331-.125-.119.487-.106.411-.42-.249.117.5.1.482-.437-.108.228.41.3.305.188.252.129.074.183.175.057.269s.11.29.11.305.016.286.016.286l0,.187-.008.149-.008.06-.008.06-.007.18c-.077.005-.212-.129-.262-.046s.254.327.2.377-.5-.084-.529.06a.362.362,0,0,0,.3.4c.254.062.847.2.75.317s-.746-.36-.718-.012a.612.612,0,0,0,.415.554c.165.065.814-.015.782.141s-.53-.055-.581.173.344.254.433.254a.918.918,0,0,1,.458.07c.1.082.465.463.694.663.2.165.617.453.741.538h-.007c-.12-.012-.377-.038-.422.055-.048.118.979.487.688.6s-.615-.317-.707-.048.2.478.356.579,1.083.015.9.225-.84-.141-.852.1.442.636.674.622.483-.375.586-.178-.18.278.044.333.377-.223.634-.175a2.171,2.171,0,0,1,.879.417c.229.209.458.446.458.446",
    transform: "translate(-551.838 11.721)",
    fill: "#99a069"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7472",
    "data-name": "Caminho 7472",
    d: "M601.515,28.422c.158,0,.173.086.2.086a4.8,4.8,0,0,1,.533-.367,2.632,2.632,0,0,1,.627-.216l.029.029a2.582,2.582,0,0,0-.672.269c-.275.192-.487.309-.5.343a.324.324,0,0,1-.264.1c-.151.005-.216-.091-.216-.135s.11-.113.268-.113m1.365-.689a.347.347,0,0,1-.212-.057.667.667,0,0,0-.408-.129,1.006,1.006,0,0,0-.635.288.741.741,0,0,1-.236.211c.06.015.18-.062.312-.175a1.148,1.148,0,0,1,.593-.213.441.441,0,0,1,.346.125.481.481,0,0,0,.235.033Zm-8.115-3.317c.026-.007.017-.046,0-.106-.02-.01-.122-.057-.349-.185-.266-.165-.816-.6-.816-.6s.226.221.455.427a6.06,6.06,0,0,0,.643.465c.036,0,.06.009.063,0m5.728,4.054a3.005,3.005,0,0,0,.236-.351,1.314,1.314,0,0,1,.3-.334c.024-.036-.053-.149-.1-.242a.42.42,0,0,1-.038-.192.813.813,0,0,0,.161.221,1.273,1.273,0,0,1,.182.149s.212-.029.216-.072,0-.072-.042-.082-.079.029-.174-.015c-.209-.087-.283-.4-.41-.41s-.037.334-.093.338c-.192.012-.333-.691-.792-.727-.317-.022-.377.041-.393.113s.386.5.25.557-.562-.67-.879-.677-.337.111-.308.183.339.125.264.355-.389-.339-.674-.307-.317.05-.338.13.105.2.065.231a1.275,1.275,0,0,0-.375.122,2.476,2.476,0,0,0-.348.375.756.756,0,0,1,.446-.3,8.169,8.169,0,0,1,.893.007,1.466,1.466,0,0,1-.183-.139,1.1,1.1,0,0,1-.173-.261s.143.135.278.249a2.387,2.387,0,0,0,.3.2,1.059,1.059,0,0,1,.289.057c.018.033,0,.093-.119.216a3.616,3.616,0,0,1-.27.266s.27-.209.317-.254.242-.189.242-.189.2.029.216.024.013-.072-.119-.271-.254-.41-.254-.41a2.907,2.907,0,0,1,.329.372c.161.218.134.317.206.329a1.063,1.063,0,0,0,.221.021c.071,0,.059.093-.06.269a2.006,2.006,0,0,0-.182.4,2.279,2.279,0,0,1,.24-.321c.125-.129.192-.285.238-.293s.223.015.24.005-.036-.081-.125-.262a1.391,1.391,0,0,1-.115-.425,1.507,1.507,0,0,0,.223.4c.134.171.182.309.214.312s.132-.012.209-.012c.04,0,.042-.01.048.012.014.077-.021.122-.109.293a2.848,2.848,0,0,0-.153.341m-3.463-2.006a1.038,1.038,0,0,0,.275.067.877.877,0,0,1-.339-.384c-.072-.225-.007-.7-.126-.694s-.176.353-.289.281.038-.7-.088-.972-.421-.463-.488-.362-.053.684-.231.559.014-.634-.041-.855-.19-.393-.3-.338.041.483-.123.487-.141-.3-.208-.326-.1.06-.138.005-.017-.274-.1-.259-.074.189-.053.283a1.828,1.828,0,0,0,.112.285c.041.058.171.132.157.189s-.077.091-.163.093-.29-.005-.29-.005a2.161,2.161,0,0,0,.29.075c.08.012.238-.034.277.041s.231.326.231.326a1.954,1.954,0,0,0,.063-.367,3.071,3.071,0,0,0,.011-.437,2.476,2.476,0,0,1,.065.43c-.013.161-.077.473-.077.473s.181.149.13.189a1.2,1.2,0,0,1-.456.038,3.521,3.521,0,0,1-.525-.081,2.648,2.648,0,0,0,.468.165c.19.031.616.043.616.043l.288.329a1.35,1.35,0,0,0,.154-.48,3.226,3.226,0,0,0-.009-.5,2.554,2.554,0,0,1,.072.456,1.824,1.824,0,0,1-.093.61.954.954,0,0,1-.3.153c-.188.048-.567.1-.567.1a1.956,1.956,0,0,0,.6-.014c.247-.06.278-.127.35-.084a.5.5,0,0,1,.129.117s.158.113.225.153c.007.021-.113.074-.18.113a2.574,2.574,0,0,1-.237.12s.255-.093.356-.12c.059-.017.192-.069.192-.069l.07.041a1.3,1.3,0,0,0-.012-.2c-.026-.156-.053-.293-.053-.293a.82.82,0,0,1,.108.261,1.407,1.407,0,0,1,.027.257s.023.043.214.1m-4.993-5.727a3.244,3.244,0,0,0,.055-.574,2.231,2.231,0,0,0-.252-.847c-.033-.05-.055-.086-.055-.086l.147-.225-.191.146a.931.931,0,0,1-.189-.077.4.4,0,0,1-.14-.141,1.485,1.485,0,0,0,.192.113c.091.033.113.021.113.021l-.072-.31s-.092-.039-.306-.156a2.563,2.563,0,0,1-.4-.309,3.7,3.7,0,0,0,.444.237.916.916,0,0,0,.257.079,1.267,1.267,0,0,0,.261-.1c.088-.051.267-.187.267-.187a1.43,1.43,0,0,1-.283.127c-.111.024-.259.041-.259.041l-.051-.382s-.029,0-.171-.187a2.281,2.281,0,0,1-.254-.451,1.812,1.812,0,0,0,.264.274,1.847,1.847,0,0,1,.227.228,2.677,2.677,0,0,0,.261-.156c.128-.089.453-.322.453-.322s-.186.1-.444.214-.261.108-.261.108a.463.463,0,0,1,.023-.233c.032-.077.113-.194.1-.266s-.07-.048-.089-.1a2.081,2.081,0,0,1,.061-.422,1.25,1.25,0,0,1,.029.2c.005.065-.034.158.062.158a2.441,2.441,0,0,0,.573-.507c.053-.084.135-.3-.088-.216s-.177.285-.363.262c-.05,0-.12-.242-.184-.178a.722.722,0,0,0-.262.374c-.033.17.039.425-.062.506s-.175-.29-.364-.24-.228.305-.2.41.44.569.308.636-.447-.408-.617-.091.54.634.629.71.007.1.13.254.29.2.379.3a2.076,2.076,0,0,1,.346.934,3.05,3.05,0,0,1-.021.442m1.884,2.745a.652.652,0,0,1-.115-.53c.057-.336.284-.922.209-1s-.324.362-.39.261.141-.689.042-.934-.117-.394-.326-.374-.3.71-.4.59.054-.425-.011-.6-.1-.221-.209-.194-.149.341-.221.338-.2-.382-.345-.326.362.722.362.722a.672.672,0,0,0,.136-.2c.049-.113.1-.238.1-.238a.771.771,0,0,1,0,.305,2.161,2.161,0,0,0-.065.278.7.7,0,0,1-.325.009,1.274,1.274,0,0,1-.377-.117,1.033,1.033,0,0,0,.349.151c.213.057.434.125.434.125s.057.069.15.194.174.225.174.225a2.566,2.566,0,0,0,.122-.333,5.645,5.645,0,0,1,.2-.552,6,6,0,0,1-.093.622c-.051.2-.1.49-.1.49a3.911,3.911,0,0,1-.429-.067c-.245-.041-.577-.129-.577-.129s.288.115.577.2.458.12.458.12l.226.3a2.5,2.5,0,0,1,.144-.23,1.29,1.29,0,0,0,.159-.3,2.01,2.01,0,0,1-.108.365c-.065.141-.113.225-.113.225a1.317,1.317,0,0,1-.279.029c-.134,0-.4-.005-.4-.005s.229.072.4.1.313.051.313.051a.7.7,0,0,0,.108.218.724.724,0,0,0,.217.2",
    transform: "translate(-551.965 11.713)",
    fill: "#707837"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7473",
    "data-name": "Caminho 7473",
    d: "M597.715,24.99a1.026,1.026,0,0,0-.24-.18c-.134-.074-.186-.05-.186-.05l-.06-.024.12-.309.892-.854.141-.852.027-.009.521,0-.006,1.173.165.072,1,.6,0,.257s-.052.024-.147.057a.264.264,0,0,0-.113.07l-.377.029-.655-.473-.28-.281-.494.626Z",
    transform: "translate(-547.188 16.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7474",
    "data-name": "Caminho 7474",
    d: "M598.594,22.712s-.009.045-.021.182a7.22,7.22,0,0,1-.022.917c-.032.094-.511.29-.792.528a.768.768,0,0,0-.285.42.848.848,0,0,0-.257.075.56.56,0,0,0-.246.153,1.777,1.777,0,0,1,.542-.821,6.609,6.609,0,0,1,.71-.5,6.633,6.633,0,0,0,.017-.879c0-.063.06-.067.1-.067a1.951,1.951,0,0,1,.253-.009",
    transform: "translate(-547.372 16.223)",
    fill: "#2c694a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7475",
    "data-name": "Caminho 7475",
    d: "M599.035,24.586a.846.846,0,0,1,.111-.18,1.254,1.254,0,0,1,.158-.125s.012-.021-.23-.125-.374-.07-.542-.192a2.439,2.439,0,0,1-.352-.336l-.226.211a2.577,2.577,0,0,0,.265.322c.133.125.434.171.563.245a1.543,1.543,0,0,1,.252.18",
    transform: "translate(-546.67 16.877)",
    fill: "#2c694a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7476",
    "data-name": "Caminho 7476",
    d: "M598.667,22.711s.261-.015.3.031a.1.1,0,0,1,.034.089,5.284,5.284,0,0,1-.034.843,1.3,1.3,0,0,1-.218.5c-.063.063-.458.408-.649.59a5.028,5.028,0,0,0-.379.446s-.07-.074-.128-.146-.115-.1-.1-.149a1.586,1.586,0,0,1,.529-.557,1.263,1.263,0,0,0,.638-.782,4.107,4.107,0,0,0,.012-.864",
    transform: "translate(-547.006 16.22)",
    fill: "#bb1033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7477",
    "data-name": "Caminho 7477",
    d: "M599.925,24.477a.485.485,0,0,0-.281-.065c-.23,0-.248.026-.248.026a1.356,1.356,0,0,0-.317-.278c-.2-.132-.35-.111-.56-.252a1.12,1.12,0,0,1-.327-.343l.165-.333a2.181,2.181,0,0,0,.372.394c.19.144.612.276.744.389s.453.461.453.461",
    transform: "translate(-546.501 16.594)",
    fill: "#bb1033"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7478",
    "data-name": "Caminho 7478",
    d: "M604.645,22.864s-.57-.221-.529-.422,1.324-.538,1.324-.538l.02-.345a1.6,1.6,0,0,0-.512.1,4.427,4.427,0,0,1-1.378.247,2.208,2.208,0,0,1-.618-.067c-.051-.017-4.521-.278-4.671-.278-.057,0-.141,0-.239-.009-.6-.039-.979-.951-.979-.951l-.278.046s.084.453-.066.485a10.193,10.193,0,0,1-2.226-.951l-.111.413s1.185.641,1.155.874-.39.225-.39.225l.146.274c.055.007,1.955.1,1.987.669.012.23-.469.367-.469.367l.164.2v.1a4.724,4.724,0,0,1,1.344.173c.3.154.442.394.8.6a10.782,10.782,0,0,0,3.169.048c.427-.12.688-.609,1.387-.821a4.317,4.317,0,0,1,.925-.214Z",
    transform: "translate(-549.223 14.414)",
    fill: "#60c0d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7479",
    "data-name": "Caminho 7479",
    d: "M604.666,22.892l.012-.045-.015,0a2.195,2.195,0,0,1-.29-.146.588.588,0,0,1-.141-.111.153.153,0,0,1-.057-.1v-.012l.017-.017a.4.4,0,0,1,.093-.072A4.372,4.372,0,0,1,605,22.11c.132-.045.247-.077.333-.1l.139-.036.026-.009.028-.41h-.061a1.57,1.57,0,0,0-.505.1,4.6,4.6,0,0,1-1.37.238,2.227,2.227,0,0,1-.605-.062l-.012,0c-.024,0-.108-.005-.249-.015-.475-.029-1.541-.1-2.506-.154-.483-.024-.943-.055-1.288-.072l-.425-.024-.2-.007H598.3v0h-.025c-.055,0-.127-.009-.209-.009a.721.721,0,0,1-.381-.159,1.748,1.748,0,0,1-.41-.487c-.047-.077-.087-.147-.114-.2a.362.362,0,0,1-.026-.06l-.012-.021-.012-.033-.356.06.005.046.007.015a1.733,1.733,0,0,1,.024.231.442.442,0,0,1-.019.137c-.012.015-.012.033-.02.041a.041.041,0,0,1-.024.01l-.017.005a.743.743,0,0,1-.2-.041,10.656,10.656,0,0,1-1.215-.525l-.547-.278c-.135-.069-.223-.117-.223-.117l-.044-.027-.129.506.024.019.057.022c.112.063.384.219.625.384a2.465,2.465,0,0,1,.324.242.529.529,0,0,1,.1.1.138.138,0,0,1,.031.067v0a.16.16,0,0,1-.045.094.261.261,0,0,1-.154.072.516.516,0,0,1-.13.019h-.016l-.072-.009.194.375h.023a.788.788,0,0,1,.1.007,6.712,6.712,0,0,1,1.079.153,2.049,2.049,0,0,1,.542.192.59.59,0,0,1,.17.125.249.249,0,0,1,.057.147v.009a.161.161,0,0,1-.057.12.914.914,0,0,1-.236.146.474.474,0,0,1-.1.033.051.051,0,0,1-.036.012l0,.01-.07.017.192.23v.123H597s.061,0,.165,0c.159,0,.4.017.622.041.111.015.224.031.317.048a.765.765,0,0,1,.225.075,1.92,1.92,0,0,1,.365.281,2.593,2.593,0,0,0,.432.322.677.677,0,0,0,.237.067,8.64,8.64,0,0,0,1.349.081c.355,0,.707-.009.993-.027l.381-.029a1.5,1.5,0,0,0,.233-.039,1.883,1.883,0,0,0,.614-.381,2.313,2.313,0,0,1,.778-.439c.35-.1.58-.159.724-.187a.707.707,0,0,1,.152-.026l.027,0h.041l.067-.285-.04-.017-.012.045-.036-.009-.048.209.039.015-.007-.046a4.617,4.617,0,0,0-.931.228,2.376,2.376,0,0,0-.808.442,1.742,1.742,0,0,1-.579.369,1.105,1.105,0,0,1-.223.039c-.313.033-.844.053-1.367.053-.344,0-.694-.009-.973-.029-.143-.015-.263-.024-.364-.043a.87.87,0,0,1-.21-.062,2.682,2.682,0,0,1-.415-.315,2.111,2.111,0,0,0-.38-.29,1.245,1.245,0,0,0-.35-.1A7.523,7.523,0,0,0,597,23.281v.039h.04v-.111L596.874,23l-.042.026.012.043a1.7,1.7,0,0,0,.245-.1.517.517,0,0,0,.168-.122.226.226,0,0,0,.084-.177v-.015a.321.321,0,0,0-.1-.213,1.106,1.106,0,0,0-.473-.254,5.629,5.629,0,0,0-.928-.189c-.141-.021-.269-.031-.358-.036s-.155-.009-.155-.009l-.011.038.04-.017-.146-.285-.04.021v.045h.016a.653.653,0,0,0,.212-.033.435.435,0,0,0,.125-.077.26.26,0,0,0,.072-.149l0-.015a.3.3,0,0,0-.06-.132,1.724,1.724,0,0,0-.274-.245,7.868,7.868,0,0,0-.842-.518l-.02.033.036.012.113-.418-.038-.007-.023.033s.451.24.951.483c.25.122.511.242.742.338.11.045.212.077.3.108a.8.8,0,0,0,.225.041.142.142,0,0,0,.042-.005.115.115,0,0,0,.066-.048.317.317,0,0,0,.044-.1.413.413,0,0,0,.012-.122,1.3,1.3,0,0,0-.031-.259h-.038l.005.05.285-.055-.012-.041-.037.017a2.353,2.353,0,0,0,.273.466,1.786,1.786,0,0,0,.311.336.911.911,0,0,0,.432.18h.245v0c.024,0,.11.012.249.017.485.019,1.577.084,2.549.147.494.026.952.053,1.289.074.177.012.312.024.41.031a.579.579,0,0,1,.124.009.068.068,0,0,1,.029,0h.01v-.031l0,.031h0v-.031l0,.031a2.179,2.179,0,0,0,.626.062,4.551,4.551,0,0,0,1.394-.245,2.032,2.032,0,0,1,.481-.1h.012l0-.039h-.036l-.021.338.036.007-.012-.043s-.316.081-.649.2a3.288,3.288,0,0,0-.453.177,1.385,1.385,0,0,0-.164.087.344.344,0,0,0-.054.051.16.16,0,0,0-.032.057v.029a.183.183,0,0,0,.025.1.588.588,0,0,0,.132.141,2.439,2.439,0,0,0,.4.207l.016-.039-.036-.009Z",
    transform: "translate(-549.242 14.385)",
    fill: "#3771a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7480",
    "data-name": "Caminho 7480",
    d: "M595.179,21.352a.335.335,0,1,1-.333-.333.334.334,0,0,1,.333.333",
    transform: "translate(-549.132 15.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7481",
    "data-name": "Caminho 7481",
    d: "M595.21,21.387h-.081a.251.251,0,1,1-.5,0,.251.251,0,1,1,.5,0h.161a.412.412,0,1,0-.413.425.414.414,0,0,0,.413-.425Z",
    transform: "translate(-549.163 14.978)",
    fill: "#3771a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7482",
    "data-name": "Caminho 7482",
    d: "M596.3,20.437a.337.337,0,0,1-.336.346.333.333,0,0,1-.331-.346.33.33,0,0,1,.331-.333.334.334,0,0,1,.336.333",
    transform: "translate(-548.33 14.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7483",
    "data-name": "Caminho 7483",
    d: "M596.334,20.475h-.084a.257.257,0,0,1-.251.264.26.26,0,0,1-.25-.264.251.251,0,0,1,.25-.249.248.248,0,0,1,.251.249h.165a.416.416,0,1,0-.831,0,.416.416,0,1,0,.831,0Z",
    transform: "translate(-548.365 14.321)",
    fill: "#3771a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7484",
    "data-name": "Caminho 7484",
    d: "M601.008,21.91a.352.352,0,0,1-.345.348.349.349,0,0,1,0-.7.351.351,0,0,1,.345.35",
    transform: "translate(-544.982 15.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7485",
    "data-name": "Caminho 7485",
    d: "M601.042,21.945h-.089a.258.258,0,1,1-.517,0,.259.259,0,1,1,.517,0h.169a.426.426,0,1,0-.425.429.43.43,0,0,0,.425-.429Z",
    transform: "translate(-545.016 15.365)",
    fill: "#3771a3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7486",
    "data-name": "Caminho 7486",
    d: "M593.834,20.056c-.108.252.324.734.629.787s.466-.021.518-.17a.472.472,0,0,0-.051-.4c-.2-.259-.988-.471-1.1-.218",
    transform: "translate(-549.626 14.244)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7487",
    "data-name": "Caminho 7487",
    d: "M594.685,20.358c-.009-.149-.261-.3-.426-.3s-.32-.01-.293.084.441.2.453.242-.127.1-.061.168.158.014.225-.036.1-.06.1-.156",
    transform: "translate(-549.521 14.326)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7488",
    "data-name": "Caminho 7488",
    d: "M596.417,22.032c.065.225-.107.334-.333.437a.774.774,0,0,1-.787-.141c-.1-.18.171-.473.444-.537s.612.039.675.24",
    transform: "translate(-548.584 15.55)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7489",
    "data-name": "Caminho 7489",
    d: "M595.857,22.121c.089-.015.089.135.171.125s.146-.141.125-.225a.337.337,0,0,0-.3-.19c-.12.009-.5.322-.451.41s.125.069.2.039.164-.141.253-.159",
    transform: "translate(-548.493 15.593)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7490",
    "data-name": "Caminho 7490",
    d: "M600.794,21.537c.206.276.568.027.665-.077s.4-.285.281-.465a.506.506,0,0,0-.473-.153.887.887,0,0,0-.473.309.381.381,0,0,0,0,.386",
    transform: "translate(-544.68 14.886)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7491",
    "data-name": "Caminho 7491",
    d: "M600.81,21.272a.326.326,0,0,1,.293-.307c.152,0,.165.045.278.108s.165-.084.165-.084.012.207-.178.214-.127-.093-.312-.117c-.169-.022-.245.185-.245.185",
    transform: "translate(-544.631 14.975)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7492",
    "data-name": "Caminho 7492",
    d: "M598.682,20.848l-.132-.087s-.273-.012-.458-.005-.553.017-.553.017l.553,1.587.65.939.251.081.5-.024.091-.252-.187-1.526Z",
    transform: "translate(-546.968 14.824)",
    fill: "#eca757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7493",
    "data-name": "Caminho 7493",
    d: "M598.7,20.868l.021-.029-.133-.091-.019-.012s-.218-.009-.395-.009h-.063c-.185,0-.553.024-.553.024a.051.051,0,0,0-.033.017c0,.012-.012.027,0,.036l.547,1.586.007.01.655.941c0,.01.012.012.017.012l.252.094.016,0,.506-.036a.044.044,0,0,0,.038-.022l.091-.252,0-.019-.2-1.522a.054.054,0,0,0-.012-.031l-.715-.727-.007,0-.021.029-.033.031.7.72.192,1.5-.076.216-.473.031-.226-.087-.645-.922L597.6,20.78l-.044.012v.046s.1,0,.21-.012.247-.01.35-.01h.05c.1,0,.188,0,.267,0l.128.007.005-.046-.026.039.134.084.024-.036-.033.031Z",
    transform: "translate(-546.985 14.805)",
    fill: "#883129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7494",
    "data-name": "Caminho 7494",
    d: "M597.154,20.95l.029-.177s.123-.015.3-.021a1.109,1.109,0,0,1,.333.024,3.564,3.564,0,0,1,.507.747c.127.291.271.778.432,1.078s.515.78.515.78-.176.021-.329.021-.326,0-.326,0l-.292-.113-.921-1.431Z",
    transform: "translate(-547.243 14.822)",
    fill: "#eca757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7495",
    "data-name": "Caminho 7495",
    d: "M597.17,20.969l.045.009.027-.178-.043-.007.007.045.021-.005c.044-.007.14-.012.273-.019.02,0,.039,0,.06,0,.072,0,.132.009.182.012a.3.3,0,0,1,.052.005l.019,0,0,.005.006-.026-.011.021,0,.005.006-.026-.011.021.014-.024-.014.021v0l.014-.024-.014.021v0l.021.027a3.676,3.676,0,0,1,.47.7c.06.144.132.338.2.533a3.805,3.805,0,0,0,.236.547c.159.3.513.79.513.79l.032-.027,0-.033s-.044,0-.108.005-.141,0-.218,0c-.159,0-.326.009-.326.009v.039l.014-.036-.283-.11-.906-1.416-.24-.9-.045.005.045.009-.045-.009-.039.012.249.91V21.9l.922,1.43a.034.034,0,0,0,.024.021l.289.115.016,0s.042,0,.11,0,.141,0,.216,0c.153,0,.329-.012.329-.012a.037.037,0,0,0,.033-.024.038.038,0,0,0,0-.043,1,1,0,0,1-.06-.082c-.1-.147-.326-.485-.449-.71a3.327,3.327,0,0,1-.227-.537c-.072-.189-.144-.386-.2-.531a3.32,3.32,0,0,0-.293-.492c-.057-.07-.113-.137-.149-.19-.015-.019-.033-.036-.048-.051l-.019-.021,0-.007-.007-.005a.042.042,0,0,0-.026-.009.472.472,0,0,0-.1-.022c-.05,0-.1-.005-.17-.005a.309.309,0,0,0-.067.005,1.884,1.884,0,0,0-.3.022c-.024,0-.033.014-.04.033l-.024.18v.017Z",
    transform: "translate(-547.259 14.803)",
    fill: "#883129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7496",
    "data-name": "Caminho 7496",
    d: "M597.076,20.755a2.954,2.954,0,0,1,.413.015,2.276,2.276,0,0,1,.615.852,9.706,9.706,0,0,0,.3.994,3.049,3.049,0,0,0,.514.787,5.075,5.075,0,0,1-.984-.031c-.35-.062-.477-.05-.561-.153a1.163,1.163,0,0,0-.274-.214h-.356l.083-.494-.1-1.114.024-.567Z",
    transform: "translate(-547.548 14.825)",
    fill: "#eca757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7497",
    "data-name": "Caminho 7497",
    d: "M597.091,20.775v.045s.063,0,.133,0,.12,0,.165,0a.568.568,0,0,0,.07,0l.013,0,.012,0,.007-.017-.012.015.005,0,.007-.017-.012.015a.256.256,0,0,0,.029.024,2.248,2.248,0,0,1,.573.8,3.127,3.127,0,0,1,.132.482,1.96,1.96,0,0,0,.17.516,2.992,2.992,0,0,0,.522.8l.027-.029v-.039l-.113.007-.276,0a3.674,3.674,0,0,1-.583-.038c-.177-.031-.3-.045-.382-.069a.236.236,0,0,1-.1-.031c-.02-.005-.039-.027-.06-.041a.78.78,0,0,0-.176-.159c-.057-.039-.108-.069-.108-.069l-.021-.005h-.306l.077-.444v-.009l-.1-1.111.023-.535.293-.067-.011-.041v0l-.012-.041-.326.074c-.015,0-.032.021-.032.033l-.015.578v.007l.092,1.1-.084.487c0,.01,0,.027.012.034s.016.012.033.012h.356v-.036l-.024.029a.333.333,0,0,1,.032.024,1.109,1.109,0,0,1,.237.189.264.264,0,0,0,.087.069,2.473,2.473,0,0,0,.5.1,4.833,4.833,0,0,0,.6.038c.219,0,.389-.009.389-.009.021,0,.033-.012.036-.029a.036.036,0,0,0,0-.046l-.012-.009a3.443,3.443,0,0,1-.5-.766,1.952,1.952,0,0,1-.165-.5,2.883,2.883,0,0,0-.132-.5,2.386,2.386,0,0,0-.365-.6,1.89,1.89,0,0,0-.18-.185.786.786,0,0,0-.06-.057l-.021-.019-.012-.009c-.012-.007-.02-.007-.027-.015-.029,0-.064,0-.12-.005a1.114,1.114,0,0,0-.153-.007c-.07,0-.133.007-.133.007h-.012Z",
    transform: "translate(-547.563 14.805)",
    fill: "#883129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7498",
    "data-name": "Caminho 7498",
    d: "M599.833,21.051l-.594-.242-1.116-.06s.044.295.083.574a4.916,4.916,0,0,0,.42,1.238c.182.317.362.7.451.8.108.094.746-.175.746-.175l.417-.062-.055-.451-.06-.144.1-1.3-.1-.2Z",
    transform: "translate(-546.551 14.821)",
    fill: "#eca757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7499",
    "data-name": "Caminho 7499",
    d: "M599.852,21.069l.015-.033-.6-.252h-.009l-1.111-.06a.068.068,0,0,0-.04.015c0,.012-.012.021,0,.033s.039.3.084.574A4.94,4.94,0,0,0,598.6,22.6l.264.482c.041.077.077.149.109.2a.5.5,0,0,0,.093.122.07.07,0,0,0,.055.027.091.091,0,0,0,.048.009.679.679,0,0,0,.2-.036,3.3,3.3,0,0,0,.481-.158l-.017-.041v.041l.422-.057a.043.043,0,0,0,.031-.051l-.052-.458v-.007l-.057-.13.093-1.287v-.021l-.093-.2c-.01-.021-.022-.031-.042-.027l-.3.021.007.039.015-.033-.015.033,0,.045.267-.017.072.165-.1,1.286v.019l.057.13.051.408-.377.057-.006.005s-.033.014-.074.034c-.076.026-.184.06-.293.1a1.271,1.271,0,0,1-.285.06l-.034,0c-.009,0-.009-.007-.009-.007a.406.406,0,0,1-.081-.117c-.1-.156-.236-.437-.374-.674a4.936,4.936,0,0,1-.409-1.224c-.019-.137-.043-.281-.057-.394a1.625,1.625,0,0,1-.024-.18l-.045.007,0,.041,1.109.06.586.245h.024Z",
    transform: "translate(-546.569 14.803)",
    fill: "#883129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7500",
    "data-name": "Caminho 7500",
    d: "M597,21.122a.15.15,0,0,0,.185.144.239.239,0,0,0,.171-.252.345.345,0,0,0-.356-.353c-.228-.012-.407.281-.407.48s.2.3.2.375a.677.677,0,0,0-.192.5.96.96,0,0,0,.273.574s-.28.216-.28.441a.4.4,0,0,0,.41.37c.2,0,.456-.125.456-.3a.281.281,0,0,0-.281-.271c-.12,0-.175.075-.175.132",
    transform: "translate(-547.646 14.758)",
    fill: "#eca757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7501",
    "data-name": "Caminho 7501",
    d: "M596.97,21.139a.155.155,0,0,0,.028.093.137.137,0,0,0,.085.075.227.227,0,0,0,.094.021.051.051,0,0,0,.025-.005.3.3,0,0,0,.124-.063.286.286,0,0,0,.081-.228.358.358,0,0,0-.1-.266.4.4,0,0,0-.29-.129H597a.407.407,0,0,0-.314.185.606.606,0,0,0-.12.336.411.411,0,0,0,.109.262.668.668,0,0,0,.067.075.034.034,0,0,1,.014.026l.007.01h.044l-.033-.034a.712.712,0,0,0-.1.135.741.741,0,0,0-.1.381v.024a.816.816,0,0,0,.146.422,1.25,1.25,0,0,0,.132.177l.033-.027-.027-.039a1.212,1.212,0,0,0-.14.147.551.551,0,0,0-.15.333.363.363,0,0,0,.144.295.467.467,0,0,0,.305.115.514.514,0,0,0,.443-.2.244.244,0,0,0,.055-.142.313.313,0,0,0-.108-.228.322.322,0,0,0-.216-.087.228.228,0,0,0-.158.06.163.163,0,0,0-.051.117.039.039,0,0,0,.036.043.046.046,0,0,0,.044-.043.067.067,0,0,1,.028-.057.159.159,0,0,1,.1-.033.257.257,0,0,1,.159.06.225.225,0,0,1,.077.168.205.205,0,0,1-.032.1.43.43,0,0,1-.165.113.583.583,0,0,1-.212.043.416.416,0,0,1-.252-.087.319.319,0,0,1-.113-.238.485.485,0,0,1,.125-.279.982.982,0,0,1,.093-.1c.01-.017.022-.021.034-.033l0,0,.007,0c0-.009.008-.021.008-.027a.053.053,0,0,0-.008-.036v0a.867.867,0,0,1-.264-.535v-.021a.682.682,0,0,1,.092-.336.423.423,0,0,1,.061-.084c.007-.009.016-.017.016-.026l0,0a.042.042,0,0,0,.016-.031.068.068,0,0,0-.016-.05,1.223,1.223,0,0,0-.107-.141.288.288,0,0,1-.072-.185.488.488,0,0,1,.106-.285.311.311,0,0,1,.245-.151h.014a.338.338,0,0,1,.236.1.289.289,0,0,1,.079.209.223.223,0,0,1-.057.165.179.179,0,0,1-.079.045h-.014a.267.267,0,0,1-.082-.017.116.116,0,0,1-.033-.027c0-.015,0-.029,0-.057a.045.045,0,0,0-.046-.041.042.042,0,0,0-.042.041",
    transform: "translate(-547.664 14.741)",
    fill: "#883129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7502",
    "data-name": "Caminho 7502",
    d: "M599.388,21.121c0,.144-.089.147-.172.147s-.178-.043-.178-.216.229-.269.377-.269a.471.471,0,0,1,.391.442.614.614,0,0,1-.173.41s.112.048.112.357a.866.866,0,0,1-.2.53.444.444,0,0,1,.256.418.376.376,0,0,1-.373.42c-.149,0-.411-.091-.411-.312a.249.249,0,0,1,.239-.285.239.239,0,0,1,.207.24",
    transform: "translate(-545.912 14.845)",
    fill: "#eca757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7503",
    "data-name": "Caminho 7503",
    d: "M599.358,21.139a.2.2,0,0,1,0,.065.08.08,0,0,1-.04.031.2.2,0,0,1-.08.009.124.124,0,0,1-.087-.033.173.173,0,0,1-.048-.141.279.279,0,0,1,.024-.1.352.352,0,0,1,.141-.1.6.6,0,0,1,.167-.033.313.313,0,0,1,.1.027.5.5,0,0,1,.168.147.4.4,0,0,1,.081.226.579.579,0,0,1-.081.276c-.021.029-.044.057-.06.077s-.009.019-.016.019l0,.005v0c-.01,0-.015.021-.015.029a.047.047,0,0,0,.027.036v0c.014.012.081.079.081.321a.764.764,0,0,1-.093.362.708.708,0,0,1-.067.1c0,.012-.012.024-.021.026l-.005.009v0a.057.057,0,0,0-.012.036.133.133,0,0,0,.026.031.3.3,0,0,1,.12.089.44.44,0,0,1,0,.586.321.321,0,0,1-.217.077.492.492,0,0,1-.246-.069.255.255,0,0,1-.091-.074.205.205,0,0,1-.032-.123.248.248,0,0,1,.068-.194.171.171,0,0,1,.125-.048.18.18,0,0,1,.119.053.235.235,0,0,1,.046.144.045.045,0,0,0,.043.036.043.043,0,0,0,.044-.036.3.3,0,0,0-.077-.2.216.216,0,0,0-.175-.089.257.257,0,0,0-.185.075.356.356,0,0,0-.093.254.27.27,0,0,0,.048.168.43.43,0,0,0,.192.144.7.7,0,0,0,.213.041.43.43,0,0,0,.269-.1.45.45,0,0,0,.14-.362.523.523,0,0,0-.135-.362.492.492,0,0,0-.14-.1l-.018.039.026.027a.848.848,0,0,0,.212-.557.764.764,0,0,0-.06-.321.147.147,0,0,0-.078-.074l-.015.038.027.027a.608.608,0,0,0,.1-.123.551.551,0,0,0,.1-.314.514.514,0,0,0-.153-.346.737.737,0,0,0-.141-.1.4.4,0,0,0-.144-.041.521.521,0,0,0-.264.077.278.278,0,0,0-.106.093.253.253,0,0,0-.052.144.272.272,0,0,0,.077.206.234.234,0,0,0,.147.051.319.319,0,0,0,.137-.021c.021-.021.044-.036.053-.063a.188.188,0,0,0,.022-.1.046.046,0,0,0-.043-.041.048.048,0,0,0-.044.041",
    transform: "translate(-545.929 14.826)",
    fill: "#883129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7504",
    "data-name": "Caminho 7504",
    d: "M597.049,21.975a.189.189,0,0,1,.065.084.756.756,0,0,0,.119.225,5.313,5.313,0,0,0,1.481.158,6.225,6.225,0,0,0,1.433-.062c.173-.108.2-.285.305-.363s.136-.07.136-.07l-.129.113-.012.225.081.122s-.018.067-.132.123a.647.647,0,0,1-.357.113c-.151.015-2.127.012-2.443-.045s-.295-.045-.39-.113a.766.766,0,0,1-.145-.141l.039-.147Z",
    transform: "translate(-547.318 15.676)",
    fill: "#883129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7505",
    "data-name": "Caminho 7505",
    d: "M599.442,20.855l.18.075s-.147.048-.269.358-.012.41-.1.446a8.937,8.937,0,0,1-.928.007l-.147-.357Z",
    transform: "translate(-546.509 14.896)",
    fill: "#883129"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7506",
    "data-name": "Caminho 7506",
    d: "M600.637,20.985a.443.443,0,0,1-.212-.173c-.065-.123-.125-.276-.069-.305s.156.069.148.165.134.314.134.314",
    transform: "translate(-544.972 14.643)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7507",
    "data-name": "Caminho 7507",
    d: "M601.544,20.513a.908.908,0,0,0,.141.209,2.082,2.082,0,0,0,.2.1s-.237,0-.306-.063a1.107,1.107,0,0,1-.18-.233Z",
    transform: "translate(-544.207 14.652)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7508",
    "data-name": "Caminho 7508",
    d: "M601.964,20.671a.344.344,0,0,1-.264.036c-.113-.045-.213-.12-.17-.168s.084-.029.141.033a.668.668,0,0,0,.293.1",
    transform: "translate(-544.124 14.65)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7509",
    "data-name": "Caminho 7509",
    d: "M602.46,20.192a.4.4,0,0,1-.2.1c-.083,0-.252-.031-.252-.063s.225-.065.257-.057l.192.021",
    transform: "translate(-543.773 14.407)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7510",
    "data-name": "Caminho 7510",
    d: "M601.647,19.2a.519.519,0,0,0-.245.156c-.064.089-.048.2.033.194s.1-.108.1-.141a1.211,1.211,0,0,1,.113-.209",
    transform: "translate(-544.236 13.713)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7511",
    "data-name": "Caminho 7511",
    d: "M601.133,19.469a.646.646,0,0,0-.184.165c-.029.084-.062.252.024.257s.106-.129.112-.2a1.86,1.86,0,0,1,.048-.225",
    transform: "translate(-544.554 13.906)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7512",
    "data-name": "Caminho 7512",
    d: "M600.358,20.564l-.461.49a4.485,4.485,0,0,0,1.877.566,3.127,3.127,0,0,0,1.8-.79,1.667,1.667,0,0,0-.089-.879,1.757,1.757,0,0,0-.888-.6,2.344,2.344,0,0,0-.937.65c-.343.338-.313.626-.8.6s-.505-.031-.505-.031",
    transform: "translate(-545.283 13.82)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7513",
    "data-name": "Caminho 7513",
    d: "M600.388,20.579l-.027-.027-.506.525.051.033a5.021,5.021,0,0,0,.61.281,3.49,3.49,0,0,0,1.229.293h.059a2.957,2.957,0,0,0,1.2-.365,3.719,3.719,0,0,0,.433-.269c.054-.039.1-.072.134-.1a.489.489,0,0,0,.072-.084.368.368,0,0,0,.024-.1.862.862,0,0,0,.008-.132,2.6,2.6,0,0,0-.033-.375,1.019,1.019,0,0,0-.1-.312.872.872,0,0,0-.151-.183,3.361,3.361,0,0,0-.378-.293,1.514,1.514,0,0,0-.2-.1.371.371,0,0,0-.165-.045h-.027a1.007,1.007,0,0,0-.434.209,4.648,4.648,0,0,0-.526.449,3.307,3.307,0,0,0-.336.425.424.424,0,0,1-.37.158h-.063l-.5-.021h-.023l-.011.005.027.027v.041c.009,0,.081.012.5.031.028,0,.043.009.067.009a.507.507,0,0,0,.259-.06.651.651,0,0,0,.243-.23,1.659,1.659,0,0,1,.261-.329,4.5,4.5,0,0,1,.52-.437.931.931,0,0,1,.393-.194h.019a.487.487,0,0,1,.2.058,2.659,2.659,0,0,1,.379.261c.06.048.112.1.156.144a.348.348,0,0,1,.093.115.9.9,0,0,1,.084.281,2.621,2.621,0,0,1,.036.363.577.577,0,0,1-.012.12.15.15,0,0,1-.017.072c0,.009-.022.033-.051.055a2.938,2.938,0,0,1-.679.43,2.824,2.824,0,0,1-1.032.288h-.059a3.517,3.517,0,0,1-1.2-.281,4.563,4.563,0,0,1-.43-.2L600,21.056l-.044-.022-.024.036.036.031.453-.485-.028-.036v0Z",
    transform: "translate(-545.313 13.804)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7514",
    "data-name": "Caminho 7514",
    d: "M600.2,20.688s1.128.168,1.457-.12.683-.855.914-.981a.783.783,0,0,1,.334-.132s.168.113.242.177.293.242.293.242l.091.538.005.291-.355.29-.657.3-.615.2-.53-.015-1.066-.312-.278-.19-.072-.06Z",
    transform: "translate(-545.237 13.896)",
    fill: "#3c8386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7515",
    "data-name": "Caminho 7515",
    d: "M601.107,19.832c0-.1.063-.1.153-.1s.18.019.18.12-.093.23-.18.23-.153-.153-.153-.254",
    transform: "translate(-544.419 14.097)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7516",
    "data-name": "Caminho 7516",
    d: "M601.371,20.015c0-.087.068-.134.169-.134a.225.225,0,0,1,.2.2.18.18,0,0,1-.19.159c-.1,0-.18-.141-.18-.228",
    transform: "translate(-544.231 14.201)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7517",
    "data-name": "Caminho 7517",
    d: "M601.282,20.406c0-.108.065-.129.171-.129s.167.048.167.156a.2.2,0,0,1-.19.2c-.1,0-.148-.12-.148-.228",
    transform: "translate(-544.294 14.484)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7518",
    "data-name": "Caminho 7518",
    d: "M600.933,20.294c0-.113.113-.149.2-.149a.186.186,0,0,1,.171.206.193.193,0,0,1-.171.213c-.084,0-.2-.156-.2-.269",
    transform: "translate(-544.543 14.389)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7519",
    "data-name": "Caminho 7519",
    d: "M600.379,20.393a.231.231,0,0,1,.237-.228.228.228,0,0,1,.226.228.232.232,0,0,1-.226.233.235.235,0,0,1-.237-.233",
    transform: "translate(-544.939 14.404)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7520",
    "data-name": "Caminho 7520",
    d: "M601.371,20.015c0-.075.108-.134.169-.134a.127.127,0,0,1,.115.141.122.122,0,0,1-.115.137c-.062,0-.169-.067-.169-.144",
    transform: "translate(-544.231 14.201)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7521",
    "data-name": "Caminho 7521",
    d: "M601.282,20.392c0-.089.088-.129.18-.129s.169.039.169.129a.164.164,0,0,1-.172.158.168.168,0,0,1-.177-.158",
    transform: "translate(-544.294 14.474)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7522",
    "data-name": "Caminho 7522",
    d: "M600.934,20.284c0-.1.161-.147.228-.147s.062.07.062.168-.062.177-.128.177a.214.214,0,0,1-.161-.2",
    transform: "translate(-544.542 14.384)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7523",
    "data-name": "Caminho 7523",
    d: "M601.1,19.824c0-.084.069-.093.132-.093s.1.027.1.12-.043.165-.1.165-.125-.1-.125-.192",
    transform: "translate(-544.426 14.094)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7524",
    "data-name": "Caminho 7524",
    d: "M600.376,20.346a.22.22,0,0,1,.229-.206c.132,0,.273.045.273.154a.362.362,0,0,1-.3.281.214.214,0,0,1-.2-.23",
    transform: "translate(-544.941 14.386)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7525",
    "data-name": "Caminho 7525",
    d: "M600.762,20.153a.507.507,0,0,0-.24.1c-.084.081-.093.171-.05.2s.109-.057.128-.1a1.651,1.651,0,0,1,.161-.206",
    transform: "translate(-544.89 14.395)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7526",
    "data-name": "Caminho 7526",
    d: "M601.144,20.055s-.152.111-.168.216,0,.158.045.161.063-.137.046-.189.077-.189.077-.189",
    transform: "translate(-544.517 14.325)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7527",
    "data-name": "Caminho 7527",
    d: "M601.255,20.15a.319.319,0,0,0-.168.065c-.065.072-.132.147-.081.151s.117-.033.123-.075.125-.141.125-.141",
    transform: "translate(-544.504 14.393)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7528",
    "data-name": "Caminho 7528",
    d: "M601.312,19.64s-.081.063-.12.1-.092.141-.039.171.091-.027.127-.1a.529.529,0,0,0,.032-.177",
    transform: "translate(-544.403 14.029)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7529",
    "data-name": "Caminho 7529",
    d: "M601.669,19.853a.354.354,0,0,0-.191.087c-.05.058-.077.137-.014.137s.077-.036.1-.1a.583.583,0,0,1,.1-.129",
    transform: "translate(-544.191 14.181)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7530",
    "data-name": "Caminho 7530",
    d: "M601.636,20.246a.275.275,0,0,1-.12.146c-.085.051-.113.094-.153.027s.009-.1.061-.113l.212-.06",
    transform: "translate(-544.245 14.461)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7531",
    "data-name": "Caminho 7531",
    d: "M603.55,19.98a.445.445,0,0,1-.206.463,3.283,3.283,0,0,1-1.754.629,5.041,5.041,0,0,1-1.542-.477l-.108.055.177.074.557.237.635.187.4.029.343-.045.637-.216.536-.274.279-.223.077-.093-.005-.125v-.18Z",
    transform: "translate(-545.252 14.271)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7532",
    "data-name": "Caminho 7532",
    d: "M593.8,17.606s.164.141.153.266-.057.175-.1.147-.051-.147-.046-.2a.889.889,0,0,0,0-.216",
    transform: "translate(-549.635 12.576)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7533",
    "data-name": "Caminho 7533",
    d: "M594.638,18.273s-.052.216-.132.233a.11.11,0,0,1-.138-.1c.024-.036.089-.01.129-.036s.141-.1.141-.1",
    transform: "translate(-549.233 13.052)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7534",
    "data-name": "Caminho 7534",
    d: "M592.958,18.373a.267.267,0,0,0,.168.141c.107.021.158-.051.144-.093s-.063-.027-.12-.027-.192-.021-.192-.021",
    transform: "translate(-550.24 13.124)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7535",
    "data-name": "Caminho 7535",
    d: "M593.237,18.928a.437.437,0,0,0,.236.132.205.205,0,0,0,.213-.123c.008-.029-.159-.027-.208.019s-.242-.027-.242-.027",
    transform: "translate(-550.041 13.512)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7536",
    "data-name": "Caminho 7536",
    d: "M593.734,19.477s.216-.036.254-.1.091-.156.045-.218-.083.1-.106.153a.8.8,0,0,1-.192.161",
    transform: "translate(-549.685 13.679)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7537",
    "data-name": "Caminho 7537",
    d: "M595.56,19.912a1.98,1.98,0,0,0-.643-1.673c-.8-.7-1.308-.519-1.586-.269a1.27,1.27,0,0,0,.336,1.814,2.34,2.34,0,0,0,1.879.5Z",
    transform: "translate(-550.148 12.677)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7538",
    "data-name": "Caminho 7538",
    d: "M595.576,19.93l.042,0a1.739,1.739,0,0,0,.009-.192,1.978,1.978,0,0,0-.673-1.514,1.639,1.639,0,0,0-1.047-.506.837.837,0,0,0-.586.238,1,1,0,0,0-.259.706,1.487,1.487,0,0,0,.592,1.164,2.449,2.449,0,0,0,1.914.513l.032-.007.017-.4-.042,0,.042,0-.042,0-.041,0-.017.372.044,0-.012-.041h0a1.455,1.455,0,0,1-.374.036,2.226,2.226,0,0,1-1.462-.53,1.448,1.448,0,0,1-.569-1.1.92.92,0,0,1,.236-.648.758.758,0,0,1,.53-.207,1.562,1.562,0,0,1,.992.478,1.914,1.914,0,0,1,.647,1.452c0,.06-.005.1-.005.132,0,.015-.007.026-.007.036v.017Z",
    transform: "translate(-550.165 12.659)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7539",
    "data-name": "Caminho 7539",
    d: "M593.118,18.744s-.016-.535.242-.7a1.1,1.1,0,0,1,1.5.494,2.062,2.062,0,0,1,.322,1.6l-.446,0-.679-.281-.574-.422Z",
    transform: "translate(-550.125 12.801)",
    fill: "#3c8386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7540",
    "data-name": "Caminho 7540",
    d: "M595.458,19.679a.553.553,0,0,1-.425.144,2.394,2.394,0,0,1-1.948-1.557l.021.267.015.082.089.24.277.4.348.3.442.231.32.093.414.072h.236Z",
    transform: "translate(-550.149 13.047)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7541",
    "data-name": "Caminho 7541",
    d: "M594.068,18.937c0-.108.052-.108.136-.108s.146-.041.146.063-.053.262-.141.262-.141-.11-.141-.218",
    transform: "translate(-549.447 13.444)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7542",
    "data-name": "Caminho 7542",
    d: "M594.1,18.579a.139.139,0,0,1,.148-.134.134.134,0,1,1,0,.266.139.139,0,0,1-.148-.132",
    transform: "translate(-549.426 13.175)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7543",
    "data-name": "Caminho 7543",
    d: "M593.749,18.974c0-.057.076-.111.168-.111s.17.055.17.111-.17.132-.262.132-.076-.075-.076-.132",
    transform: "translate(-549.676 13.474)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7544",
    "data-name": "Caminho 7544",
    d: "M593.715,18.521c0-.089.044-.063.125-.063s.187.027.187.12a.242.242,0,0,1-.187.219c-.081,0-.125-.183-.125-.276",
    transform: "translate(-549.699 13.181)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7545",
    "data-name": "Caminho 7545",
    d: "M593.387,18.645c0-.075.053-.189.156-.189a.228.228,0,0,1,.2.189.164.164,0,0,1-.178.147.172.172,0,0,1-.18-.147",
    transform: "translate(-549.933 13.183)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7546",
    "data-name": "Caminho 7546",
    d: "M593.448,18.215c0-.077.057-.077.159-.077s.185.041.185.122-.126.189-.224.189-.12-.153-.12-.233",
    transform: "translate(-549.889 12.956)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7547",
    "data-name": "Caminho 7547",
    d: "M593.8,18.169c0-.077.076-.051.172-.051a.156.156,0,0,1,.169.144c0,.079-.12.161-.218.161s-.124-.173-.124-.254",
    transform: "translate(-549.64 12.938)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7548",
    "data-name": "Caminho 7548",
    d: "M593.449,18.218a.116.116,0,0,1,.121-.1c.077,0,.133.017.133.1a.133.133,0,0,1-.125.144c-.068,0-.149-.069-.129-.144",
    transform: "translate(-549.89 12.941)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7549",
    "data-name": "Caminho 7549",
    d: "M593.38,18.613a.138.138,0,0,1,.129-.153c.081,0,.141.005.141.087a.172.172,0,0,1-.153.173c-.084,0-.117-.031-.117-.108",
    transform: "translate(-549.938 13.186)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7550",
    "data-name": "Caminho 7550",
    d: "M593.8,18.182c0-.063.057-.069.136-.069s.125.015.125.081a.133.133,0,0,1-.144.11.119.119,0,0,1-.117-.122",
    transform: "translate(-549.64 12.938)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7551",
    "data-name": "Caminho 7551",
    d: "M593.715,18.584a.149.149,0,0,0,.14.156.169.169,0,0,0,.171-.156.186.186,0,0,0-.171-.168.157.157,0,0,0-.14.168",
    transform: "translate(-549.699 13.154)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7552",
    "data-name": "Caminho 7552",
    d: "M594.11,18.52a.153.153,0,0,0,.156.141.146.146,0,0,0,.153-.141.149.149,0,0,0-.153-.144.156.156,0,0,0-.156.144",
    transform: "translate(-549.417 13.126)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7553",
    "data-name": "Caminho 7553",
    d: "M593.731,18.979a.15.15,0,0,1,.144-.135.127.127,0,0,1,.141.115c0,.069-.125.161-.2.161s-.087-.072-.087-.141",
    transform: "translate(-549.687 13.46)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7554",
    "data-name": "Caminho 7554",
    d: "M594.068,18.9c0-.081.063-.087.156-.087s.125.007.125.087a.156.156,0,0,1-.158.158c-.087,0-.124-.074-.124-.158",
    transform: "translate(-549.447 13.437)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7555",
    "data-name": "Caminho 7555",
    d: "M594.166,18.284a.658.658,0,0,1,.1.2c.015.087.015.18-.018.192s-.082-.057-.094-.132a.894.894,0,0,1,.009-.257",
    transform: "translate(-549.388 13.06)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7556",
    "data-name": "Caminho 7556",
    d: "M593.875,17.971a.356.356,0,0,1,.061.168c0,.081-.012.165-.055.165s-.038-.084-.038-.139a1.281,1.281,0,0,1,.032-.194",
    transform: "translate(-549.608 12.836)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7557",
    "data-name": "Caminho 7557",
    d: "M593.535,18.017a.4.4,0,0,1,.053.171c0,.077-.009.161-.053.161s-.04-.079-.04-.132a1.147,1.147,0,0,1,.04-.2",
    transform: "translate(-549.856 12.869)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7558",
    "data-name": "Caminho 7558",
    d: "M593.4,18.083a.5.5,0,0,1,.147.072c.062.057.089.117.062.146s-.086-.014-.1-.053a1.526,1.526,0,0,0-.1-.165",
    transform: "translate(-549.927 12.916)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7559",
    "data-name": "Caminho 7559",
    d: "M593.661,18.444a.355.355,0,0,1,.177.065c.056.06.113.108.075.144s-.127-.026-.159-.072a.847.847,0,0,1-.093-.137",
    transform: "translate(-549.738 13.174)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7560",
    "data-name": "Caminho 7560",
    d: "M593.336,18.434a.751.751,0,0,1,.16.063c.046.036.065.11.044.129s-.068-.012-.111-.06a.659.659,0,0,1-.093-.132",
    transform: "translate(-549.97 13.167)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7561",
    "data-name": "Caminho 7561",
    d: "M594.142,18.678a1.033,1.033,0,0,1,.033.213c0,.1.011.17-.028.17s-.065-.106-.065-.178a.761.761,0,0,1,.06-.2",
    transform: "translate(-549.437 13.341)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7562",
    "data-name": "Caminho 7562",
    d: "M594.028,18.8a.691.691,0,0,1,.137.077c.039.034.047.094.02.1s-.053-.057-.081-.084-.077-.1-.077-.1",
    transform: "translate(-549.476 13.426)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7563",
    "data-name": "Caminho 7563",
    d: "M593.68,18.819a.487.487,0,0,1,.149.043c.043.027.048.171.043.187s-.072.005-.1-.057a1.191,1.191,0,0,0-.093-.173",
    transform: "translate(-549.724 13.442)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7564",
    "data-name": "Caminho 7564",
    d: "M593.881,17.769s-.526.113-.623.453a2.823,2.823,0,0,0-.1.711l-.075-.434.1-.276.15-.257.24-.146.206-.069Z",
    transform: "translate(-550.151 12.68)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7565",
    "data-name": "Caminho 7565",
    d: "M594.74,19.564s.056-.129-.1-.55a8.223,8.223,0,0,0-.473-.958l.246.281.2.321.1.288.072.269-.007.262Z",
    transform: "translate(-549.374 12.896)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7566",
    "data-name": "Caminho 7566",
    d: "M594.811,18.542s.185.12.2.185.026.091-.02.1-.12-.057-.144-.1a1.271,1.271,0,0,1-.04-.185",
    transform: "translate(-548.916 13.244)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7567",
    "data-name": "Caminho 7567",
    d: "M594.361,19.856a.593.593,0,0,1,.2-.216c.117-.069.2-.057.235-.017s-.077.12-.157.146a2.847,2.847,0,0,1-.281.087",
    transform: "translate(-549.238 13.994)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7568",
    "data-name": "Caminho 7568",
    d: "M595.119,20.182a.857.857,0,0,0,.21-.156c.081-.086.094-.149.062-.182s-.14.021-.185.089a1.186,1.186,0,0,0-.087.249",
    transform: "translate(-548.696 14.169)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7569",
    "data-name": "Caminho 7569",
    d: "M595.035,20.084a.777.777,0,0,1,.093-.221.129.129,0,0,1,.153-.051c.044.033.019.1-.017.144a1.18,1.18,0,0,1-.229.129",
    transform: "translate(-548.756 14.144)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7570",
    "data-name": "Caminho 7570",
    d: "M597.688,19.906a3,3,0,0,0-2.052-1.233,1.175,1.175,0,0,0-1.284,1.119c.029.262.413.849,1.747.945s1.55-.626,1.606-.663-.017-.168-.017-.168",
    transform: "translate(-549.246 13.337)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7571",
    "data-name": "Caminho 7571",
    d: "M597.706,19.922l.032-.027a3.041,3.041,0,0,0-.567-.595,2.551,2.551,0,0,0-1.517-.646.725.725,0,0,0-.083,0,1.221,1.221,0,0,0-.969.43,1.453,1.453,0,0,0-.216.369,1.043,1.043,0,0,0-.062.312.181.181,0,0,0,.006.057c.039.286.437.879,1.781.981.089.007.166.01.246.01a1.67,1.67,0,0,0,1.109-.336.967.967,0,0,0,.212-.24c.023-.033.04-.065.051-.082s.008-.019.015-.022v0l-.01-.024.01.024-.01-.024.01.024a.1.1,0,0,0,.033-.041.25.25,0,0,0,.008-.045.327.327,0,0,0-.021-.093l-.021-.048v-.007h-.007l-.032.027-.032.017v0c0,.007.012.021.017.043a.189.189,0,0,1,.011.057v.012c-.017.009-.023.017-.023.024a.241.241,0,0,0-.038.062,1.152,1.152,0,0,1-.339.353,1.758,1.758,0,0,1-.944.228c-.08,0-.153-.009-.241-.009-1.321-.1-1.678-.674-1.711-.91v-.041a.9.9,0,0,1,.061-.279,1.247,1.247,0,0,1,.361-.5,1.13,1.13,0,0,1,.744-.249.377.377,0,0,1,.076.005,2.525,2.525,0,0,1,1.476.622,4.125,4.125,0,0,1,.41.4.9.9,0,0,1,.1.129.113.113,0,0,1,.028.036.025.025,0,0,1,.012.019l.032-.027-.032.017Z",
    transform: "translate(-549.263 13.321)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7572",
    "data-name": "Caminho 7572",
    d: "M596.627,18.928a2.99,2.99,0,0,1,.479.461c.141.2.173.345.087.37a8.036,8.036,0,0,0-1.4-.783c-.591-.149-1.11-.012-1.224.273a.761.761,0,0,0,.2.888,7.846,7.846,0,0,0,1.544.384s.58-.084.6-.091l.37-.209.076-.2.1-.257.043-.113-.305-.338Z",
    transform: "translate(-549.136 13.511)",
    fill: "#3c8386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7573",
    "data-name": "Caminho 7573",
    d: "M595.272,19.076c0,.072-.081.108-.156.108s-.146-.036-.146-.111a.14.14,0,0,1,.146-.13.152.152,0,0,1,.156.134",
    transform: "translate(-548.803 13.53)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7574",
    "data-name": "Caminho 7574",
    d: "M594.721,19.206c0-.077.077-.077.161-.077a.147.147,0,0,1,.153.137c0,.072-.13.182-.206.144a.2.2,0,0,1-.108-.2",
    transform: "translate(-548.98 13.664)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7575",
    "data-name": "Caminho 7575",
    d: "M595.181,19.5a.173.173,0,0,1,.173-.171.18.18,0,0,1,.184.171c0,.093-.139.2-.233.2s-.123-.108-.123-.2",
    transform: "translate(-548.652 13.804)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7576",
    "data-name": "Caminho 7576",
    d: "M594.832,19.57c0-.084.084-.1.156-.1a.182.182,0,0,1,.169.165c0,.084-.093.137-.169.137s-.156-.113-.156-.2",
    transform: "translate(-548.901 13.906)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7577",
    "data-name": "Caminho 7577",
    d: "M595.455,19.747a.113.113,0,0,1,.112-.123c.068,0,.145.036.145.108a.145.145,0,0,1-.128.137.122.122,0,0,1-.128-.122",
    transform: "translate(-548.456 14.017)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7578",
    "data-name": "Caminho 7578",
    d: "M595.733,19.514c0-.077.048-.075.137-.075a.155.155,0,0,1,.168.139c0,.086-.111.13-.191.13s-.114-.1-.114-.194",
    transform: "translate(-548.257 13.885)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7579",
    "data-name": "Caminho 7579",
    d: "M595.218,19.021c0,.063-.031.1-.089.1s-.148-.036-.148-.1a.081.081,0,0,1,.091-.093c.067,0,.146.027.146.093",
    transform: "translate(-548.794 13.52)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7580",
    "data-name": "Caminho 7580",
    d: "M595.022,19.2c0,.072-.111.122-.184.122a.11.11,0,0,1-.113-.122c0-.072.048-.089.12-.089s.176.017.176.089",
    transform: "translate(-548.977 13.649)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7581",
    "data-name": "Caminho 7581",
    d: "M595.1,19.57c0,.06-.02.111-.089.111s-.177-.051-.177-.111.026-.113.1-.113.161.045.161.113",
    transform: "translate(-548.897 13.898)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7582",
    "data-name": "Caminho 7582",
    d: "M595.491,19.466c0,.072-.125.146-.194.146s-.106-.125-.106-.187a.125.125,0,0,1,.124-.123.222.222,0,0,1,.177.165",
    transform: "translate(-548.645 13.786)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7583",
    "data-name": "Caminho 7583",
    d: "M596.035,19.6c0,.069-.112.069-.177.069a.147.147,0,0,1-.124-.146c0-.075.024-.139.184-.123.06.012.117.132.117.2",
    transform: "translate(-548.256 13.854)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7584",
    "data-name": "Caminho 7584",
    d: "M595.69,19.72a.125.125,0,0,1-.12.125.121.121,0,0,1-.122-.125c0-.069.05-.1.122-.1s.12.027.12.1",
    transform: "translate(-548.46 14.017)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7585",
    "data-name": "Caminho 7585",
    d: "M595.639,19.465a.673.673,0,0,1,.229-.027c.1.01.1.046.1.063s-.079.051-.117.036l-.216-.072",
    transform: "translate(-548.324 13.883)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7586",
    "data-name": "Caminho 7586",
    d: "M595.323,19.756a.668.668,0,0,1,.18-.077c.074-.015.141.012.134.06s-.033.053-.108.053a.923.923,0,0,1-.206-.036",
    transform: "translate(-548.55 14.053)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7587",
    "data-name": "Caminho 7587",
    d: "M595.119,19.251s.225.1.264.192.072.106.022.137-.095-.033-.129-.077-.157-.252-.157-.252",
    transform: "translate(-548.696 13.751)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7588",
    "data-name": "Caminho 7588",
    d: "M595.082,19.443a1.394,1.394,0,0,1,.254-.051c.076,0,.1.01.108.048s-.017.048-.081.045a2.763,2.763,0,0,1-.281-.041",
    transform: "translate(-548.723 13.851)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7589",
    "data-name": "Caminho 7589",
    d: "M594.763,19.425A.717.717,0,0,1,595,19.5a.108.108,0,0,1,.028.125c-.022.027-.109.009-.137-.017s-.127-.183-.127-.183",
    transform: "translate(-548.95 13.875)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7590",
    "data-name": "Caminho 7590",
    d: "M594.748,19.645a.3.3,0,0,1,.137-.125c.068-.024.147-.024.156.014s-.054.084-.1.1l-.192.012",
    transform: "translate(-548.961 13.931)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7591",
    "data-name": "Caminho 7591",
    d: "M594.666,19.108a.359.359,0,0,1,.182.048c.067.053.084.1.067.113s-.083.031-.136-.005a.333.333,0,0,1-.113-.156",
    transform: "translate(-549.02 13.649)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7592",
    "data-name": "Caminho 7592",
    d: "M594.9,18.83a.574.574,0,0,1,.248.137c.062.087.053.141.018.156s-.094-.027-.141-.065a.985.985,0,0,1-.125-.228",
    transform: "translate(-548.85 13.45)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7593",
    "data-name": "Caminho 7593",
    d: "M597.462,19.837a1.89,1.89,0,0,1-1.253.3,2.283,2.283,0,0,1-1.858-.811l.081.2.192.259.6.312.69.153.542.033.507-.093.4-.189c.02-.009.056-.1.056-.1Z",
    transform: "translate(-549.245 13.804)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7594",
    "data-name": "Caminho 7594",
    d: "M596.792,19.829s-.148-.177-.346-.369-1-.7-1-.7l.643.29.42.357.305.336Z",
    transform: "translate(-548.461 13.399)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7595",
    "data-name": "Caminho 7595",
    d: "M596.255,18.935a.926.926,0,0,1,.261.141.9.9,0,0,0,.077.1s-.056.141-.108.089-.064-.065-.125-.142a1.941,1.941,0,0,1-.1-.183",
    transform: "translate(-547.885 13.525)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7596",
    "data-name": "Caminho 7596",
    d: "M596.634,18.73a.807.807,0,0,1,.281.187c.068.1.053.185.024.194s-.168-.108-.189-.156-.116-.225-.116-.225",
    transform: "translate(-547.615 13.379)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7597",
    "data-name": "Caminho 7597",
    d: "M596.752,18.7a1.192,1.192,0,0,1,.225.209c.033.06.092.147.033.165s-.153-.075-.174-.132-.083-.242-.083-.242",
    transform: "translate(-547.53 13.36)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7598",
    "data-name": "Caminho 7598",
    d: "M597.4,18.86a.235.235,0,0,1,.161.173.524.524,0,0,1-.016.216s-.1-.087-.1-.113a.22.22,0,0,0,0-.1c-.01-.063-.041-.171-.041-.171",
    transform: "translate(-547.068 13.471)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7599",
    "data-name": "Caminho 7599",
    d: "M597.568,18.912a.626.626,0,0,1,.137.209c.016.075.035.129-.041.141s-.1-.072-.1-.137.005-.213.005-.213",
    transform: "translate(-546.95 13.509)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7600",
    "data-name": "Caminho 7600",
    d: "M596.419,20.413a.282.282,0,0,0,.176.007c.091-.031.161-.115.15-.159-.021-.06-.065-.111-.131-.036s-.03.1-.087.123-.108.065-.108.065",
    transform: "translate(-547.767 14.419)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7601",
    "data-name": "Caminho 7601",
    d: "M597.049,20.63a.424.424,0,0,0,.242-.125c.1-.108.147-.183.076-.2a.123.123,0,0,0-.172.081.822.822,0,0,1-.146.249",
    transform: "translate(-547.318 14.493)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7602",
    "data-name": "Caminho 7602",
    d: "M597.569,20.66a1.38,1.38,0,0,0,.2-.147c.076-.081.127-.13.068-.178-.06-.067-.1-.024-.125.005s0,.027-.032.115a1.839,1.839,0,0,1-.108.206",
    transform: "translate(-546.946 14.499)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7603",
    "data-name": "Caminho 7603",
    d: "M597.724,20.665a1.046,1.046,0,0,0,.147-.218c.029-.081.044-.175-.012-.168a.158.158,0,0,0-.117.141c-.007.057-.019.245-.019.245",
    transform: "translate(-546.835 14.485)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7604",
    "data-name": "Caminho 7604",
    d: "M596.143,20.2c.007-.4.572-1.3,1.208-1.289a3.662,3.662,0,0,1,1.212.334c.356.156.47.333.706.386a1.977,1.977,0,0,0,.59.015l.8-.087-.628.919-.222.2a1.511,1.511,0,0,1-.768.614,3.951,3.951,0,0,1-1.961-.048,1.19,1.19,0,0,1-.936-1.039",
    transform: "translate(-547.965 13.509)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7605",
    "data-name": "Caminho 7605",
    d: "M596.158,20.22h.045a.785.785,0,0,1,.1-.35,1.731,1.731,0,0,1,.425-.605.923.923,0,0,1,.624-.29h.013a2.362,2.362,0,0,1,.536.093,4.438,4.438,0,0,1,.66.233,2.371,2.371,0,0,1,.389.231.827.827,0,0,0,.327.161,1.306,1.306,0,0,0,.322.033,2.537,2.537,0,0,0,.278-.015l.7-.077-.575.835-.223.2v.005a1.5,1.5,0,0,1-.748.59,2.042,2.042,0,0,1-.715.108,5.4,5.4,0,0,1-1.219-.159,1.26,1.26,0,0,1-.61-.35.916.916,0,0,1-.293-.638V20.22h-.045l-.036-.007v.015a1,1,0,0,0,.317.7,1.446,1.446,0,0,0,.65.37,5.773,5.773,0,0,0,1.236.161,2.179,2.179,0,0,0,.748-.117,1.449,1.449,0,0,0,.783-.631l-.032-.021.03.036.225-.2.683-.993-.893.1h-.021a1.617,1.617,0,0,1-.246.019,1.143,1.143,0,0,1-.3-.036.853.853,0,0,1-.3-.147,2.1,2.1,0,0,0-.4-.242,3.9,3.9,0,0,0-.671-.233,2.587,2.587,0,0,0-.56-.1h-.013a.911.911,0,0,0-.478.154,1.756,1.756,0,0,0-.535.573,1.292,1.292,0,0,0-.219.6Z",
    transform: "translate(-547.98 13.49)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7606",
    "data-name": "Caminho 7606",
    d: "M599.957,20.146a.344.344,0,0,1-.221.048,9.731,9.731,0,0,0-2.417-1.035c-.552.045-1.079.286-1.09.847s.124.578.236.735a4.606,4.606,0,0,0,1.2.4l.66-.014.53-.055.47-.261.259-.2.166-.211Z",
    transform: "translate(-547.904 13.684)",
    fill: "#3c8386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7607",
    "data-name": "Caminho 7607",
    d: "M596.908,19.615c0,.111-.044.189-.149.189s-.192-.051-.192-.161.063-.147.17-.147.171.007.171.12",
    transform: "translate(-547.662 13.925)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7608",
    "data-name": "Caminho 7608",
    d: "M596.874,19.33c0-.087.084-.132.192-.132s.178.036.178.132a.166.166,0,0,1-.178.159.172.172,0,0,1-.192-.159",
    transform: "translate(-547.442 13.713)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7609",
    "data-name": "Caminho 7609",
    d: "M597.494,19.51a.157.157,0,0,1,.313,0,.158.158,0,0,1-.313,0",
    transform: "translate(-547 13.826)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7610",
    "data-name": "Caminho 7610",
    d: "M597.62,19.906a.176.176,0,0,1,.168-.189c.089,0,.182.045.182.147s-.037.2-.125.2-.225-.06-.225-.159",
    transform: "translate(-546.91 14.084)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7611",
    "data-name": "Caminho 7611",
    d: "M597.32,20.134a.174.174,0,0,1,.348,0,.15.15,0,0,1-.169.149.163.163,0,0,1-.178-.149",
    transform: "translate(-547.124 14.268)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7612",
    "data-name": "Caminho 7612",
    d: "M596.749,20.034a.156.156,0,0,1,.312,0,.156.156,0,0,1-.312,0",
    transform: "translate(-547.532 14.201)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7613",
    "data-name": "Caminho 7613",
    d: "M596.9,19.605a.168.168,0,0,1-.335,0c0-.093.077-.125.165-.125s.17.033.17.125",
    transform: "translate(-547.661 13.914)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7614",
    "data-name": "Caminho 7614",
    d: "M597.2,19.322c0,.087-.028.141-.121.141s-.206-.053-.206-.141a.158.158,0,0,1,.161-.153.162.162,0,0,1,.165.153",
    transform: "translate(-547.442 13.692)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7615",
    "data-name": "Caminho 7615",
    d: "M597.79,19.476a.142.142,0,0,1-.147.129.134.134,0,1,1,0-.264.142.142,0,0,1,.147.135",
    transform: "translate(-547.003 13.815)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7616",
    "data-name": "Caminho 7616",
    d: "M597.486,19.72c0,.113-.039.192-.147.192s-.19-.048-.19-.159.065-.153.166-.153.171.019.171.12",
    transform: "translate(-547.246 14)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7617",
    "data-name": "Caminho 7617",
    d: "M597.052,20a.169.169,0,0,1-.338,0c0-.084.11-.129.2-.129a.118.118,0,0,1,.134.129",
    transform: "translate(-547.557 14.194)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7618",
    "data-name": "Caminho 7618",
    d: "M597.459,19.731a.154.154,0,0,1-.16.153.156.156,0,0,1-.157-.153.158.158,0,1,1,.317,0",
    transform: "translate(-547.251 13.979)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7619",
    "data-name": "Caminho 7619",
    d: "M597.963,19.839a.163.163,0,0,1-.164.18.18.18,0,0,1-.18-.18c0-.089.034-.125.128-.125s.216.036.216.125",
    transform: "translate(-546.911 14.081)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7620",
    "data-name": "Caminho 7620",
    d: "M597.645,20.1a.14.14,0,0,1-.153.144.165.165,0,0,1-.182-.144c0-.093.083-.129.169-.129s.165.036.165.129",
    transform: "translate(-547.131 14.266)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7621",
    "data-name": "Caminho 7621",
    d: "M597.539,19.739s.265-.024.317.024a.107.107,0,0,1,.021.137.148.148,0,0,1-.152-.005,1.191,1.191,0,0,0-.185-.156",
    transform: "translate(-546.968 14.095)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7622",
    "data-name": "Caminho 7622",
    d: "M597.391,19.24a.686.686,0,0,1,.281.137c.083.081.075.171.057.18a.109.109,0,0,1-.149-.031,2.71,2.71,0,0,1-.188-.286",
    transform: "translate(-547.073 13.743)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7623",
    "data-name": "Caminho 7623",
    d: "M597.037,19.479a1.272,1.272,0,0,1,.289.206c.055.075.063.132.043.163s-.141-.01-.165-.045-.167-.324-.167-.324",
    transform: "translate(-547.326 13.914)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7624",
    "data-name": "Caminho 7624",
    d: "M596.976,19.586a1.029,1.029,0,0,1,.329.087c.065.046.114.053.108.089s-.031.072-.068.065a.674.674,0,0,1-.192-.081c-.024-.021-.176-.161-.176-.161",
    transform: "translate(-547.37 13.99)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7625",
    "data-name": "Caminho 7625",
    d: "M596.8,19.128a1.37,1.37,0,0,1,.329.091c.052.045.063.163.006.2s-.134-.038-.155-.086a1.662,1.662,0,0,0-.18-.206",
    transform: "translate(-547.497 13.663)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7626",
    "data-name": "Caminho 7626",
    d: "M596.456,19.371a1.04,1.04,0,0,1,.329.228c.045.06.078.113,0,.141s-.147-.108-.147-.141a1.472,1.472,0,0,0-.182-.228",
    transform: "translate(-547.741 13.836)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7627",
    "data-name": "Caminho 7627",
    d: "M596.426,19.574a1.626,1.626,0,0,1,.233-.033c.079,0,.187-.024.192.033s-.1.077-.153.063a2.362,2.362,0,0,0-.272-.063",
    transform: "translate(-547.763 13.954)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7628",
    "data-name": "Caminho 7628",
    d: "M597.23,20.123s.168-.111.257-.1.113.021.113.069-.094.039-.128.039-.242-.012-.242-.012",
    transform: "translate(-547.188 14.304)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7629",
    "data-name": "Caminho 7629",
    d: "M596.667,20.049s.065-.1.136-.111.106-.01.116.022-.066.093-.093.093l-.159,0",
    transform: "translate(-547.59 14.237)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7630",
    "data-name": "Caminho 7630",
    d: "M599.784,19.979a1.945,1.945,0,0,1-.638.482,2.259,2.259,0,0,1-1.169.18,2.382,2.382,0,0,1-1.114-.291,1.733,1.733,0,0,1-.675-.552c-.057-.111.053.189.053.189l.324.415.377.168.555.144.524.06.407-.012.478-.072.307-.115.214-.129.16-.125Z",
    transform: "translate(-547.945 14.123)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7631",
    "data-name": "Caminho 7631",
    d: "M599.186,19.64s-.145.053-.462-.144a2.442,2.442,0,0,0-1.417-.454,1.1,1.1,0,0,0-1,.523c-.049.039.321-.425.321-.425l.329-.175.256-.043.246.009.317.084.288.091.334.11.288.159.356.189Z",
    transform: "translate(-547.847 13.516)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7632",
    "data-name": "Caminho 7632",
    d: "M598.906,19.56s-.422-.009-.541,0-.124.033-.141.069-.045.075-.045.075l-.128-.285.574-.077.312.113Z",
    transform: "translate(-546.602 13.816)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7633",
    "data-name": "Caminho 7633",
    d: "M598.1,22.485a.218.218,0,0,0,.184.147c.083,0,.262,0,.262,0l.566-.039.2-.228.125-.518s.156-.182.156-.19.526-.3.526-.3l.461-.129.293-.036.406-.132.3-.161.137-.192.12-.293-.12-.4-.322-.425-.542-.218h-.447l-.5.182-.887.206a1.649,1.649,0,0,0-.686.59,1.809,1.809,0,0,0-.229.979c-.033.5-.013,1.152-.013,1.152",
    transform: "translate(-546.573 13.841)",
    fill: "#3c8386"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7634",
    "data-name": "Caminho 7634",
    d: "M598.115,22.5l-.036.015a.346.346,0,0,0,.079.12.231.231,0,0,0,.141.057h.262l.59-.043.218-.25.126-.528-.039-.009.028.033s.037-.05.077-.1l.057-.069a.085.085,0,0,1,.019-.027l0,0V21.7l.007-.007v-.014h-.036l.029.021a.054.054,0,0,0,.007-.021h-.036l.029.021-.029-.021.024.026,0-.005-.029-.021.024.026-.012-.012,0,.015.007,0-.012-.012,0,.015a.125.125,0,0,0,.033-.021c.063-.031.184-.1.293-.161s.2-.108.2-.108l-.018-.036.012.036.454-.129.294-.031.416-.132.314-.166.141-.211.135-.31-.135-.418-.33-.441-.562-.225h-.458l-.5.185-.886.2,0,0a2.046,2.046,0,0,0-.273.154,1.573,1.573,0,0,0-.434.459,1.878,1.878,0,0,0-.179.454,3.152,3.152,0,0,0-.054.538c-.015.2-.015.417-.015.61,0,.3,0,.542,0,.542l0,.009v.007l.036-.015h.042v-.158c-.006-.1-.006-.231-.006-.384,0-.189.006-.413.015-.6a3.4,3.4,0,0,1,.057-.53,1.427,1.427,0,0,1,.173-.432,1.171,1.171,0,0,1,.4-.422c.072-.048.137-.086.185-.113.021-.009.04-.021.057-.027l.015-.005,0,0-.02-.043.008.046.887-.211.5-.182h.43l.521.213.305.406.12.381-.12.276-.121.178-.284.153-.4.132-.291.027-.473.137v0s-.134.069-.27.141c-.068.039-.13.072-.182.1a.183.183,0,0,0-.057.043l-.019.009-.011,0,0,.005-.007.007a.064.064,0,0,0-.005.027h.038l-.038-.019v.019h.038l-.038-.019.025.012-.02-.015-.005,0,.025.012-.02-.015-.027.036-.119.151-.006.009-.129.514-.18.206-.55.034v0s-.122.005-.213.005H598.3a.122.122,0,0,1-.083-.039.191.191,0,0,1-.059-.082l-.042.017h0Z",
    transform: "translate(-546.588 13.823)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7635",
    "data-name": "Caminho 7635",
    d: "M598.31,22.256c.169,0,.044-.285.236-.61a3.148,3.148,0,0,1,.482-.737c.056,0,.068.058.134.043a.56.56,0,0,0,.2-.156.553.553,0,0,1,.153-.338,1.877,1.877,0,0,1,.448-.309c.1-.021.14-.036.159.009s-.057.111.015.129.213.015.254-.086a.26.26,0,0,0,.029-.153.329.329,0,0,1,.292-.057c.192.046.218.029.233.108s-.087.082-.063.141-.017.045.007.082.044.156.173.156a.267.267,0,0,0,.185-.081l.036-.069s.036-.081-.016-.115-.025-.069.016-.053c.057.031.249.3.313.185s.076-.273.036-.309-.305-.447-.305-.447l-.49-.168-.649.048-.635.362-.574.309s-.033.473-.134.386-.255-.317-.3-.24a6.129,6.129,0,0,0-.208.6,3.393,3.393,0,0,0-.208.9c.019.2.12.47.18.47",
    transform: "translate(-546.547 13.873)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7636",
    "data-name": "Caminho 7636",
    d: "M598.647,20.626a.366.366,0,0,0-.137.081.173.173,0,0,0-.028.147c.015.058.111.117.12.125l.072,0,.149-.041a.245.245,0,0,0,.056-.135.092.092,0,0,0-.06-.1,1.571,1.571,0,0,1-.173-.072",
    transform: "translate(-546.298 14.733)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7637",
    "data-name": "Caminho 7637",
    d: "M599.221,20.154a.116.116,0,0,0-.149.057.252.252,0,0,0-.007.089s.019.12.068.147.168.06.208.017a.161.161,0,0,0,.074-.146c0-.081-.106-.117-.106-.117Z",
    transform: "translate(-545.878 14.389)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7638",
    "data-name": "Caminho 7638",
    d: "M599.719,20.279c0-.031-.083-.051-.132-.041a.135.135,0,0,0-.1.173c.021.108.122.113.2.089s.06-.12.06-.141a.43.43,0,0,0-.027-.081",
    transform: "translate(-545.577 14.454)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7639",
    "data-name": "Caminho 7639",
    d: "M598.274,20.374a.182.182,0,0,0,.2.135.2.2,0,0,0,.186-.163c.009-.06-.055.063-.139.084s-.134.043-.166-.005-.076-.051-.076-.051",
    transform: "translate(-546.442 14.522)",
    fill: "#93bcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7640",
    "data-name": "Caminho 7640",
    d: "M598.878,20.727a.178.178,0,0,1-.06.156.225.225,0,0,1-.161.048.15.15,0,0,1-.124-.051.37.37,0,0,1-.053-.1s.081.135.206.1a.344.344,0,0,0,.192-.153",
    transform: "translate(-546.296 14.805)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7641",
    "data-name": "Caminho 7641",
    d: "M600.142,20a.214.214,0,0,1-.077.149.326.326,0,0,1-.163.045.179.179,0,0,1-.122-.065c-.1-.149-.04-.245-.04-.245s.063.254.2.24a.325.325,0,0,0,.206-.123",
    transform: "translate(-545.409 14.202)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7642",
    "data-name": "Caminho 7642",
    d: "M598.977,20.219s-.06.2-.2.2-.12-.036-.108-.062.06.026.12.012a.8.8,0,0,0,.185-.147",
    transform: "translate(-546.163 14.442)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7643",
    "data-name": "Caminho 7643",
    d: "M599.065,20.2s-.012.141.036.189a.22.22,0,0,0,.161.075.16.16,0,0,0,.139-.067.133.133,0,0,0,.014-.117.132.132,0,0,1-.036.072.144.144,0,0,1-.118.053c-.04,0-.119-.009-.132-.057s-.063-.149-.063-.149",
    transform: "translate(-545.878 14.427)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7644",
    "data-name": "Caminho 7644",
    d: "M599.583,19.787a.209.209,0,0,1-.041.2c-.084.089-.243.039-.243.039s.127.026.185-.039a.478.478,0,0,0,.1-.2",
    transform: "translate(-545.71 14.134)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7645",
    "data-name": "Caminho 7645",
    d: "M598.192,22.691s.847-.009.912-.129-.065-.574.444-.934a2,2,0,0,1,1.176-.374,1.058,1.058,0,0,0,.963-.727c.062-.314-.369-.338-.527-.634s-.581-.183-.6-.183a1.142,1.142,0,0,0-.7.2c-.132.127-.118.288-.18.36s-.619,0-.685.089.019.278-.021.324-.18-.123-.18-.123l.051-.451.712-.417.808-.453s.536.031.56.019.545.273.562.281.273.317.273.317a1.453,1.453,0,0,1,.078.377.713.713,0,0,1-.025.31,1.175,1.175,0,0,1-1.076.809,2.264,2.264,0,0,0-1.135.4c-.223.158-.331.864-.331.951a4.641,4.641,0,0,1-1.056.024Z",
    transform: "translate(-546.501 13.743)",
    fill: "#26554f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7646",
    "data-name": "Caminho 7646",
    d: "M598.454,20.44a.074.074,0,0,1-.12-.019.743.743,0,0,1,.044-.339,1.644,1.644,0,0,0,.015.254c.019.033.055.024.079.053.009.007.021.024-.018.051",
    transform: "translate(-546.406 14.344)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7647",
    "data-name": "Caminho 7647",
    d: "M598.724,20.411c-.045-.012-.033-.144,0-.2a2.457,2.457,0,0,1,.265-.23s-.068.18-.1.24-.1.206-.16.194",
    transform: "translate(-546.142 14.269)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7648",
    "data-name": "Caminho 7648",
    d: "M598.609,20.9c-.032.009-.041-.063-.041-.156s.155-.261.155-.261a1.591,1.591,0,0,0-.053.2c-.007.041.027.086.02.141a.082.082,0,0,1-.081.077",
    transform: "translate(-546.233 14.631)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7649",
    "data-name": "Caminho 7649",
    d: "M598.992,20.59a.649.649,0,0,1-.165.134c-.081.048-.179.123-.228.1s.027-.125.06-.135a2.48,2.48,0,0,1,.333-.1",
    transform: "translate(-546.223 14.707)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7650",
    "data-name": "Caminho 7650",
    d: "M599.323,19.986a.708.708,0,0,0-.144.194c-.052.115-.065.211-.021.228s.12-.132.125-.182.04-.24.04-.24",
    transform: "translate(-545.83 14.276)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7651",
    "data-name": "Caminho 7651",
    d: "M599.583,20.242a.451.451,0,0,0-.192-.089c-.113-.036-.169,0-.182.033s-.1.084-.056.11.1-.041.132-.053a.487.487,0,0,1,.14-.027l.158.027",
    transform: "translate(-545.824 14.383)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7652",
    "data-name": "Caminho 7652",
    d: "M599.312,19.9c.039.041.1-.036.161-.1a.632.632,0,0,0,.1-.194,1.342,1.342,0,0,0-.166.106c-.055.043-.129.163-.1.183",
    transform: "translate(-545.706 14.01)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7653",
    "data-name": "Caminho 7653",
    d: "M600.067,19.767a.719.719,0,0,0-.192.135c-.05.065-.109.134-.065.165s.089-.027.134-.079.124-.221.124-.221",
    transform: "translate(-545.357 14.119)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7654",
    "data-name": "Caminho 7654",
    d: "M599.916,20.2a.434.434,0,0,1-.135.158c-.093.058-.2.082-.218.051a.112.112,0,0,1,.048-.113.738.738,0,0,1,.137-.039.657.657,0,0,0,.168-.057",
    transform: "translate(-545.525 14.431)",
    fill: "#272425"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7655",
    "data-name": "Caminho 7655",
    d: "M595.839,18.05l-.276.687.225-.034.132-.605Z",
    transform: "translate(-548.379 12.893)",
    fill: "#f2c949"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_822",
    "data-name": "Grupo 822",
    transform: "translate(46.73 31.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_821",
    "data-name": "Grupo 821",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7656",
    "data-name": "Caminho 7656",
    d: "M595.629,18.152l1.373.58-.646,1.572-1.373-.58Z",
    transform: "translate(-595.523 -18.524)",
    fill: "url(#radial-gradient)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7658",
    "data-name": "Caminho 7658",
    d: "M595.859,18.1l.046.027-.119.578-.174.021Zm0-.031-.012.019Zm-.019-.007-.29.715.275-.036.135-.638-.113-.072Z",
    transform: "translate(-548.392 12.878)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_824",
    "data-name": "Grupo 824",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_823",
    "data-name": "Grupo 823",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7659",
    "data-name": "Caminho 7659",
    d: "M595.883,17.882a.171.171,0,0,0-.2.168.176.176,0,1,0,.2-.168",
    transform: "translate(-548.295 12.771)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7660",
    "data-name": "Caminho 7660",
    d: "M595.893,17.89v-.019l-.016,0a.209.209,0,0,0-.209.182v.021a.21.21,0,0,0,.176.213l.013,0a.208.208,0,0,0,.206-.185v-.031a.2.2,0,0,0-.17-.2v.019l0,.015a.159.159,0,0,1,.135.166V18.1a.164.164,0,0,1-.159.151h-.021a.166.166,0,0,1-.137-.171v-.017a.17.17,0,0,1,.165-.153h.017Z",
    transform: "translate(-548.304 12.764)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7661",
    "data-name": "Caminho 7661",
    d: "M595.957,17.9s.044.029-.012.005-.212.058-.212.163a.162.162,0,0,0,.156.17c.078,0-.033.015-.033.015l-.1-.031-.037-.062-.04-.084.027-.093.065-.084.077-.024h.055Z",
    transform: "translate(-548.299 12.772)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7662",
    "data-name": "Caminho 7662",
    d: "M595.826,18.229s-.041-.007-.081.051-.113.166-.113.166l.146-.377.087.048Z",
    transform: "translate(-548.33 12.907)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7663",
    "data-name": "Caminho 7663",
    d: "M602.972,18.879l-.676.638.278.069.463-.607Z",
    transform: "translate(-543.57 13.485)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7664",
    "data-name": "Caminho 7664",
    d: "M602.991,18.891l-.009-.017-.713.667.333.084.481-.634L603,18.862l-.016.012.009.017-.015.012.051.087-.44.586-.23-.067.65-.6-.016-.019-.015.012Z",
    transform: "translate(-543.589 13.473)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7665",
    "data-name": "Caminho 7665",
    d: "M603.016,18.733a.258.258,0,0,0-.324.094.227.227,0,0,0,.07.31.244.244,0,0,0,.322-.1.213.213,0,0,0-.068-.307",
    transform: "translate(-543.311 13.363)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7666",
    "data-name": "Caminho 7666",
    d: "M603.026,18.739l.009-.007a.222.222,0,0,0-.121-.033.254.254,0,0,0-.225.125.259.259,0,0,0-.044.137.227.227,0,0,0,.12.2.26.26,0,0,0,.12.031.271.271,0,0,0,.229-.125.281.281,0,0,0,.034-.139.209.209,0,0,0-.113-.194l-.009.007-.012.022a.176.176,0,0,1,.1.165.223.223,0,0,1-.031.115.23.23,0,0,1-.2.108.177.177,0,0,1-.1-.026.184.184,0,0,1-.1-.161.2.2,0,0,1,.033-.117.23.23,0,0,1,.193-.108.155.155,0,0,1,.1.024Z",
    transform: "translate(-543.321 13.357)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7667",
    "data-name": "Caminho 7667",
    d: "M603.075,18.8s.051.053-.012.007a.268.268,0,0,0-.337.077.188.188,0,0,0,.1.257c.093.041-.036,0-.036,0l-.109-.084-.016-.089.007-.111.073-.091.117-.057.108.007.06.029Z",
    transform: "translate(-543.308 13.365)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7668",
    "data-name": "Caminho 7668",
    d: "M602.811,19.1a.134.134,0,0,0-.132.015l-.225.13.377-.346.068.087Z",
    transform: "translate(-543.457 13.501)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7669",
    "data-name": "Caminho 7669",
    d: "M592.671,16.757l.347.787.159-.216-.4-.6Z",
    transform: "translate(-550.444 11.947)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7670",
    "data-name": "Caminho 7670",
    d: "M592.686,16.766l-.023.009.37.819.184-.257-.417-.622-.149.036.012.024.023-.009v.021l.089-.026.389.576-.125.177-.338-.753-.016.005v0Z",
    transform: "translate(-550.46 11.939)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7671",
    "data-name": "Caminho 7671",
    d: "M592.621,16.564a.212.212,0,0,0-.028.3.21.21,0,0,0,.305.036.225.225,0,0,0,.016-.305.207.207,0,0,0-.293-.033",
    transform: "translate(-550.537 11.798)",
    fill: "#f2c949"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7672",
    "data-name": "Caminho 7672",
    d: "M593.811,17.67c.192.362.15.759-.1.888s-.591-.053-.78-.415-.151-.77.093-.9.6.057.783.425",
    transform: "translate(-550.342 12.289)",
    fill: "#df5072"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_826",
    "data-name": "Grupo 826",
    transform: "translate(42.471 29.491)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_825",
    "data-name": "Grupo 825",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7673",
    "data-name": "Caminho 7673",
    d: "M592.839,18.859l-.146-1.594,1.387-.131.146,1.594Z",
    transform: "translate(-592.901 -17.252)",
    fill: "url(#radial-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_828",
    "data-name": "Grupo 828",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_827",
    "data-name": "Grupo 827",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7675",
    "data-name": "Caminho 7675",
    d: "M592.626,16.57l-.017-.015a.231.231,0,0,0-.075.175.248.248,0,0,0,.053.158.232.232,0,0,0,.187.093.213.213,0,0,0,.142-.053.242.242,0,0,0,.076-.173.234.234,0,0,0-.053-.156.249.249,0,0,0-.187-.091.255.255,0,0,0-.143.048l.017.015.012.015a.151.151,0,0,1,.113-.043.208.208,0,0,1,.16.075.216.216,0,0,1,.044.135.172.172,0,0,1-.069.146.2.2,0,0,1-.113.041.211.211,0,0,1-.16-.07.231.231,0,0,1-.048-.141.191.191,0,0,1,.072-.144Z",
    transform: "translate(-550.542 11.791)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7676",
    "data-name": "Caminho 7676",
    d: "M592.689,16.521s.075-.021,0,.015a.244.244,0,0,0-.033.321.174.174,0,0,0,.263-.01c.067-.06-.009.043-.009.043l-.109.069-.081-.015-.1-.041-.061-.1-.017-.117.038-.093.051-.039Z",
    transform: "translate(-550.536 11.797)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7677",
    "data-name": "Caminho 7677",
    d: "M592.854,16.867s-.044.031-.024.111.041.238.041.238l-.188-.437.1-.036Z",
    transform: "translate(-550.436 11.96)",
    fill: "#a28b38"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7678",
    "data-name": "Caminho 7678",
    d: "M592.735,17.77a.5.5,0,0,0,.236-.009c.088-.043.1-.1.121-.123a.259.259,0,0,0,.039-.153.675.675,0,0,0-.16-.23c-.027-.019-.152,0-.172-.021s.02-.067-.024-.079-.279.252-.236.3.063-.021.077.012a.846.846,0,0,1,.007.18c0,.041.114.125.114.125",
    transform: "translate(-550.544 12.254)",
    fill: "#d6153e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7679",
    "data-name": "Caminho 7679",
    d: "M592.822,17.416a.58.58,0,0,0,.138.165.431.431,0,0,0,.174.007c.032-.015.146-.12.146-.168a.259.259,0,0,0-.016-.129c-.026-.045-.011-.168-.057-.177s-.057-.009-.074-.033.012-.072-.022-.115-.406.171-.376.209.072,0,.083.031-.017.168,0,.209",
    transform: "translate(-550.401 12.114)",
    fill: "#d6153e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7680",
    "data-name": "Caminho 7680",
    d: "M593.472,17.353a.423.423,0,0,0-.027-.281c-.038-.036-.1-.039-.1-.067s.051-.034.051-.077-.42.015-.389.063.1.021.093.05-.072.06-.077.1a.558.558,0,0,0,.037.18c.02.027-.008.067.047.081s.038.019.08.033a.664.664,0,0,0,.237-.009c.017-.017.032-.012.053-.069",
    transform: "translate(-550.21 12.081)",
    fill: "#d6153e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7681",
    "data-name": "Caminho 7681",
    d: "M592.9,17.339c.04.053-.006.177-.031.213s-.214-.015-.221-.057a.169.169,0,0,1,.012-.12c.024-.036.087-.108.132-.1a.2.2,0,0,1,.108.06",
    transform: "translate(-550.463 12.341)",
    fill: "#f0e32a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7682",
    "data-name": "Caminho 7682",
    d: "M592.832,17.236a.123.123,0,0,0,.036.125.291.291,0,0,0,.191.039.4.4,0,0,0,.063-.266c-.024-.031-.093-.031-.121-.031a.616.616,0,0,0-.169.132",
    transform: "translate(-550.334 12.217)",
    fill: "#f0e32a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7683",
    "data-name": "Caminho 7683",
    d: "M593.094,17.077a.117.117,0,0,0,0,.113.252.252,0,0,0,.147.079c.048,0,.076-.147.076-.175s-.012-.038-.052-.057a.552.552,0,0,0-.176.039",
    transform: "translate(-550.151 12.169)",
    fill: "#f0e32a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7684",
    "data-name": "Caminho 7684",
    d: "M595.326,18.525s.072.117.145.144a.23.23,0,0,0,.146,0,.178.178,0,0,0,.115-.063.466.466,0,0,0,.049-.237c-.011-.027-.089-.1-.089-.12s.057-.026.033-.062-.321-.027-.321.024.055.026.043.06a.639.639,0,0,1-.108.1c-.028.024-.013.153-.013.153",
    transform: "translate(-548.552 12.977)",
    fill: "#d6153e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7685",
    "data-name": "Caminho 7685",
    d: "M595.588,18.374a.41.41,0,0,0-.015.185.258.258,0,0,0,.1.111.314.314,0,0,0,.182,0,.162.162,0,0,0,.068-.093c.015-.043.1-.1.084-.129a.1.1,0,0,1-.029-.075c0-.029.051-.029.06-.081s-.341-.147-.348-.111.036.043.023.067-.106.089-.125.125",
    transform: "translate(-548.377 12.982)",
    fill: "#d6153e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7686",
    "data-name": "Caminho 7686",
    d: "M596.007,18.778a.393.393,0,0,0,.157-.177c0-.045-.032-.087-.023-.108s.051.009.079-.014-.257-.252-.264-.2.044.074.024.084-.077-.007-.1.012a.3.3,0,0,0-.086.13c-.012.027-.047.031-.031.072a.389.389,0,0,0,.036.072.384.384,0,0,0,.14.139c.021,0,.021.021.072-.007",
    transform: "translate(-548.242 13.049)",
    fill: "#d6153e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7687",
    "data-name": "Caminho 7687",
    d: "M595.636,18.411c0,.051-.113.1-.149.1s-.117-.144-.093-.168.044-.065.081-.065.113-.007.137.024a.273.273,0,0,1,.024.113",
    transform: "translate(-548.502 13.053)",
    fill: "#f0e32a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7688",
    "data-name": "Caminho 7688",
    d: "M595.659,18.3c-.045.009-.057.06-.057.1a.215.215,0,0,0,.085.137.335.335,0,0,0,.2-.11c.006-.036-.04-.082-.057-.1a.328.328,0,0,0-.176-.027",
    transform: "translate(-548.352 13.065)",
    fill: "#f0e32a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7689",
    "data-name": "Caminho 7689",
    d: "M595.887,18.385a.107.107,0,0,0-.063.072.2.2,0,0,0,.036.137c.034.031.139-.039.148-.053s.02-.034,0-.06-.125-.1-.125-.1",
    transform: "translate(-548.194 13.132)",
    fill: "#f0e32a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7690",
    "data-name": "Caminho 7690",
    d: "M602.1,19.183a.433.433,0,0,0,.051.194c.05.058.106.058.119.072a.235.235,0,0,0,.129,0,.564.564,0,0,0,.147-.178c0-.027-.032-.123-.021-.141s.054,0,.054-.039-.258-.173-.278-.135.028.055.005.069a.492.492,0,0,1-.137.043c-.033.005-.068.117-.068.117",
    transform: "translate(-543.71 13.534)",
    fill: "#d6153e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7691",
    "data-name": "Caminho 7691",
    d: "M602.381,19.177a.374.374,0,0,0-.108.135.3.3,0,0,0,.021.123c.019.021.115.093.151.084a.133.133,0,0,0,.094-.033c.035-.024.133-.033.133-.069s0-.043.015-.06.063,0,.089-.036-.19-.269-.218-.243.009.051-.011.067-.138.014-.165.031",
    transform: "translate(-543.586 13.626)",
    fill: "#d6153e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7692",
    "data-name": "Caminho 7692",
    d: "M602.417,19.624a.342.342,0,0,0,.216-.005c.032-.031.037-.072.062-.072s.028.026.06.026,0-.307-.04-.286-.02.072-.044.069-.047-.057-.074-.06a.3.3,0,0,0-.144.027c-.021.005-.048-.015-.063.027a.5.5,0,0,0-.029.058.347.347,0,0,0,0,.177c.017.015,0,.024.057.039",
    transform: "translate(-543.533 13.775)",
    fill: "#d6153e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7693",
    "data-name": "Caminho 7693",
    d: "M602.367,19.234c-.029.036-.134.027-.168.009s-.032-.17,0-.18a.151.151,0,0,1,.094-.021c.031.015.1.045.106.087a.228.228,0,0,1-.027.1",
    transform: "translate(-543.657 13.6)",
    fill: "#f0e32a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7694",
    "data-name": "Caminho 7694",
    d: "M602.423,19.161a.1.1,0,0,0-.093.045c-.019.021-.024.132,0,.149a.351.351,0,0,0,.213.012.112.112,0,0,0,.012-.094.557.557,0,0,0-.132-.111",
    transform: "translate(-543.556 13.685)",
    fill: "#f0e32a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7695",
    "data-name": "Caminho 7695",
    d: "M602.546,19.352a.116.116,0,0,0-.1,0,.189.189,0,0,0-.062.111c0,.041.113.06.134.06s.036-.01.051-.039a.55.55,0,0,0-.027-.132",
    transform: "translate(-543.503 13.816)",
    fill: "#f0e32a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7696",
    "data-name": "Caminho 7696",
    d: "M597.46,12.839l.165.369-.593.355-.089.027-.039-.141-.093-.242-.358-.132-.108-.027.072-.177.3-.1.293-.012.317-.012Z",
    transform: "translate(-547.821 9.102)",
    fill: "#854729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7697",
    "data-name": "Caminho 7697",
    d: "M598.368,10.9s-1.125-.209-1.108.727c0,.3.076.4.312.465a2.208,2.208,0,0,1,1.118.458,1.023,1.023,0,0,1,.437.84,1.034,1.034,0,0,1-.1.422l.257,1.239.257.915.767-.437.44-1.365-.572-2.445Z",
    transform: "translate(-547.167 7.774)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7698",
    "data-name": "Caminho 7698",
    d: "M598.379,10.916l.005-.029a1.4,1.4,0,0,0-.259-.022,1.1,1.1,0,0,0-.566.132.672.672,0,0,0-.317.626v.021a.664.664,0,0,0,.074.336.391.391,0,0,0,.255.161c.125.033.3.057.5.113a1.5,1.5,0,0,1,.617.333,1.465,1.465,0,0,1,.362.466.871.871,0,0,1,.06.353.758.758,0,0,1-.051.279.567.567,0,0,1-.033.093l0,.021-.007.017H599l.261,1.258.269.957.8-.465.459-1.385-.581-2.47-1.822-.823h-.007l-.005.029-.012.027,1.795.811.561,2.426-.437,1.341-.722.413-.238-.876-.259-1.243-.032.012.027.012a.961.961,0,0,0,.04-.816,1.484,1.484,0,0,0-.377-.485,1.7,1.7,0,0,0-.635-.346c-.2-.058-.384-.079-.5-.115a.391.391,0,0,1-.225-.129.606.606,0,0,1-.057-.305v-.021a.6.6,0,0,1,.282-.569,1.087,1.087,0,0,1,.54-.122,1.173,1.173,0,0,1,.186.012h.047l.014.005.007-.033-.012.027Z",
    transform: "translate(-547.179 7.761)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7699",
    "data-name": "Caminho 7699",
    d: "M599.406,15.517a.874.874,0,0,0,.49-.465c.027-.089-.395-.471-.41-.471a1.833,1.833,0,0,1,.325.206c.108.093.184.132.216.113s.213-.427.141-.519a1.439,1.439,0,0,0-.345-.417.65.65,0,0,0-.377-.093.74.74,0,0,1,.449-.012c.152.084.165.182.18.149a1.723,1.723,0,0,0-.1-.6.356.356,0,0,0-.317-.242,1.964,1.964,0,0,0-.377-.024.794.794,0,0,1,.461-.1c.2.051.2.149.212.129a2.233,2.233,0,0,0-.144-.478,1.036,1.036,0,0,0-.35-.293,1.611,1.611,0,0,0-.281-.027h-.1a.575.575,0,0,1,.341-.084.5.5,0,0,1,.228.072c.032-.012-.023-.039-.139-.123s-.675-.317-.675-.317l-.515-.009a.142.142,0,0,1,.14-.149c.15-.027.194.012.189-.027a2.14,2.14,0,0,0-.437-.132s-.249.01-.35.019-.482.048-.482.048a.462.462,0,0,1,.1-.156.771.771,0,0,1,.218-.1c.171-.045-.1-.175-.1-.175l.147-.214.623.055,1.313.77.623.538.394,1-.118,1.721-.886.732a3,3,0,0,1-.389.043c0-.015.1-.369.1-.369",
    transform: "translate(-547.083 7.879)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7700",
    "data-name": "Caminho 7700",
    d: "M598.272,11.329a1.048,1.048,0,0,1-.036-.273c0-.149.02-.146.02-.146a1.026,1.026,0,0,0-.726.185.608.608,0,0,0-.133.67.916.916,0,0,1,.305-.2,1.418,1.418,0,0,1,.482-.057c.027-.027-.062-.147-.179-.177a1.991,1.991,0,0,0-.339-.027.565.565,0,0,1,.348-.067c.233.022.258.087.258.087",
    transform: "translate(-547.104 7.788)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7701",
    "data-name": "Caminho 7701",
    d: "M599.233,15.939l-.285.1.173,1.2,1.138,1.954.6-.1.2-.362a.247.247,0,0,1,.16.072c.062.069.293.449.481.53s.281.045.446.185a9.62,9.62,0,0,1,.807,1.077c.033.034-.029-.387-.029-.387l-.187-.545-.229-.384-.036-.094h.314l.2.122.3.245.162.192.081.189.033.165.081.261.17.362.2.345.065-.144-.1-.4-.305-.975-.19-.336a2.439,2.439,0,0,0,.317.2,2.009,2.009,0,0,1,.289.362l.141.341.1.324.072.278.1.3.174-.1-.028-.218-.152-.669-.068-.723a.28.28,0,0,1,.191.11,1.481,1.481,0,0,1,.194.372l.077.658.1.6.2.619.209.384.128.214s.007-.3.007-.317-.248-2.57-.248-2.57l.029-.108s.032-.014.116.108a1.986,1.986,0,0,1,.171.312l.069.4.039.278.053.521.069.564.267.609.134.326.081-.389-.125-2.746.057-.079a1.275,1.275,0,0,1,.2.2.656.656,0,0,0,.14.168l.087.61.072,1.726.061.453.51-4.539.313-.072.037-.081-.227-.177-.521-.806-.345-.771-.61-1.123-1.059-1.3s-.655-.561-.825-.686a3.188,3.188,0,0,0-.3-.206l.053-.159.173-.286-.027-.007-.137.007-.354.046-.352-.106-.707-.485-.751-.362-.438-.156-1.062-.273-1.06-.141-.475-.005-.432.081a.66.66,0,0,0-.289.226.652.652,0,0,0-.053.429c.022.2.14.3.442.425a9.236,9.236,0,0,1,.992.586l.333.338.128.165.019.129L600,14.806l-.448.969Z",
    transform: "translate(-546.743 7.603)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7702",
    "data-name": "Caminho 7702",
    d: "M599.325,15.765a.287.287,0,0,0,.465.077c.274-.254-.12-.963-.115-1s.127-.057.127-.057l.194.365a.833.833,0,0,1,.078.511,1.2,1.2,0,0,1-.347.59l-.348-.081Z",
    transform: "translate(-545.691 10.558)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7703",
    "data-name": "Caminho 7703",
    d: "M603.756,20.221l-.236-.725s-.072-.466-.072-.562-.05-1.27-.074-1.49-.01-.482-.031-.514-.269-.353-.269-.353l-.1-.1.068-.057s.1.1.116.045a1.889,1.889,0,0,0-.1-.713,8.994,8.994,0,0,0-.61-1.339l.048.041.146.146.308.24.65.242.355.063.228.454a7.791,7.791,0,0,1,.16,1.191,3.217,3.217,0,0,1-.192,1.116,10.658,10.658,0,0,0-.212,1.862,2,2,0,0,1-.1.4Z",
    transform: "translate(-543.465 10.291)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7704",
    "data-name": "Caminho 7704",
    d: "M603.45,17.813a1.118,1.118,0,0,0,.2-.393,6.078,6.078,0,0,0-.126-2.2,1.633,1.633,0,0,0-.656-.374,5.27,5.27,0,0,0,.172.573,1.184,1.184,0,0,1,.125.226.952.952,0,0,1,.089.285,4.577,4.577,0,0,1,.172.967c.021.463.021.915.021.915",
    transform: "translate(-543.159 10.605)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7705",
    "data-name": "Caminho 7705",
    d: "M603.278,19.348a9.96,9.96,0,0,0,.052-1.44,1.775,1.775,0,0,0-.151-.8,4.888,4.888,0,0,1-.415-1,4.448,4.448,0,0,0-.32-1.006c-.1-.1-.282-.321-.322-.257a.431.431,0,0,0-.04.185l-.252-.072-.053-.158.074-.261-.012-.111-.029-.182.323.254.667.458.331,1.377.307.859.049,1.449-.032,1.281Z",
    transform: "translate(-543.941 10.17)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7706",
    "data-name": "Caminho 7706",
    d: "M602.879,14.9a2.388,2.388,0,0,0,.278.221c.1.057.288.173.249.189a.92.92,0,0,1-.325-.122.64.64,0,0,1-.184-.147Z",
    transform: "translate(-543.153 10.645)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7707",
    "data-name": "Caminho 7707",
    d: "M602.7,18.914a1.687,1.687,0,0,0,.113-.658,8.3,8.3,0,0,0-.253-1.38A3.336,3.336,0,0,1,602,16.1a4.026,4.026,0,0,0-.371-.79c-.156-.185-.314-.389-.314-.389l.038-.538.581.295.252.123.29,1.4.262.4.108.562.139,1.306.073,1.044-.037.082Z",
    transform: "translate(-544.267 10.272)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7708",
    "data-name": "Caminho 7708",
    d: "M602.431,18.214a2.875,2.875,0,0,0-.093-.787,2.144,2.144,0,0,0-.288-.758,5.629,5.629,0,0,1-.667-.809,9.236,9.236,0,0,0-.619-.8l0-.521a1.759,1.759,0,0,0,.317.226c.152.07.372.2.372.2l.152.6.2.435.286.387.192.168.113.651.068.367.153.518-.05.261Z",
    transform: "translate(-544.663 10.382)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7709",
    "data-name": "Caminho 7709",
    d: "M602.358,18.091l-.165-.149a.374.374,0,0,0,.052-.314,2.807,2.807,0,0,0-.192-.6,1.938,1.938,0,0,0-.18-.37c-.057-.063-.547-.525-.718-.665s-.427-.406-.586-.509a.976.976,0,0,0-.282-.134l-.093-.641a1.465,1.465,0,0,0,.341.329c.129.055.338.115.338.115l.452.8.152.213.422.334.177.345.122.4.159.554.027.334Z",
    transform: "translate(-545.071 10.509)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7710",
    "data-name": "Caminho 7710",
    d: "M601.557,17.59a1.712,1.712,0,0,1-.312-.5c-.038-.2.031-.2-.05-.425a2.2,2.2,0,0,0-.6-.746c-.225-.178-.553-.449-.53-.595s.06-.156.06-.156l.137.115.715.768.228.393.158.506.117.226.1.3Z",
    transform: "translate(-545.162 10.833)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7711",
    "data-name": "Caminho 7711",
    d: "M603.131,15.692s.494.61.617.048a1.6,1.6,0,0,0-.167-.727s-.458-.806-.617-1-.924-1.173-.924-1.173l-.557-.255.187.324a6.9,6.9,0,0,1,.956,1.341,2.261,2.261,0,0,1,.426,1.421Z",
    transform: "translate(-544.151 8.99)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7712",
    "data-name": "Caminho 7712",
    d: "M601,12.246a11.254,11.254,0,0,1,1.613,1.738c.627.907.883,1.512.736,1.63s-.536-.07-.695-.322a6.334,6.334,0,0,0-.891-1.373,2.712,2.712,0,0,0-.883-.778l-.426-.694Z",
    transform: "translate(-544.886 8.747)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7713",
    "data-name": "Caminho 7713",
    d: "M600.475,13.638a12.376,12.376,0,0,1,.936.874,6.216,6.216,0,0,1,.56.67l.237.226s-.148-.238-.067-.326a.155.155,0,0,1,.173-.041L600.475,13.1Z",
    transform: "translate(-544.871 9.361)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7714",
    "data-name": "Caminho 7714",
    d: "M600.588,13.445a2.8,2.8,0,0,0,.489.662c.312.3.649.631.649.631l.132.461s-.842-.641-.845-.485a1.286,1.286,0,0,0,.2.485l-.259-.132-.35-.514-.218-.446-.238-.61Z",
    transform: "translate(-545.101 9.604)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7715",
    "data-name": "Caminho 7715",
    d: "M598.924,16.72s.43.393.675.012a.969.969,0,0,0,.059-.819s.615.909.789.057c.028-.156-.382-.746-.382-.746l.147-.137.311.526a.551.551,0,0,0,.3-.5,1.985,1.985,0,0,0-.305-.835l.293.322s.566.012.576-.338-.48-.711-.48-.711.395.029.387-.2-.529-.386-.54-.535a.267.267,0,0,1,.395-.252c.238.135.57.243.709-.021s-.01-.31-.01-.31-.307-.067-.338-.079-.547-.285-.547-.285l-.44-.166-.44-.058.166.333.113.915v.423l.091.924-.225.766-.113.137-.079.1-.19.4-.267.29-.343.434Z",
    transform: "translate(-545.979 8.319)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7716",
    "data-name": "Caminho 7716",
    d: "M601.136,15.885a1.232,1.232,0,0,0-.35-.461,1.171,1.171,0,0,0-.614-.2l.646.677Z",
    transform: "translate(-545.087 10.876)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7717",
    "data-name": "Caminho 7717",
    d: "M601.692,16.222a3.4,3.4,0,0,0-.452-.67c-.242-.254-.407-.583-.47-.583a.567.567,0,0,0-.116.012l.067.526.442.43s.422.312.53.285",
    transform: "translate(-544.743 10.692)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7718",
    "data-name": "Caminho 7718",
    d: "M602.048,16.352a4.225,4.225,0,0,0-.35-.951,2.013,2.013,0,0,0-.509-.653l.06.494.2.482.322.473Z",
    transform: "translate(-544.36 10.534)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7719",
    "data-name": "Caminho 7719",
    d: "M602.264,16.188a3.266,3.266,0,0,0,.019-1.269.715.715,0,0,0-.452-.329l-.1.147.1.7.236.55Z",
    transform: "translate(-543.971 10.421)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7720",
    "data-name": "Caminho 7720",
    d: "M602.432,14.561a.968.968,0,0,1,.321.41,7.545,7.545,0,0,1,.425,1.383c-.008.046-.091.036-.12.026s-.623-.955-.623-.955l-.1-.879Z",
    transform: "translate(-543.541 10.39)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7721",
    "data-name": "Caminho 7721",
    d: "M599.957,15.839s.312-.065.312-.173-.377-.336-.344-.513c.017-.093.322.012.344-.051s-.315-.6-.212-.715.389.574.389.574a.854.854,0,0,1,.106.516c-.19.567-.595.362-.595.362",
    transform: "translate(-545.265 10.266)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7722",
    "data-name": "Caminho 7722",
    d: "M600.381,15.354c.019-.048.5.063.5.029.023-.113-.431-.466-.431-.466s-.111-.194-.077-.226.322.033.341-.012-.336-.5-.336-.593.1-.007.1-.007a3.87,3.87,0,0,1,.419.518,1.033,1.033,0,0,1,.236.8c-.051.4-.795.087-.75-.041",
    transform: "translate(-544.946 10.034)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7723",
    "data-name": "Caminho 7723",
    d: "M601.826,14.644s-.077-.322-.027-.369a.587.587,0,0,1,.171-.077,1.249,1.249,0,0,0-.38-.165c-.129-.007-.146-.039-.174.015s.218.37.218.37Z",
    transform: "translate(-544.2 10.013)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7724",
    "data-name": "Caminho 7724",
    d: "M600.791,14.817a3.514,3.514,0,0,0,.782.129c.033-.051-.6-.631-.6-.631a.59.59,0,0,1-.033-.144c.013-.039.273-.048.356.017s0,.187.026.235.256.4.3.353-.053-.5-.027-.533.281.249.356.3.49.374.535.221.063-.177.051-.269.14.422-.051.487a.62.62,0,0,1-.422-.069l-.177-.129-.094-.111s.106.4-.025.444a.711.711,0,0,1-.275.021l-.316-.039Z",
    transform: "translate(-544.645 10.1)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7725",
    "data-name": "Caminho 7725",
    d: "M595.508,14.752h0a4.878,4.878,0,0,1-1.044-.019c-.229-.038-.338-.415-.329-1.109.007-.057.007-.069,0-.072a.152.152,0,0,0-.025-.051.664.664,0,0,1-.187-.482c.039-.238.821-.873.925-.9a.387.387,0,0,1,.214.043l.006.005.013-.012a.887.887,0,0,1,.245-.19c.029,0,.064.034.092.077.012.017.021.045.012.057s-.051.045-.081.077c-.1.067-.221.171-.236.255-.007.038-.007.077-.012.12a.525.525,0,0,1-.06.238.97.97,0,0,1-.088.12,1.025,1.025,0,0,0-.165.269c0,.015-.012.043-.012.06-.021.072-.034.149.043.18a.9.9,0,0,0,.565-.091,1.024,1.024,0,0,0,.278-.185c.024-.017.044-.039.055-.041h-.007l0-.01a.708.708,0,0,1-.365.357,2.242,2.242,0,0,0-.214.1.658.658,0,0,1-.305.1l-.015-.01-.007.022a.289.289,0,0,0,.012.242.337.337,0,0,0,.288.125,1.538,1.538,0,0,0,.662-.094l-.027-.024-.246.859Zm.24-.847h0a1.6,1.6,0,0,1-.642.087.333.333,0,0,1-.259-.1.266.266,0,0,1-.007-.216l-.021.021a.656.656,0,0,0,.326-.113c.06-.027.132-.067.212-.1a.711.711,0,0,0,.39-.393.03.03,0,0,0-.017-.026c-.023,0-.043.012-.095.05a1.028,1.028,0,0,1-.266.178.936.936,0,0,1-.535.094c-.051-.026-.039-.062-.015-.142a.24.24,0,0,1,.008-.058.813.813,0,0,1,.153-.254c.032-.045.067-.084.093-.123a.555.555,0,0,0,.066-.259c.005-.039.005-.079.012-.111.008-.072.134-.168.218-.233.055-.045.087-.072.092-.087a.109.109,0,0,0-.017-.1c-.027-.041-.072-.091-.12-.091s-.24.163-.269.2l.017-.007a.444.444,0,0,0-.239-.039c-.111.036-.906.674-.955.934a.784.784,0,0,0,.193.511.178.178,0,0,0,.027.036v.063c0,.269-.027,1.077.356,1.149a5.313,5.313,0,0,0,1.05.022l.016,0v-.012l.252-.859.009-.036Z",
    transform: "translate(-549.584 8.516)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7726",
    "data-name": "Caminho 7726",
    d: "M601.791,14.629s.8.473.876.393-.209-1.207-.161-1.327c.032-.093.646,1.272.345,1.464-.222.141-.333.041-.333.041l-.391-.209Z",
    transform: "translate(-543.93 9.779)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7727",
    "data-name": "Caminho 7727",
    d: "M603.086,15.409a.529.529,0,0,0,.168.081c.033.009.125.043.1.043a2.051,2.051,0,0,0-.232.033.843.843,0,0,1-.041-.156",
    transform: "translate(-543.005 11.006)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7728",
    "data-name": "Caminho 7728",
    d: "M602.633,13.873a.665.665,0,0,0,.125.057.222.222,0,0,1,.1.055.14.14,0,0,1-.1.026c-.043-.009-.069-.015-.069-.015Z",
    transform: "translate(-543.329 9.909)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7729",
    "data-name": "Caminho 7729",
    d: "M602.6,13.807a.209.209,0,0,0,.183-.039c.106-.074.115-.122.106-.166s-.176-.036-.233-.075a.111.111,0,0,1-.048-.1l-.182-.005-.063.026Z",
    transform: "translate(-543.523 9.589)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7730",
    "data-name": "Caminho 7730",
    d: "M602.91,14.992a1.9,1.9,0,0,0,.311.156c.067.017.18.077.163.1a.414.414,0,0,1-.281-.015c-.093-.057-.12-.021-.12-.021Z",
    transform: "translate(-543.131 10.709)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7731",
    "data-name": "Caminho 7731",
    d: "M602.259,12.885h.007a.162.162,0,0,0,.089.012c.051-.005.089-.033.1-.017a.242.242,0,0,1-.06.257.379.379,0,0,1-.158.081c-.012,0-.255-.35-.255-.35Z",
    transform: "translate(-543.791 9.191)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7732",
    "data-name": "Caminho 7732",
    d: "M601.584,12.3s.159-.009.24-.009a.458.458,0,0,1,.242.1,1.092,1.092,0,0,1,.108.617c-.042.093-.577-.312-.589-.351s-.252-.394-.252-.394Z",
    transform: "translate(-544.259 8.759)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7733",
    "data-name": "Caminho 7733",
    d: "M601.322,12.4s.393.024.356-.228a.518.518,0,0,0-.22-.353l-.462.329Z",
    transform: "translate(-544.498 8.44)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7734",
    "data-name": "Caminho 7734",
    d: "M600.577,12.1a.282.282,0,0,0,.225.015c.114-.048.418-.449.643-.494s.268-.045.312,0a.45.45,0,0,1-.027.345,5.446,5.446,0,0,1-.706.338,1.855,1.855,0,0,1-.24-.033,1.284,1.284,0,0,1-.211-.072Z",
    transform: "translate(-544.801 8.278)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7735",
    "data-name": "Caminho 7735",
    d: "M600.651,11.6c-.1-.23-.272-.324-.341-.3s.225.238.265.559a2.576,2.576,0,0,1,.032.545c-.007.015.134.021.134.021l.031-.12.013-.087v-.07l-.02-.171-.036-.129-.024-.1a1.547,1.547,0,0,0-.053-.146",
    transform: "translate(-544.995 8.064)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7736",
    "data-name": "Caminho 7736",
    d: "M600.33,11.53a2.439,2.439,0,0,0-.876-.6c-.032,0,.634.406.78.662s.159.61.228.655.128-.021.135-.029.054-.084.046-.1-.044-.166-.044-.166l-.1-.171-.057-.111Z",
    transform: "translate(-545.601 7.806)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7737",
    "data-name": "Caminho 7737",
    d: "M600.444,11.276a2.68,2.68,0,0,0-1.625-.5c-.547-.007-.835.038-.75.35s.325.434.795.434a2.658,2.658,0,0,1,.838.027,1.667,1.667,0,0,1,.575.317,2.387,2.387,0,0,0-.415-.408c-.235-.178-.4-.278-.4-.278s-.048-.1.276-.051a1.219,1.219,0,0,1,.872.525.919.919,0,0,1,.1.475c0,.057.111-.036.111-.036L600.87,12a.347.347,0,0,0-.045-.228,1.171,1.171,0,0,0-.216-.329c-.149-.177-.165-.17-.165-.17",
    transform: "translate(-546.6 7.695)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7738",
    "data-name": "Caminho 7738",
    d: "M598.559,15.072a1.3,1.3,0,0,0,.844-1.089A5.368,5.368,0,0,0,599,11.946c-.093-.137.141-.063.274.072a3.993,3.993,0,0,1,.393,1.711,1.308,1.308,0,0,1-.487,1.188.838.838,0,0,1-.638.3Z",
    transform: "translate(-546.254 8.48)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7739",
    "data-name": "Caminho 7739",
    d: "M599.036,16.155s.12.146.245.1c.245-.091.625-.267.625-.617,0-.23-.29-.425-.309-.507a.858.858,0,0,1,0-.163l.257.063.072.357a.23.23,0,0,0,.208.069c.1-.048.4-.264.358-.48s-.325-.466-.356-.574a.4.4,0,0,1,.007-.2l.249.043.068.31a.2.2,0,0,0,.209.082c.135-.031.382-.285.325-.4s-.233-.4-.249-.429a.384.384,0,0,1,0-.137l.1.057a.4.4,0,0,0,.277-.021c.185-.051.374-.182.374-.312s-.144-.25-.154-.322a.207.207,0,0,1,0-.1l.122.021.156.189.032.225-.053.194-.231.249-.23.1-.06-.009.137.245-.044.317-.2.189-.269.156-.013.3-.153.324-.345.2h-.1l-.044.192-.213.31-.374.247-.273.057-.159-.231Z",
    transform: "translate(-545.912 9.257)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7740",
    "data-name": "Caminho 7740",
    d: "M600.258,13.467s.629.173.61-.221c-.016-.228-.617-.739-.65-.823a.393.393,0,0,1-.032-.2l.312.281s.4.1.505-.129.024-.377.005-.384.1-.014.1-.014l.177.033-.019.353-.2.891s.057.35-.225.37a1.072,1.072,0,0,1-.578-.161",
    transform: "translate(-545.078 8.558)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7741",
    "data-name": "Caminho 7741",
    d: "M600.818,15.853a.42.42,0,0,0-.132-.309,2.264,2.264,0,0,0-.449-.273c-.046-.026.444.554.444.554Z",
    transform: "translate(-545.042 10.908)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7742",
    "data-name": "Caminho 7742",
    d: "M601.43,16.017a5.151,5.151,0,0,1-.382-.511c-.072-.139-.237-.425-.364-.437s.12.478.12.478l.509.47Z",
    transform: "translate(-544.747 10.763)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7743",
    "data-name": "Caminho 7743",
    d: "M601.918,16.183s-.269-.511-.336-.658a1.916,1.916,0,0,0-.365-.662c-.153-.113.022.183.022.183l.17.526.3.454Z",
    transform: "translate(-544.384 10.598)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7744",
    "data-name": "Caminho 7744",
    d: "M602.125,15.941a5.894,5.894,0,0,0-.069-.739,1,1,0,0,0-.3-.542,4.539,4.539,0,0,0,.019.533Z",
    transform: "translate(-543.96 10.471)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7745",
    "data-name": "Caminho 7745",
    d: "M603,16.193s-.221-.521-.3-.768a3.074,3.074,0,0,0-.336-.665,3.77,3.77,0,0,0,.072.473l.264.763Z",
    transform: "translate(-543.529 10.543)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7746",
    "data-name": "Caminho 7746",
    d: "M604.016,15.034a1.926,1.926,0,0,0-.638-.374,3.161,3.161,0,0,0-.864-.192l.057.063.2.165.446.233.593.144Z",
    transform: "translate(-543.414 10.334)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7747",
    "data-name": "Caminho 7747",
    d: "M600.829,14.946a1.088,1.088,0,0,0,.2.614c.2.225.657.65.742.727a5.908,5.908,0,0,1,.305.946c.137.382.165.706.225.811s.18.286.093.266a.4.4,0,0,1-.237-.266c-.053-.135-.038-.135-.025-.327a3.678,3.678,0,0,0-.437-1.3,6.35,6.35,0,0,1-1.02-1.011c-.249-.358-.2-.451-.2-.451Z",
    transform: "translate(-544.875 10.676)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7748",
    "data-name": "Caminho 7748",
    d: "M602.092,17.261a3.006,3.006,0,0,1-.2-.694,2.483,2.483,0,0,0-.708-.679c-.1-.043-.3.017-.385-.051s-.589-.638-.589-.638-.074.07-.053.091.558.6.748.78a3.107,3.107,0,0,1,.431.907c.137.317.084.254.1.41s.107.245.211.245.118-.045.082-.07a1.674,1.674,0,0,1-.347-.564,4.254,4.254,0,0,0-.4-.972.423.423,0,0,0-.044-.045c.044,0,.108-.021.208-.021a1.765,1.765,0,0,1,.707.626,2.187,2.187,0,0,0,.221.682,2.493,2.493,0,0,0,.321.595h.044s-.2-.326-.337-.6",
    transform: "translate(-545.103 10.856)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7749",
    "data-name": "Caminho 7749",
    d: "M600.791,14.535a4.008,4.008,0,0,0,.509.269,1.213,1.213,0,0,0,.2.048,2.571,2.571,0,0,0,.338,1.1,2.046,2.046,0,0,0,.509.545,4.4,4.4,0,0,0,.216,1.291,2.829,2.829,0,0,1,.208,1.27c-.051.1-.228-.312-.344-.677s-.228-.759-.3-1a2.069,2.069,0,0,0-.41-.71c-.121-.1-.019-.089.044-.027a1.818,1.818,0,0,1,.4.718c.132.408.187.819.252.823a.132.132,0,0,0,.125-.149c0-.081-.093-.29-.155-.674a3.37,3.37,0,0,0-.191-.742,2.69,2.69,0,0,1-.395-.55,2.93,2.93,0,0,1-.4-.85c-.041-.2.007-.178-.029-.209a1.392,1.392,0,0,1-.257-.1.978.978,0,0,1-.324-.369",
    transform: "translate(-544.645 10.382)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7750",
    "data-name": "Caminho 7750",
    d: "M601.378,14.449a2.56,2.56,0,0,0,.365.24,1.073,1.073,0,0,0,.329.069,2.2,2.2,0,0,0,.207,1.1,3.676,3.676,0,0,0,.536.693s.038.161.121,1.085.086.955.113,1.329a11.136,11.136,0,0,1-.015,1.661c-.2-.161-.039-.878-.137-1.176a4.183,4.183,0,0,1-.458-1.183c-.2-.843-.066-1.032-.207-1.342s-.322-.345-.322-.345a.553.553,0,0,1,.367.314c.108.261.123.963.21,1.317a4.019,4.019,0,0,0,.466,1.179s-.057-.982-.132-1.546a7.274,7.274,0,0,0-.177-1.239c-.108-.218-.333-.389-.463-.675a9.082,9.082,0,0,1-.255-.991c-.062-.147-.1-.1-.2-.139a.532.532,0,0,1-.35-.346",
    transform: "translate(-544.225 10.321)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7751",
    "data-name": "Caminho 7751",
    d: "M601.791,14.238a2.422,2.422,0,0,0,.5.394,1.369,1.369,0,0,0,.481.163,2.923,2.923,0,0,0,.246,1.176c.308.543.423.554.425.631s.06,1.687.1,2.235.079,2.376-.146,2.376-.024-1.353-.139-1.677a3.154,3.154,0,0,0-.21-.473c-.112-.254-.106-1.26-.28-1.848-.125-.449-.257-.518-.257-.518a.775.775,0,0,1,.312.478c.1.369.137,1.6.257,1.8a2.914,2.914,0,0,1,.322.619c.036.189-.029-2.337-.077-2.493a6.712,6.712,0,0,1-.595-1.569c-.047-.5-.063-.555-.1-.588a.988.988,0,0,1-.434-.237,3.348,3.348,0,0,1-.41-.473",
    transform: "translate(-543.93 10.17)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7752",
    "data-name": "Caminho 7752",
    d: "M602.462,14.409a2.066,2.066,0,0,0,.61.446,5.584,5.584,0,0,0,.946.2,3.59,3.59,0,0,1,.354,1.644,5.143,5.143,0,0,1-.293,1.6c-.143.782-.148,2.383-.235,2.618a1.2,1.2,0,0,0-.141.285c-.045.149.04.446-.1.449s-.158-.225-.158-.345a7.045,7.045,0,0,0,.146-.987,6.441,6.441,0,0,0-.155-1c-.062-.518-.069-2.172-.126-2.328a3.224,3.224,0,0,0-.341-.5,1,1,0,0,1,.38.42c.068.221.074,2.055.165,2.421s.049-.087.083-.3a11.561,11.561,0,0,0,.126-1.589,4.676,4.676,0,0,0-.386-1.7,1.284,1.284,0,0,1,.18.333.716.716,0,0,0,.13.1c.075.043.153.063.16.072a.453.453,0,0,1-.165-.039.591.591,0,0,1-.092-.065,4,4,0,0,1,.218,1.3,17.843,17.843,0,0,0,.005,2.643c.13.017.1-.986.244-1.8a5.478,5.478,0,0,0,.26-1.6A3.2,3.2,0,0,0,603.9,15.2a4.234,4.234,0,0,1-.892-.281c-.356-.23-.554-.466-.542-.514",
    transform: "translate(-543.451 10.289)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7753",
    "data-name": "Caminho 7753",
    d: "M599.109,17.2a.369.369,0,0,0,.276-.015c.154-.074.559-.391.559-.523s0-.269,0-.269.008.062.115.077a.663.663,0,0,0,.475-.393,1.484,1.484,0,0,0-.009-.5c-.039-.057.1.06.165,0s.384-.273.381-.482a.755.755,0,0,0-.18-.406,1.134,1.134,0,0,0,.251,0c.09-.024.41-.207.4-.4s-.12-.487-.365-.506a.684.684,0,0,0,.358-.021.328.328,0,0,0,.24-.365,1.486,1.486,0,0,0-.425-.675c-.061-.039.385.125.5-.048a.48.48,0,0,0,.1-.408.192.192,0,0,0-.125-.129.707.707,0,0,0,.451-.081c.264-.129.494-.309.617-.3s-.386.266-.413.422c-.012.057.14.158.369.326.014.012.014.021.044.029a3.223,3.223,0,0,0,.515.1c.032.019-.374.015-.345.043a4.961,4.961,0,0,1,.919.861.4.4,0,0,0,.153.094c.089.026.2.017.208.033s-.269-.007-.26.012a8.132,8.132,0,0,1,.533.753.424.424,0,0,0,.141.12c.084.036.176.027.186.043.018.036-.222,0-.207.036.309.5.535.963.535.963a10.476,10.476,0,0,0-1.1-1.538c-.6-.67-.734-.761-.766-.694a11.579,11.579,0,0,0,.7,1.073,8.489,8.489,0,0,1,.484.938,7.7,7.7,0,0,0-1.438-2.018c-.847-.768-.935-.895-1.034-.864a1.144,1.144,0,0,0-.1.715c.055.117.674.583,1.2,1.2a16.635,16.635,0,0,1,1.188,1.68,11.14,11.14,0,0,0-1.271-1.618c-.8-.852-1.107-1.044-1.174-1.041s-.069.156-.163.285-.285.113-.292.17a5.192,5.192,0,0,0,.815.763c.137.075.208.036.31.091a2.2,2.2,0,0,1,.223.158s-.151-.051-.249-.089-.216-.036-.216,0a5.165,5.165,0,0,0,.65.747c.1.041.146.024.272.069a1.8,1.8,0,0,1,.3.177,1.536,1.536,0,0,0-.329-.137c-.136-.027-.2,0-.192.036s.422.574.4.581-.644-.741-1.176-1.21-.77-.571-.8-.559-.012.156-.144.2-.252.069-.252.12.482.5.819.867.634.73.634.73-.342-.348-.72-.694c-.377-.362-.569-.5-.608-.477a.344.344,0,0,0,0,.252c.034.045.728.864.706.883s-.82-.979-.869-.979-.087.125-.142.182-.271.06-.271.139,1.125,1.188,1.1,1.214a8.922,8.922,0,0,0-.966-.759c-.034.051.393.823.366.838s-.547-.807-.6-.806-.036.1-.18.219c-.127.12-.3.069-.31.12s.784.921.759.933-.792-.823-.811-.778a.147.147,0,0,0-.029.129c.06.2.227.573.216.6,0,0-.261-.514-.327-.494s-.062.125-.186.2-.206.055-.209.1c-.019.058.134.151.193.271a1.806,1.806,0,0,1,.117.389,1.483,1.483,0,0,0-.188-.367c-.113-.142-.21-.235-.293-.235a.2.2,0,0,0-.141.077Z",
    transform: "translate(-545.846 8.406)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7754",
    "data-name": "Caminho 7754",
    d: "M604.833,16.936s.258-.015.285-.065-.093-.012-.317-.267-.814-1.947-1.457-2.8a9.108,9.108,0,0,0-2.026-2.038,7.262,7.262,0,0,1,2.067,2c.919,1.337,1.14,2.39,1.4,2.662s.5.326.49.406a.17.17,0,0,1-.153.144c-.1.012-.334.036-.334.036Z",
    transform: "translate(-544.268 8.405)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7755",
    "data-name": "Caminho 7755",
    d: "M598.871,17.091s.012.024.057.024.365-.305.35-.394a.88.88,0,0,1-.258-.175.566.566,0,0,1-.137-.305.818.818,0,0,0,.192.269c.089.058.23.087.281.048s.514-.389.49-.526a.492.492,0,0,1-.288-.093.541.541,0,0,1-.158-.309.6.6,0,0,0,.229.233.294.294,0,0,0,.312-.005c.04-.055.345-.473.305-.6a.449.449,0,0,1-.293-.079.779.779,0,0,1-.209-.346.476.476,0,0,0,.281.242.282.282,0,0,0,.345-.2c.029-.125.13-.6-.022-.718a.635.635,0,0,1-.395-.012.5.5,0,0,1-.219-.29.551.551,0,0,0,.32.213.259.259,0,0,0,.3-.147.919.919,0,0,0-.019-.487c-.06-.151-.168-.141-.2-.365,0,0-.055.089-.295.089s-.362-.269-.362-.269a.63.63,0,0,0,.381.161.287.287,0,0,0,.261-.293.962.962,0,0,0-.148-.343c-.057-.123-.062-.276-.1-.252s-.074.129-.322.089a.349.349,0,0,1-.293-.209.667.667,0,0,0,.31.12c.139-.015.225-.079.225-.168s-.05-.266-.355-.521-.557-.446-.557-.446a4.8,4.8,0,0,1,.649.437,2.419,2.419,0,0,1,.4.42s.284.093.312,0a.465.465,0,0,0-.056-.384,2.487,2.487,0,0,0-.33-.413,1.82,1.82,0,0,1,.371.425.685.685,0,0,1,.077.422c.011.051.537.255.657.18s.06-.221-.039-.377-.182-.285-.182-.285a1.752,1.752,0,0,1,.214.285c.091.156.159.281.127.346s-.1.106-.1.132a1.6,1.6,0,0,0,.361.219c.173.086.385.17.408.122a.684.684,0,0,0,.029-.346,2.3,2.3,0,0,0-.113-.434,1.707,1.707,0,0,1,.134.434c.022.182-.021.317.022.381s.169.081.169.081a.378.378,0,0,1-.333,0c-.237-.069-1.229-.564-1.272-.523s.459.358.693.578a1.838,1.838,0,0,1,.35.454,2.531,2.531,0,0,0-.362-.242,3.168,3.168,0,0,0-.742-.339c-.033.034.2.087.218.127s-.161.213-.161.278.757.6.73.655a.533.533,0,0,1-.219.189c-.033-.005-.41-.3-.41-.25s.216.225.216.269-.147.132-.117.218.422.417.417.526-.225.211-.184.279.242.326.242.326a2.235,2.235,0,0,1-.283-.225c-.076-.077-.223-.242-.24-.218a1.088,1.088,0,0,0-.153.4c.008.072.188.18.221.365a.639.639,0,0,1-.045.384c-.007,0-.261-.324-.312-.327a.157.157,0,0,0-.153.1c-.044.075-.19.338-.167.382s.269.1.269.3a.537.537,0,0,1-.171.377c-.017,0-.3-.384-.332-.384a2.322,2.322,0,0,0-.367.4c-.007.048.221.213.185.276s-.2-.021-.29.026a1.23,1.23,0,0,1-.28.115c-.026,0-.077-.108-.077-.108",
    transform: "translate(-546.016 7.879)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7756",
    "data-name": "Caminho 7756",
    d: "M603.755,12.609a.414.414,0,0,1,.075-.159c.05-.053.25-.281.173-.319s-.326.036-.49.021-.268.029-.741-.362a7.9,7.9,0,0,0-3.791-1.171c-.733-.041-1.059.216-1.092.353a1.2,1.2,0,0,1,.924-.285,8.044,8.044,0,0,1,3.845,1.135c.067.048.465.43.835.389s.454-.084.444-.031-.12.187-.147.252-.053.18-.053.18Z",
    transform: "translate(-546.717 7.582)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7757",
    "data-name": "Caminho 7757",
    d: "M599.682,12.46l-.006-.021a2.025,2.025,0,0,0-.423-.506,6.368,6.368,0,0,0-1.289-.684,8.26,8.26,0,0,1,1.245.732,4.256,4.256,0,0,1,.473.478",
    transform: "translate(-546.666 8.036)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7758",
    "data-name": "Caminho 7758",
    d: "M599.238,13.091a.834.834,0,0,0-.264-.228,1.472,1.472,0,0,0-.391-.178.863.863,0,0,1,.451.117.7.7,0,0,1,.2.29",
    transform: "translate(-546.222 9.061)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7759",
    "data-name": "Caminho 7759",
    d: "M599.184,12.552s-.057-.093-.345-.183a1.384,1.384,0,0,0-.35-.082.611.611,0,0,1,.461-.01.419.419,0,0,1,.233.276",
    transform: "translate(-546.288 8.737)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7760",
    "data-name": "Caminho 7760",
    d: "M599.1,12.148s-.057-.125-.312-.216a2.1,2.1,0,0,0-.423-.1.883.883,0,0,1,.507.027c.252.1.229.293.229.293",
    transform: "translate(-546.375 8.43)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7761",
    "data-name": "Caminho 7761",
    d: "M599.117,11.881s-.068-.1-.542-.209a3.822,3.822,0,0,0-.65-.117,3.327,3.327,0,0,1,.847.024,1.06,1.06,0,0,1,.345.3",
    transform: "translate(-546.692 8.241)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7762",
    "data-name": "Caminho 7762",
    d: "M598.652,11.524a3.837,3.837,0,0,0-.562-.1,5.482,5.482,0,0,0-.713.024,4.725,4.725,0,0,1,1.018-.084c.212.045.257.161.257.161",
    transform: "translate(-547.083 8.108)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7763",
    "data-name": "Caminho 7763",
    d: "M596.732,17.252a.539.539,0,0,0,.425.257c.281.012.5.41.5.41l-.311.312-.742.033-.243-.386Z",
    transform: "translate(-547.808 12.323)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7764",
    "data-name": "Caminho 7764",
    d: "M596.742,17.269l-.017.012a.847.847,0,0,0,.106.129.543.543,0,0,0,.336.141.54.54,0,0,1,.338.2c.044.057.084.1.111.144a.452.452,0,0,1,.024.045l0,.015.024-.015-.017-.012-.305.3-.718.036-.231-.365.363-.614-.019-.012-.017.012.017-.012-.017-.012-.377.641.257.406.76-.039.325-.321,0-.012a1.466,1.466,0,0,0-.15-.209.552.552,0,0,0-.37-.214.462.462,0,0,1-.305-.135.485.485,0,0,1-.076-.077.052.052,0,0,1-.017-.027l-.008-.012-.019-.029-.017.029Z",
    transform: "translate(-547.818 12.306)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7765",
    "data-name": "Caminho 7765",
    d: "M596.78,17.367a1.2,1.2,0,0,0-.394-.617c-.178-.077.059.159.021.255a.5.5,0,0,0-.052.238c.019.015.147.219.077.312s.348-.189.348-.189",
    transform: "translate(-547.839 11.954)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7766",
    "data-name": "Caminho 7766",
    d: "M596.787,17.376l.02,0v-.015a.35.35,0,0,0-.039-.132,2.308,2.308,0,0,0-.158-.281.6.6,0,0,0-.208-.209.111.111,0,0,0-.06-.019s-.016,0-.021.007a.038.038,0,0,0-.01.029.452.452,0,0,0,.01.055.731.731,0,0,1,.053.089.309.309,0,0,1,.024.091v.017a.621.621,0,0,0-.057.221.084.084,0,0,0,0,.033.494.494,0,0,1,.052.087.41.41,0,0,1,.041.144.079.079,0,0,1-.014.057l-.012.012-.007.015.012.021.019,0a.117.117,0,0,0,.038-.01,1.618,1.618,0,0,0,.192-.117c.068-.045.128-.086.128-.086l.007-.01,0,0-.02,0-.012-.019s-.077.048-.159.1c-.045.029-.083.053-.119.072a.22.22,0,0,0-.046.027l-.012,0v.019l.008-.015h-.008v.015l.008-.015-.008.015h.013l0-.015-.008.015h0l.012.005V17.58h-.012l.012.005h0l.007-.005a.123.123,0,0,0,.021-.084.416.416,0,0,0-.041-.161c-.024-.051-.052-.084-.057-.1l-.006.009.006-.009-.006.009.006-.009v-.007a.684.684,0,0,1,.057-.209v-.029a.332.332,0,0,0-.046-.141.371.371,0,0,1-.031-.063l-.016-.031-.012-.005.012.012v-.007l-.012-.005.012.012,0-.007v.007h0l0-.007v.007a.116.116,0,0,1,.039.015.841.841,0,0,1,.257.286c.036.069.072.135.093.183a.336.336,0,0,1,.038.113h0l.019.012-.012-.019Z",
    transform: "translate(-547.846 11.945)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7767",
    "data-name": "Caminho 7767",
    d: "M596.511,17.569a.364.364,0,0,0,.233.036.514.514,0,0,0,.2-.135",
    transform: "translate(-547.702 12.479)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7768",
    "data-name": "Caminho 7768",
    d: "M596.5,17.6a.491.491,0,0,0,.185.045.174.174,0,0,0,.067-.009.429.429,0,0,0,.206-.144l-.027-.026-.006.005a.449.449,0,0,1-.185.125.3.3,0,0,1-.055.007.483.483,0,0,1-.117-.021c-.015,0-.027-.01-.038-.012l-.01-.01Z",
    transform: "translate(-547.707 12.473)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7769",
    "data-name": "Caminho 7769",
    d: "M596.48,17.675s.419-.3.383-.463-.114-.153-.175-.144a1.207,1.207,0,0,0-.324.278,1.337,1.337,0,0,0,.117.329",
    transform: "translate(-547.808 12.188)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7770",
    "data-name": "Caminho 7770",
    d: "M596.488,17.684l.015.019a2.306,2.306,0,0,0,.192-.165.922.922,0,0,0,.134-.147.253.253,0,0,0,.068-.153.056.056,0,0,0,0-.024.268.268,0,0,0-.063-.129.11.11,0,0,0-.084-.036c-.017,0-.04.007-.057.009s-.044.027-.075.045c-.048.039-.11.084-.158.13-.026.022-.047.046-.072.065a.138.138,0,0,0-.032.048v.021a.279.279,0,0,0,.017.081,1.891,1.891,0,0,0,.1.245l.008.027.022-.017-.015-.019.021-.005-.06-.139a.816.816,0,0,1-.038-.1.321.321,0,0,1-.02-.069v-.012l.01-.019a2.025,2.025,0,0,1,.16-.141c.032-.026.064-.053.089-.069a.191.191,0,0,1,.051-.029.206.206,0,0,1,.044,0,.113.113,0,0,1,.061.015.276.276,0,0,1,.048.113v.012a.272.272,0,0,1-.055.129,1.115,1.115,0,0,1-.2.2.628.628,0,0,1-.091.069l-.029.027.009.017.021-.005Z",
    transform: "translate(-547.816 12.179)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7771",
    "data-name": "Caminho 7771",
    d: "M596.262,17.656s.072.2.209.2.325-.115.333-.192-.137-.233-.225-.276-.3.07-.3.07Z",
    transform: "translate(-547.879 12.416)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7772",
    "data-name": "Caminho 7772",
    d: "M596.271,17.663l-.021.012s.021.045.053.1a.221.221,0,0,0,.176.106.471.471,0,0,0,.229-.065.557.557,0,0,0,.085-.065.1.1,0,0,0,.04-.075.3.3,0,0,0-.087-.171.571.571,0,0,0-.149-.122.14.14,0,0,0-.056-.009.472.472,0,0,0-.177.036.84.84,0,0,0-.087.038l0,.007-.021.213v.009l.021-.012h.016l.023-.192-.023,0,.012.021a.044.044,0,0,1,.024-.012.54.54,0,0,1,.218-.063.07.07,0,0,1,.036.007.447.447,0,0,1,.14.117.25.25,0,0,1,.077.137.086.086,0,0,1-.032.045.465.465,0,0,1-.281.123.205.205,0,0,1-.144-.093l-.037-.067-.012-.021v-.007l-.016.007h0Z",
    transform: "translate(-547.888 12.409)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7773",
    "data-name": "Caminho 7773",
    d: "M596.724,17.483a.726.726,0,0,1-.377.189c-.081.012-.261-.207-.185-.24s.164-.029.225-.069.085-.12.125-.125a.207.207,0,0,1,.173.1c.031.06.059.086.04.149",
    transform: "translate(-547.964 12.313)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7774",
    "data-name": "Caminho 7774",
    d: "M596.735,17.491l-.021-.007a.193.193,0,0,1-.051.043,1.24,1.24,0,0,1-.158.1.653.653,0,0,1-.147.041.129.129,0,0,1-.053-.021.327.327,0,0,1-.088-.093.184.184,0,0,1-.045-.079v-.014c.072-.031.165-.027.237-.063a.49.49,0,0,0,.08-.081.1.1,0,0,1,.021-.033l.012-.012h.006a.29.29,0,0,1,.081.017.159.159,0,0,1,.065.057.186.186,0,0,0,.033.067.126.126,0,0,1,.011.041.088.088,0,0,1,0,.033l.021.007.018.005a.1.1,0,0,0,.009-.045.092.092,0,0,0-.02-.057.311.311,0,0,0-.028-.065.175.175,0,0,0-.087-.079.254.254,0,0,0-.1-.024h-.011a.069.069,0,0,0-.04.024c-.028.034-.048.084-.087.1-.06.031-.146.031-.23.06a.083.083,0,0,0-.033.057c.005.019.017.039.026.067a.416.416,0,0,0,.1.113.22.22,0,0,0,.108.057h.007a1.035,1.035,0,0,0,.218-.081c.039-.021.075-.041.107-.062a.18.18,0,0,0,.063-.07Z",
    transform: "translate(-547.975 12.305)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7775",
    "data-name": "Caminho 7775",
    d: "M596.586,17.595s-.408.554-.578.521.072-.787.072-.787a.662.662,0,0,0,.193.089c.14.039.276.1.312.177",
    transform: "translate(-548.103 12.378)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7776",
    "data-name": "Caminho 7776",
    d: "M596.6,17.608l-.012-.012s-.031.033-.069.081a3.59,3.59,0,0,1-.24.278c-.048.039-.1.079-.137.115a.223.223,0,0,1-.109.041h-.012c-.012,0-.021-.005-.027-.027a.208.208,0,0,1-.017-.094,1.69,1.69,0,0,1,.068-.4c.016-.069.033-.125.042-.166a.648.648,0,0,1,.024-.072l-.017-.009-.009.024a.577.577,0,0,0,.2.082,1.388,1.388,0,0,1,.19.072.216.216,0,0,1,.1.093l.019-.005-.012-.012.012.012.017,0a.215.215,0,0,0-.125-.12,1.181,1.181,0,0,0-.191-.07.969.969,0,0,1-.152-.063c-.018-.009-.026-.009-.033-.015l-.009-.005-.006,0-.014-.015-.012.031a2.825,2.825,0,0,0-.135.646.289.289,0,0,0,.012.108c.019.029.032.05.065.057h.018a.321.321,0,0,0,.173-.079,2.964,2.964,0,0,0,.41-.454l.007-.012-.007,0Z",
    transform: "translate(-548.113 12.365)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7777",
    "data-name": "Caminho 7777",
    d: "M595.9,17.254s.523.089.554.18-.257.2-.407.2-.147-.377-.147-.377",
    transform: "translate(-548.139 12.324)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7778",
    "data-name": "Caminho 7778",
    d: "M595.907,17.265l0,.024a.646.646,0,0,1,.08.015,2.665,2.665,0,0,1,.287.062c.042.015.084.027.12.043.015.012.027.017.039.026s.008.01.008.01v.005c0,.015-.008.027-.032.045a.71.71,0,0,1-.35.127c-.027,0-.048-.022-.072-.055a.49.49,0,0,1-.048-.189.383.383,0,0,1-.009-.081v-.033h-.019l0,.024,0-.024h-.021a1.333,1.333,0,0,0,.016.189.635.635,0,0,0,.044.137.126.126,0,0,0,.108.069.713.713,0,0,0,.263-.065.338.338,0,0,0,.111-.063.094.094,0,0,0,.05-.081l0-.015c0-.021-.022-.033-.04-.045a1.239,1.239,0,0,0-.312-.1l-.218-.045-.021-.007v.027Z",
    transform: "translate(-548.147 12.313)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7779",
    "data-name": "Caminho 7779",
    d: "M595.131,17.795a.356.356,0,0,0,.3.269c.226.015.441-.238.441-.238l-.538-.211Z",
    transform: "translate(-548.687 12.582)",
    fill: "#252725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7780",
    "data-name": "Caminho 7780",
    d: "M595.137,17.8l-.009,0a.474.474,0,0,0,.057.132.346.346,0,0,0,.249.149h.021a.707.707,0,0,0,.437-.245l.008-.019-.565-.218-.212.192.006.009.009,0,.007.009.2-.177.531.207.007-.009-.007-.01a.486.486,0,0,1-.044.043.574.574,0,0,1-.374.194h-.017a.309.309,0,0,1-.231-.134.386.386,0,0,1-.048-.087l0-.027,0-.014-.012.005.007.009Z",
    transform: "translate(-548.694 12.575)",
    fill: "#4b433c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7781",
    "data-name": "Caminho 7781",
    d: "M595.22,17.854a.428.428,0,0,0,.389.2.808.808,0,0,0,.533-.238l-.473-.375Z",
    transform: "translate(-548.624 12.455)",
    fill: "#252725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7782",
    "data-name": "Caminho 7782",
    d: "M595.226,17.862l-.011.007a.43.43,0,0,0,.4.2h.009a.8.8,0,0,0,.529-.242l.019-.015-.5-.389-.464.432,0,.012.011-.007.008.012.441-.413.467.369.007-.009-.01-.012-.005.012a.8.8,0,0,1-.509.226h-.009a.555.555,0,0,1-.3-.1.293.293,0,0,1-.057-.069c-.007-.009-.012-.014-.019-.014v-.012l-.013.005.008.012Z",
    transform: "translate(-548.63 12.446)",
    fill: "#4b433c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7783",
    "data-name": "Caminho 7783",
    d: "M595.242,17.706a.568.568,0,0,0,.29.117,1.628,1.628,0,0,0,.352-.039l-.184.063-.124.019-.122-.022-.113-.041-.081-.063Z",
    transform: "translate(-548.608 12.647)",
    fill: "#4b433c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7784",
    "data-name": "Caminho 7784",
    d: "M595.447,17.7s.132.326.41.29.281-.2.281-.2l-.31-.449Z",
    transform: "translate(-548.461 12.388)",
    fill: "#252725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7785",
    "data-name": "Caminho 7785",
    d: "M595.454,17.71l-.012.009a.661.661,0,0,0,.093.147.378.378,0,0,0,.289.154l.043,0a.444.444,0,0,0,.254-.12.217.217,0,0,0,.042-.1V17.8l-.329-.468-.4.377,0,.012.012-.009,0,.012.377-.35.3.437.008-.007h-.008v.007c-.007.029-.036.142-.272.178a.183.183,0,0,1-.04,0,.345.345,0,0,1-.269-.141.837.837,0,0,1-.07-.1l-.015-.029a.016.016,0,0,0-.007-.015l-.009,0,0,.012Z",
    transform: "translate(-548.468 12.378)",
    fill: "#4b433c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7786",
    "data-name": "Caminho 7786",
    d: "M595.468,17.589s.165.2.312.2a.516.516,0,0,0,.242-.063l.005.031-.078.033-.132.027-.133-.015-.108-.069Z",
    transform: "translate(-548.447 12.564)",
    fill: "#4b433c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7787",
    "data-name": "Caminho 7787",
    d: "M595.159,17.778a.474.474,0,0,0,.252.137.661.661,0,0,0,.295-.1l.027-.005-.032.029-.12.067-.146.045-.115-.024-.1-.051-.053-.07Z",
    transform: "translate(-548.667 12.699)",
    fill: "#4b433c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7788",
    "data-name": "Caminho 7788",
    d: "M596.043,17.236c.132-.014.39.346.39.518s-.078.441-.2.429-.422-.266-.49-.394-.125-.226-.084-.3a2.625,2.625,0,0,1,.389-.25",
    transform: "translate(-548.323 12.311)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7789",
    "data-name": "Caminho 7789",
    d: "M596.05,17.246l.007.022h.01a.18.18,0,0,1,.1.055.743.743,0,0,1,.172.209.55.55,0,0,1,.083.231.809.809,0,0,1-.051.274.464.464,0,0,1-.06.1.077.077,0,0,1-.072.036.27.27,0,0,1-.113-.043,1.167,1.167,0,0,1-.356-.346.936.936,0,0,1-.1-.23.067.067,0,0,1,.017-.048c0-.012.04-.031.072-.06a1.806,1.806,0,0,1,.2-.12.792.792,0,0,1,.113-.062l-.017-.021.007.022-.007-.022,0-.017s-.084.05-.175.1c-.05.031-.1.057-.137.084a.267.267,0,0,0-.084.075.139.139,0,0,0-.017.069.676.676,0,0,0,.1.249.9.9,0,0,0,.233.254.618.618,0,0,0,.146.11.282.282,0,0,0,.124.048h.005a.114.114,0,0,0,.1-.048.66.66,0,0,0,.125-.4.668.668,0,0,0-.141-.333.933.933,0,0,0-.132-.144.269.269,0,0,0-.12-.065l-.017.007h0v0Z",
    transform: "translate(-548.33 12.301)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7790",
    "data-name": "Caminho 7790",
    d: "M595.266,17.3s-.209-.165-.293-.077a.472.472,0,0,0,0,.427c.057.048.308-.141.308-.141Z",
    transform: "translate(-548.838 12.283)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7791",
    "data-name": "Caminho 7791",
    d: "M595.275,17.307l.015-.017-.083-.051a.409.409,0,0,0-.161-.055.1.1,0,0,0-.076.031.372.372,0,0,0-.063.213,1.04,1.04,0,0,0,.019.144.172.172,0,0,0,.044.1c.005.015.024.019.042.019a.206.206,0,0,0,.092-.027,1.389,1.389,0,0,0,.2-.125l.009-.007L595.3,17.3l-.005-.005-.015.017-.024.007.017.206.022,0-.015-.012a.084.084,0,0,1-.03.019.57.57,0,0,1-.119.074.234.234,0,0,1-.115.043h-.017a.2.2,0,0,1-.024-.081.464.464,0,0,1-.019-.132.347.347,0,0,1,.043-.183.08.08,0,0,1,.051-.014.308.308,0,0,1,.141.045.2.2,0,0,1,.053.039.076.076,0,0,1,.024.009l.012-.015-.024.007Z",
    transform: "translate(-548.847 12.274)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7792",
    "data-name": "Caminho 7792",
    d: "M595.22,17.371s-.276.031-.276.156a.5.5,0,0,0,.156.283c.036.034.278-.1.278-.1Z",
    transform: "translate(-548.821 12.408)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7793",
    "data-name": "Caminho 7793",
    d: "M595.229,17.38v-.021a.616.616,0,0,0-.141.029.309.309,0,0,0-.1.048.141.141,0,0,0-.055.1.411.411,0,0,0,.075.194c.033.051.084.089.1.111a.061.061,0,0,0,.027,0,.172.172,0,0,0,.068-.015,1.377,1.377,0,0,0,.2-.1l.014-.009-.167-.362h-.026l.007.021-.015.009.159.333.014-.005-.009-.022a.938.938,0,0,1-.1.055.365.365,0,0,1-.085.038.17.17,0,0,1-.06.019l-.007.012.007-.009v0l-.007.012.007-.009a.823.823,0,0,1-.091-.1.316.316,0,0,1-.065-.17.094.094,0,0,1,.032-.063.4.4,0,0,1,.141-.057.362.362,0,0,0,.063-.012.071.071,0,0,1,.025-.005l-.005-.019-.015.009Z",
    transform: "translate(-548.831 12.399)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7794",
    "data-name": "Caminho 7794",
    d: "M595.285,17.509s-.282.084-.282.183.125.278.218.278.159-.177.191-.209-.128-.252-.128-.252",
    transform: "translate(-548.779 12.506)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7795",
    "data-name": "Caminho 7795",
    d: "M595.292,17.521l0-.029-.142.062a.358.358,0,0,0-.1.063.1.1,0,0,0-.05.087.372.372,0,0,0,.077.187.584.584,0,0,0,.076.082.145.145,0,0,0,.083.026.142.142,0,0,0,.075-.024.432.432,0,0,0,.084-.11.807.807,0,0,1,.051-.077c.008-.007.008-.026.008-.031a.161.161,0,0,0-.021-.072,1.47,1.47,0,0,0-.111-.18l-.012-.014h-.015l0,.029-.016.009.022.031a.96.96,0,0,1,.07.1c.007.024.026.043.026.06a.067.067,0,0,1,.017.036l0,0,0,0,0,0,0,0c-.017.009-.023.031-.042.051s-.036.069-.065.1a.113.113,0,0,1-.075.05.114.114,0,0,1-.061-.026.723.723,0,0,1-.092-.111.31.31,0,0,1-.044-.122c0-.019.012-.036.039-.058a.711.711,0,0,1,.144-.074.425.425,0,0,1,.062-.024l.027-.012-.011-.015-.016.009Z",
    transform: "translate(-548.786 12.494)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7796",
    "data-name": "Caminho 7796",
    d: "M595.423,17.041a.154.154,0,0,0-.18-.027.352.352,0,0,0-.227.362.967.967,0,0,0,.093.315l.433-.147Z",
    transform: "translate(-548.771 12.143)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7797",
    "data-name": "Caminho 7797",
    d: "M595.432,17.049l.012-.009a.13.13,0,0,0-.114-.051.205.205,0,0,0-.082.012.437.437,0,0,0-.167.129.335.335,0,0,0-.079.216v.038a1,1,0,0,0,.091.327l.012.014.467-.158-.124-.525,0,0-.012.009-.019.009.108.482-.41.141.007.019.017-.01v-.005a.849.849,0,0,1-.085-.3v-.036a.265.265,0,0,1,.068-.189.353.353,0,0,1,.146-.115.155.155,0,0,1,.066-.017.086.086,0,0,1,.062.021l.016.015,0,0,.019-.015-.019.009Z",
    transform: "translate(-548.779 12.135)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7798",
    "data-name": "Caminho 7798",
    d: "M595.429,17.219s-.368.117-.38.261a.307.307,0,0,0,.184.309c.1.029.41-.273.41-.273Z",
    transform: "translate(-548.748 12.299)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7799",
    "data-name": "Caminho 7799",
    d: "M595.438,17.23l-.007-.021a.98.98,0,0,0-.186.081.615.615,0,0,0-.133.084.179.179,0,0,0-.079.117v.029a.339.339,0,0,0,.067.189.249.249,0,0,0,.134.115l.018,0a.251.251,0,0,0,.122-.048,2.2,2.2,0,0,0,.288-.235l.012-.015-.225-.324-.019.007.007.021-.019.012.211.293.021-.009-.015-.019a.349.349,0,0,1-.044.039,1.146,1.146,0,0,1-.174.149,1.008,1.008,0,0,1-.1.063.24.24,0,0,1-.065.024l-.012,0a.219.219,0,0,1-.108-.1.3.3,0,0,1-.057-.165v-.026a.179.179,0,0,1,.062-.091.619.619,0,0,1,.192-.1c.032-.021.065-.027.081-.038a.082.082,0,0,0,.032-.012l0-.019-.019.012Z",
    transform: "translate(-548.757 12.288)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7800",
    "data-name": "Caminho 7800",
    d: "M595.695,17.7a2.9,2.9,0,0,1-.41.237.347.347,0,0,1-.153-.317c.027-.125.273-.216.365-.252s.2.333.2.333",
    transform: "translate(-548.689 12.404)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7801",
    "data-name": "Caminho 7801",
    d: "M595.7,17.71l-.017-.021s-.083.062-.18.12a.9.9,0,0,1-.137.081.247.247,0,0,1-.052.029l-.018.007h-.012c-.005,0-.014-.007-.033-.031a.394.394,0,0,1-.1-.225v-.036c.011-.05.076-.1.148-.149a1.268,1.268,0,0,1,.208-.089h.007a.069.069,0,0,1,.024.005.734.734,0,0,1,.1.177c.007.036.024.072.027.1a.1.1,0,0,1,.012.043l.02-.007-.017-.021.017.021.016-.005a.941.941,0,0,0-.052-.168.617.617,0,0,0-.063-.123.2.2,0,0,0-.038-.045.1.1,0,0,0-.044-.015H595.5a1.942,1.942,0,0,0-.212.1.335.335,0,0,0-.167.18.4.4,0,0,0-.007.041.448.448,0,0,0,.063.2.674.674,0,0,0,.057.069.092.092,0,0,0,.06.036.2.2,0,0,1,.04-.012,1.785,1.785,0,0,0,.233-.137c.077-.051.146-.093.146-.093l.012-.01,0-.014Z",
    transform: "translate(-548.699 12.395)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7802",
    "data-name": "Caminho 7802",
    d: "M595.958,16.823a.535.535,0,0,0-.334-.075c-.216.019-.381.3-.408.446s0,.411.081.456.537-.321.537-.321Z",
    transform: "translate(-548.635 11.962)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7803",
    "data-name": "Caminho 7803",
    d: "M595.967,16.831l.008-.009a.466.466,0,0,0-.293-.087h-.053a.458.458,0,0,0-.29.18.917.917,0,0,0-.139.285,1.044,1.044,0,0,0-.009.137,1.013,1.013,0,0,0,.021.2.185.185,0,0,0,.083.137c0,.007.012.007.024.007a.334.334,0,0,0,.141-.048,3.7,3.7,0,0,0,.389-.285h.005l.132-.518-.012-.009-.008.009h-.02l-.124.5.019.009-.011-.015a.48.48,0,0,0-.063.045c-.063.046-.153.118-.242.171a1.187,1.187,0,0,1-.127.075.138.138,0,0,1-.078.024h-.012a.2.2,0,0,1-.052-.106.7.7,0,0,1-.024-.194.954.954,0,0,1,.012-.132.7.7,0,0,1,.127-.261.408.408,0,0,1,.261-.166h.049a.6.6,0,0,1,.2.038c.021.012.036.015.053.027l.013.005.015-.017h0Z",
    transform: "translate(-548.644 11.954)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7804",
    "data-name": "Caminho 7804",
    d: "M595.49,17.715a.344.344,0,0,1-.254-.362.585.585,0,0,1,.479-.333c.157.024.125.417.125.417s-.2.3-.35.278",
    transform: "translate(-548.616 12.156)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7805",
    "data-name": "Caminho 7805",
    d: "M595.5,17.724l0-.015a.254.254,0,0,1-.17-.117.327.327,0,0,1-.076-.192.051.051,0,0,1,.007-.033.278.278,0,0,1,.048-.1.96.96,0,0,1,.178-.147.461.461,0,0,1,.2-.074l.021,0a.062.062,0,0,1,.055.039.452.452,0,0,1,.053.281v.072l.023,0-.017-.007a.253.253,0,0,1-.034.039,1.769,1.769,0,0,1-.128.146.268.268,0,0,1-.153.084h-.012l0,.015v.027h.017a.367.367,0,0,0,.236-.151.993.993,0,0,0,.115-.141v-.012s0-.033,0-.077a.931.931,0,0,0-.021-.216.437.437,0,0,0-.044-.093.1.1,0,0,0-.075-.053l-.033,0a.534.534,0,0,0-.289.125.486.486,0,0,0-.121.115.349.349,0,0,0-.065.117c0,.009-.007.024-.007.038a.412.412,0,0,0,.087.219.312.312,0,0,0,.2.132Z",
    transform: "translate(-548.627 12.147)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7806",
    "data-name": "Caminho 7806",
    d: "M595.911,17.491a.579.579,0,0,1-.228.264c-.152.072-.245.014-.331-.12s.036-.183.106-.243a.907.907,0,0,1,.272-.11Z",
    transform: "translate(-548.553 12.344)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7807",
    "data-name": "Caminho 7807",
    d: "M595.922,17.5l-.02,0-.007,0a.485.485,0,0,1-.209.243.3.3,0,0,1-.113.033.154.154,0,0,1-.1-.039.377.377,0,0,1-.093-.1.115.115,0,0,1-.026-.069.108.108,0,0,1,.041-.081.75.75,0,0,0,.089-.075.612.612,0,0,1,.16-.074c.027-.012.056-.015.075-.024a.159.159,0,0,0,.033-.009l-.007-.015-.013.009.178.221.015-.021-.02,0,.02,0,.017-.005-.19-.228h-.012a.962.962,0,0,1-.108.033.571.571,0,0,0-.171.084c-.026.027-.058.045-.092.075a.169.169,0,0,0-.061.11.149.149,0,0,0,.034.093.583.583,0,0,0,.1.108.192.192,0,0,0,.128.048.247.247,0,0,0,.125-.036.58.58,0,0,0,.242-.266l.007-.015-.007-.005Z",
    transform: "translate(-548.563 12.334)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7808",
    "data-name": "Caminho 7808",
    d: "M595.566,17.237s-.171.137-.072.3a.377.377,0,0,0,.293.233c.129.027.2-.027.3-.144s.24-.17.223-.31a.348.348,0,0,0-.16-.3.686.686,0,0,0-.586.228",
    transform: "translate(-548.451 12.141)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7809",
    "data-name": "Caminho 7809",
    d: "M595.576,17.246l-.012-.017a.3.3,0,0,0-.117.209.276.276,0,0,0,.032.11.8.8,0,0,0,.148.18.431.431,0,0,0,.164.075h.063a.345.345,0,0,0,.257-.156,1.141,1.141,0,0,1,.147-.137.231.231,0,0,0,.086-.171v-.017a.388.388,0,0,0-.169-.324.333.333,0,0,0-.084-.012.839.839,0,0,0-.526.243l.012.017-.012-.017.012.017.016.015a.782.782,0,0,1,.5-.237.147.147,0,0,1,.068.012.324.324,0,0,1,.141.285v.017a.184.184,0,0,1-.068.137,1.847,1.847,0,0,0-.153.141c-.077.1-.142.144-.224.144H595.8a.354.354,0,0,1-.141-.069.5.5,0,0,1-.137-.161.161.161,0,0,1-.027-.093.206.206,0,0,1,.051-.129c.009-.015.026-.024.033-.036l.012-.007v-.005h0Z",
    transform: "translate(-548.461 12.132)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7810",
    "data-name": "Caminho 7810",
    d: "M596.034,16.753a.419.419,0,0,0-.312.005.51.51,0,0,0-.235.393,2.55,2.55,0,0,0,.029.357,1.056,1.056,0,0,0,.305-.151c.12-.1.159-.134.141-.178a.366.366,0,0,1-.053-.192c0-.221.125-.233.125-.233",
    transform: "translate(-548.433 11.946)",
    fill: "#252725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7811",
    "data-name": "Caminho 7811",
    d: "M596.036,16.753a.521.521,0,0,0-.3.029.537.537,0,0,0-.229.3c-.04.129-.013.168-.013.168a.513.513,0,0,1,.019-.228.457.457,0,0,1,.246-.281.524.524,0,0,1,.277.015",
    transform: "translate(-548.435 11.946)",
    fill: "#4b433c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7812",
    "data-name": "Caminho 7812",
    d: "M600.625,18.28l-.032-.879-2.385.734.941.881Z",
    transform: "translate(-546.49 12.429)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7813",
    "data-name": "Caminho 7813",
    d: "M597.3,17.137l-.2-.156a1.147,1.147,0,0,0-.221-.122.425.425,0,0,0-.18-.01l-.032.051.025.077.219.261.359.183c.012.005.132.125.132.125l.081.033Z",
    transform: "translate(-547.586 12.031)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7814",
    "data-name": "Caminho 7814",
    d: "M597.472,17.862l-.771-.233.062-.183.139-.129.113-.048.159-.021.062-.012.136.019.137.153.077.168.12.218.031.134Z",
    transform: "translate(-547.567 12.312)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7815",
    "data-name": "Caminho 7815",
    d: "M597.526,18.454l.132-.009.081-.072-.036-.29.041-.926-.622-.742-.129.429.185.751.136.446Z",
    transform: "translate(-547.358 11.726)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7816",
    "data-name": "Caminho 7816",
    d: "M597.094,16.767s-.042.075.012.314a4.122,4.122,0,0,0,.356,1.167c.217.369-.211-.3-.211-.3a3.27,3.27,0,0,1-.278-1.318c.052-.569.12.134.12.134",
    transform: "translate(-547.375 11.722)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7817",
    "data-name": "Caminho 7817",
    d: "M597.375,16.893a1,1,0,0,0-.158.305,1.951,1.951,0,0,0,.014.357s-.018-.173.116-.209.126.379.132.418.081-.747.081-.747Z",
    transform: "translate(-547.201 12.066)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7818",
    "data-name": "Caminho 7818",
    d: "M597.872,18.039a1.947,1.947,0,0,1-.707-.161c-.365-.168-.557-.3-.55-.381s.649.015.742.045a2.491,2.491,0,0,1,.376.159h.17l.293-.129.044.319Z",
    transform: "translate(-547.626 12.473)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7819",
    "data-name": "Caminho 7819",
    d: "M596.779,17.716s.176.123.093.183a.717.717,0,0,1-.374.041l.682.168a1.192,1.192,0,0,0,.134-.134c-.008-.005-.535-.259-.535-.259",
    transform: "translate(-547.715 12.654)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7820",
    "data-name": "Caminho 7820",
    d: "M596.552,17.611c.027-.039.051.1.3.135a.5.5,0,0,0,.346-.046l.114.067.13.029-.12.183-.449-.139-.241-.13Z",
    transform: "translate(-547.673 12.574)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7821",
    "data-name": "Caminho 7821",
    d: "M597.443,16.966l.057.787.126.18.082-.393,0-.406Z",
    transform: "translate(-547.036 12.118)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7822",
    "data-name": "Caminho 7822",
    d: "M597.268,17.508l-.213-.345-.265-.5.161-.285.2.3a.9.9,0,0,0-.016.386,2.891,2.891,0,0,0,.129.446",
    transform: "translate(-547.503 11.7)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7823",
    "data-name": "Caminho 7823",
    d: "M596.232,17.848a.392.392,0,0,1,.3-.161,1.076,1.076,0,0,1,.386.027l.428.223.088.141-.814-.11Z",
    transform: "translate(-547.901 12.629)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7824",
    "data-name": "Caminho 7824",
    d: "M597.627,17.051s.012.485.031.638.106.3.089.367-.044.1-.148.129a.743.743,0,0,1-.316,0s.21-.026.223-.062a3.554,3.554,0,0,1-.079-.4c-.012-.161.009-.346-.052-.346s-.113.074-.125.093a2.465,2.465,0,0,1,.125-.67c.067-.072.252.257.252.257",
    transform: "translate(-547.175 11.989)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7825",
    "data-name": "Caminho 7825",
    d: "M596.635,17.746s-.083-.077-.083-.135a.621.621,0,0,0,.548.243c.446-.019.418-.031.418-.031h.209s-.048.2-.081.216-.35.225-.357.23l-.109.063,0-.029h-.024l-.029-.341-.389-.151Z",
    transform: "translate(-547.674 12.575)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7826",
    "data-name": "Caminho 7826",
    d: "M597.4,17.757a4.742,4.742,0,0,1-.687-.891,1.463,1.463,0,0,1-.072-.835l.483.638a.666.666,0,0,0-.042.317,4.01,4.01,0,0,0,.317.771",
    transform: "translate(-547.633 11.451)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7827",
    "data-name": "Caminho 7827",
    d: "M596.88,18.567a.308.308,0,0,1,.056-.281,3.059,3.059,0,0,1,1.083-.658l.005.47-.993.475Z",
    transform: "translate(-547.448 12.591)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7828",
    "data-name": "Caminho 7828",
    d: "M597.13,18.165c.039-.031.221-.153.221-.213s-.117-.074-.341-.117a1.98,1.98,0,0,1-.413-.149,3,3,0,0,0,.386.257c.112.045.1.084.091.11s.053.12.057.111",
    transform: "translate(-547.64 12.634)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7829",
    "data-name": "Caminho 7829",
    d: "M598.269,18.316a1.871,1.871,0,0,1-.192-.341c-.044-.132-.05-.348-.062-.348a1.874,1.874,0,0,1-.16.1c-.06.029-.293.1-.306.113s.324-.005.317.1-.475.163-.475.171.382-.081.354.009-.189.1-.394.185a2.943,2.943,0,0,0-.37.173.517.517,0,0,0-.108.082.475.475,0,0,0,.229.041,2.777,2.777,0,0,0,.47-.084l.617-.23Z",
    transform: "translate(-547.442 12.591)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7830",
    "data-name": "Caminho 7830",
    d: "M597.85,18.731s-.177-.053-.3-.778a3.368,3.368,0,0,1-.082-.907l.286.2.264.473Z",
    transform: "translate(-547.023 12.176)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7831",
    "data-name": "Caminho 7831",
    d: "M597.8,17.334a2.76,2.76,0,0,0-.135.638,1.372,1.372,0,0,0,.046.554A1.306,1.306,0,0,0,598,18.9l.1-.111.044-.326.033-.537Z",
    transform: "translate(-546.882 12.381)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7832",
    "data-name": "Caminho 7832",
    d: "M598.185,17.682s.068,1.015-.186,1.044c-.125.009-.312-.382-.312-.4s.223.372.305.341c.163-.075.115-1.059.115-1.059Z",
    transform: "translate(-546.862 12.579)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7833",
    "data-name": "Caminho 7833",
    d: "M598.269,18.081s-.045-.012-.117-.125c0,0-.012.094-.548.283s-.729.094-.729.094.173.134.72-.024a2.141,2.141,0,0,0,.565-.213.586.586,0,0,1,.108-.015",
    transform: "translate(-547.442 12.826)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7834",
    "data-name": "Caminho 7834",
    d: "M597.158,17.391a.823.823,0,0,1,.18.269c.1.2.168.336.168.336l.021-.024a2.157,2.157,0,0,0-.152-.341c-.091-.147-.352-.506-.352-.506Z",
    transform: "translate(-547.337 12.232)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7835",
    "data-name": "Caminho 7835",
    d: "M597.39,18.182s.057-.192,0-.228-.108,0-.477-.041a5.075,5.075,0,0,1-.681-.135,2.052,2.052,0,0,0,.49.219c.237.069.554.134.554.134l.082.01Z",
    transform: "translate(-547.9 12.698)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7836",
    "data-name": "Caminho 7836",
    d: "M597.39,18.182a.1.1,0,0,0-.036-.093c-.039-.045-.113.021-.562-.1a1.9,1.9,0,0,1-.559-.207,1.309,1.309,0,0,0,.552.243c.4.1.6.161.6.161",
    transform: "translate(-547.9 12.698)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7837",
    "data-name": "Caminho 7837",
    d: "M597.313,17.235a1.163,1.163,0,0,0-.439.1,1.776,1.776,0,0,0-.259.324l.219.027a.4.4,0,0,1,.078-.309.813.813,0,0,1,.4-.144",
    transform: "translate(-547.626 12.311)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7838",
    "data-name": "Caminho 7838",
    d: "M596.654,16.86a.842.842,0,0,0,.272.245,1.3,1.3,0,0,1,.35.18,1.049,1.049,0,0,1,.144.3,3,3,0,0,1-.582-.327,1.5,1.5,0,0,1-.185-.394",
    transform: "translate(-547.6 12.043)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7839",
    "data-name": "Caminho 7839",
    d: "M597.122,17a.41.41,0,0,0-.18-.132.3.3,0,0,0-.266-.024c-.032.027-.021.045-.021.045l.174.267.1-.022s-.263-.166-.2-.214c.129-.117.395.081.395.081",
    transform: "translate(-547.599 12.015)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7840",
    "data-name": "Caminho 7840",
    d: "M600.481,15.753l1.286,1.781-2.342.636-1.243.1-.6-.437.188-.686Z",
    transform: "translate(-546.939 11.252)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7841",
    "data-name": "Caminho 7841",
    d: "M598.876,19.116a2.024,2.024,0,0,0,.241-.113c.1-.057.324-.2.324-.2l.072.367-.281.219h-.244l-.149-.1Z",
    transform: "translate(-546.039 13.43)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7842",
    "data-name": "Caminho 7842",
    d: "M598.885,19.122l0,.024s.152-.063.258-.12.316-.2.316-.2l-.012-.021-.019.005.068.353-.27.2-.226.007-.132-.1.029-.144-.017-.012,0,.024,0-.024h-.024l-.033.159a.042.042,0,0,0,.005.024l.147.106h.261l.012,0,.281-.216.008-.019-.071-.367-.009-.015h-.023s-.052.036-.12.077-.147.1-.2.123-.112.057-.158.077-.082.036-.082.036l-.017.015Z",
    transform: "translate(-546.047 13.424)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7843",
    "data-name": "Caminho 7843",
    d: "M598.657,19.028a1.645,1.645,0,0,0,.173.012c.171,0,.191-.065.223-.053s.074.2.074.2l-.063.115-.246.141-.206-.117-.019-.285Z",
    transform: "translate(-546.215 13.561)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7844",
    "data-name": "Caminho 7844",
    d: "M598.664,19.035l-.012.015.007,0c0,.007.012.007.037.01s.063,0,.141,0h.019a.362.362,0,0,0,.146-.027.051.051,0,0,0,.032-.019h.012l.007,0v-.005l-.007.005h.007v-.005l-.007.005a.07.07,0,0,1,.016.034.94.94,0,0,1,.039.1.249.249,0,0,0,.016.057l.018-.01-.018-.009-.057.1-.235.141-.19-.1-.01-.259.046-.014-.007-.017-.012.015.012-.015,0-.021-.061.012c-.011,0-.015.012-.015.021l.015.286.009.026.209.11h.021l.245-.141.007-.012.065-.113v-.012s-.012-.048-.026-.1c-.012-.024-.019-.048-.027-.069a.068.068,0,0,1-.012-.027.082.082,0,0,1-.027-.021l-.009,0a.037.037,0,0,0-.033.012.341.341,0,0,1-.056.017.268.268,0,0,1-.108.015h-.019a1.238,1.238,0,0,1-.146,0l-.021,0v.012l.005-.012h-.005v.012l.005-.012-.012.021.015-.015,0-.005-.012.021.015-.015-.02-.005Z",
    transform: "translate(-546.222 13.554)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7845",
    "data-name": "Caminho 7845",
    d: "M599.979,19.143a.783.783,0,0,0-.146-.171c-.1-.086-.352-.305-.352-.305l0,.794.369-.007.173-.245Z",
    transform: "translate(-545.584 13.333)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7846",
    "data-name": "Caminho 7846",
    d: "M599.986,19.151l.017-.015a.828.828,0,0,0-.151-.17c-.051-.043-.138-.12-.211-.183s-.134-.129-.134-.129h-.024c-.008,0-.015.019-.015.019v.8l.007.019.008,0,.369-.009.02-.012.17-.245.007-.019L600,19.136l-.017.015-.017.005.034.06-.157.221-.335.01v-.773h-.022l-.012.022.345.3a.936.936,0,0,1,.113.115.145.145,0,0,0,.027.038l.007.009Z",
    transform: "translate(-545.59 13.324)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7847",
    "data-name": "Caminho 7847",
    d: "M598.858,19.039a.219.219,0,0,0-.209-.069.406.406,0,0,0-.332.252c-.017.11,0,.411.084.478a.408.408,0,0,0,.356.045,10.725,10.725,0,0,0,1.013-.569s-.1.021-.21.048a.418.418,0,0,1-.231-.027.469.469,0,0,1-.246.153.158.158,0,0,1-.2-.125.6.6,0,0,1-.028-.185",
    transform: "translate(-546.417 13.549)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7848",
    "data-name": "Caminho 7848",
    d: "M598.868,19.046l.015-.015a.228.228,0,0,0-.18-.072.278.278,0,0,0-.051,0,.441.441,0,0,0-.222.1.294.294,0,0,0-.128.171.659.659,0,0,0,0,.1.951.951,0,0,0,.022.228.25.25,0,0,0,.077.166.363.363,0,0,0,.221.072.971.971,0,0,0,.149-.014c.042-.022.132-.06.234-.115.305-.168.789-.461.789-.461a.028.028,0,0,0,0-.029c0-.005-.009-.012-.021-.012l-.212.051c-.024,0-.044,0-.065,0a.293.293,0,0,1-.106-.015.179.179,0,0,1-.033-.012l0,0h-.007a.025.025,0,0,0-.026,0V19.2a.552.552,0,0,1-.235.144h-.037a.132.132,0,0,1-.1-.039.258.258,0,0,1-.039-.074.346.346,0,0,1-.017-.111.379.379,0,0,1-.007-.065l0-.019-.015.015h-.024a.445.445,0,0,0,.006.069.438.438,0,0,0,.024.129.212.212,0,0,0,.053.084.139.139,0,0,0,.121.06.129.129,0,0,0,.049-.012.482.482,0,0,0,.255-.156l-.016-.015,0,.022a.406.406,0,0,0,.164.036.328.328,0,0,0,.072-.012c.113-.021.218-.046.218-.046l-.007-.021-.005-.014s-.053.029-.137.081c-.127.072-.317.19-.492.286a2.278,2.278,0,0,1-.233.129.777.777,0,0,1-.152.067.656.656,0,0,1-.141.021.312.312,0,0,1-.2-.065.248.248,0,0,1-.061-.141,1.333,1.333,0,0,1-.024-.219.355.355,0,0,1,.012-.093c0-.045.051-.1.1-.144a.431.431,0,0,1,.208-.086.2.2,0,0,1,.044,0,.184.184,0,0,1,.113.029l.028.019.006.009.018-.012h0Z",
    transform: "translate(-546.425 13.542)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7849",
    "data-name": "Caminho 7849",
    d: "M598.248,19.887s-.121-.218.031-.3.239.005.332.005.063-.242.044-.286a.811.811,0,0,0-.11-.185c-.04-.026-.558.021-.551.37a.379.379,0,0,0,.254.4",
    transform: "translate(-546.642 13.653)",
    fill: "#252725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7850",
    "data-name": "Caminho 7850",
    d: "M599.125,19.169a.926.926,0,0,0-.171.087,1.121,1.121,0,0,1-.218.082l.065.264.359.089.225-.185.006-.257Z",
    transform: "translate(-546.113 13.692)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7851",
    "data-name": "Caminho 7851",
    d: "M599.132,19.178l-.007-.021s-.033.012-.07.029a.391.391,0,0,0-.1.06c-.024.012-.077.033-.128.053l-.086.039c-.012,0-.015.009-.015.021l.072.257.008.022.36.086.022,0,.231-.189v-.276a.03.03,0,0,0-.008-.024l-.272-.077h-.013l.007.021-.007.021.252.075v.233l-.214.177-.339-.087-.057-.249h-.024l.007.027.092-.033a.709.709,0,0,0,.129-.065.957.957,0,0,1,.1-.048.23.23,0,0,1,.065-.031l-.006-.021-.007.021Z",
    transform: "translate(-546.122 13.684)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7852",
    "data-name": "Caminho 7852",
    d: "M600.159,19.149a.859.859,0,0,1-.125-.132.193.193,0,0,0-.176-.072c-.02.012-.2.231-.2.231l-.01.165.2.113.142.019.187-.118Z",
    transform: "translate(-545.461 13.529)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7853",
    "data-name": "Caminho 7853",
    d: "M600.167,19.158l.012-.015a.437.437,0,0,0-.04-.033c-.02-.024-.056-.057-.089-.1a.248.248,0,0,0-.167-.086l-.029,0a.1.1,0,0,1-.019.024,2.618,2.618,0,0,0-.178.216l-.007.015-.011.165c-.006.012,0,.014.011.017l.2.115h.007l.141.024h.011l.189-.12v-.024l-.013-.2,0-.015-.012.015h-.02l.014.2-.166.1-.136-.024-.186-.1.012-.156h-.019l.019.012s.04-.055.087-.111c.024-.027.05-.06.069-.081s.012-.021.024-.024l0-.012h.012a.172.172,0,0,1,.135.075c.072.077.134.13.134.13l.015-.017h0Z",
    transform: "translate(-545.47 13.52)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7854",
    "data-name": "Caminho 7854",
    d: "M599.4,18.989a2.2,2.2,0,0,0-.242.137c-.075.069-.2.139-.2.171a1.672,1.672,0,0,0,.182.221l.183.015.4-.285-.026-.255Z",
    transform: "translate(-545.951 13.564)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7855",
    "data-name": "Caminho 7855",
    d: "M599.412,19l-.012-.021a1.406,1.406,0,0,0-.248.142c-.036.036-.087.07-.122.1s-.036.031-.055.045l-.017.019c-.007.005-.007.014-.007.024v.021c.007.009.024.029.043.057.05.063.146.159.146.159l.007.005.188.012.009,0,.413-.283v-.015L599.733,19c0-.012-.009-.017-.021-.024l-.3,0H599.4l.012.021v.021l.281.007.024.225-.389.269-.176-.012v.021l.012-.021s-.041-.039-.093-.093a.365.365,0,0,0-.06-.07c-.005-.014-.018-.021-.018-.029v-.009h0s0-.01.018-.022c.039-.029.116-.082.171-.129a.786.786,0,0,1,.146-.093c.048-.026.091-.045.091-.045L599.412,19v0Z",
    transform: "translate(-545.959 13.555)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7856",
    "data-name": "Caminho 7856",
    d: "M600.318,19.269a.384.384,0,0,0-.093-.123.287.287,0,0,0-.185-.082c-.048.005-.208.238-.208.238l-.017.067.141.17.257.06.177-.183Z",
    transform: "translate(-545.341 13.616)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7857",
    "data-name": "Caminho 7857",
    d: "M600.327,19.278l.018-.007a.467.467,0,0,0-.1-.13.288.288,0,0,0-.188-.091h-.012c-.009.007-.021.007-.032.015a.621.621,0,0,0-.117.141l-.068.093v.007l-.021.072,0,.012.141.173.012.005.26.06.016-.009.176-.173c.012-.01.012-.022,0-.027l-.074-.147-.018.007-.016.015.067.129-.163.161-.238-.057-.132-.149.017-.058-.02-.009.015.012a.848.848,0,0,1,.087-.117c.021-.027.044-.057.065-.081a.353.353,0,0,0,.029-.027l.01,0v0h0a.3.3,0,0,1,.167.086.41.41,0,0,1,.065.075c.007.009.012.021.019.024l0,.015Z",
    transform: "translate(-545.349 13.607)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7858",
    "data-name": "Caminho 7858",
    d: "M600.578,19.62l.18.027a.128.128,0,0,0,.048.1c.05.038.057.005.057.005a.566.566,0,0,0,.218.326.624.624,0,0,0,.337.012c.12-.069.1.015.1.015l.326-.4s0-.084-.074-.084c0,0,.053-.252-.153-.309a.667.667,0,0,0-.377.024s-.159.3-.257.255a.363.363,0,0,1-.115-.079,1.114,1.114,0,0,1-.114-.144.163.163,0,0,1-.144-.033.643.643,0,0,1-.149-.178.412.412,0,0,1-.161-.063.7.7,0,0,1-.082-.127l-.3.214s-.009.094-.186.226a.54.54,0,0,1-.276.125s-.044.261-.242.216a.6.6,0,0,1-.329-.266.268.268,0,0,0-.229.108c-.088.118-.129.158-.129.281a.606.606,0,0,0,.134.343.418.418,0,0,0,.485.087.251.251,0,0,0,.152-.314s0,.012.141-.075a2.954,2.954,0,0,1,.391-.278",
    transform: "translate(-546.263 13.548)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7859",
    "data-name": "Caminho 7859",
    d: "M600.582,19.641l.183.033,0-.021-.021,0v.007a.172.172,0,0,0,.114.137.047.047,0,0,0,.027-.015l.007-.021-.022,0-.017,0a.608.608,0,0,0,.225.341h.005a.876.876,0,0,0,.228.036.247.247,0,0,0,.129-.027.144.144,0,0,1,.06-.017l.008,0v.012c0,.009.007.014.012.026a.03.03,0,0,0,.027-.012l.322-.4.007-.012a.139.139,0,0,0-.012-.053.112.112,0,0,0-.087-.057v.026h.019a.438.438,0,0,0,.005-.072.256.256,0,0,0-.029-.142.229.229,0,0,0-.141-.111.627.627,0,0,0-.165-.017.649.649,0,0,0-.225.038l-.008.015a.177.177,0,0,0-.031.033.871.871,0,0,1-.089.139.424.424,0,0,1-.057.053.091.091,0,0,1-.052.021l-.008,0a.439.439,0,0,1-.1-.077,1.234,1.234,0,0,1-.087-.1l-.021-.031h-.007c0-.012-.012-.012-.021-.012h-.028a.16.16,0,0,1-.1-.029.507.507,0,0,1-.093-.108.141.141,0,0,1-.036-.048l-.009-.019-.019-.012-.011-.005a.243.243,0,0,1-.075-.015.36.36,0,0,1-.06-.033c-.019-.024-.036-.057-.053-.077s-.027-.048-.027-.048l-.011,0h-.021l-.295.213-.011.015s-.012.089-.174.213a1.419,1.419,0,0,1-.2.1.174.174,0,0,1-.056.015h-.012v0a.017.017,0,0,0-.017.019v0a.538.538,0,0,1-.051.117.167.167,0,0,1-.132.084.049.049,0,0,1-.036-.01A.45.45,0,0,1,599,19.6a.316.316,0,0,1-.062-.079.054.054,0,0,1-.021-.029v-.005l-.019-.01h-.032a.272.272,0,0,0-.218.108.784.784,0,0,0-.1.147.245.245,0,0,0-.039.149.561.561,0,0,0,.051.2.509.509,0,0,0,.1.154.5.5,0,0,0,.33.141.325.325,0,0,0,.178-.048.27.27,0,0,0,.177-.254.338.338,0,0,0-.013-.089l-.011-.009a.025.025,0,0,0-.023.009v.009l.006.017.012.007h.012c.018-.012.052-.033.132-.077a4.191,4.191,0,0,1,.39-.281c.014,0,.021-.019.014-.027s-.014-.019-.026-.007a2.575,2.575,0,0,0-.4.276c-.051.033-.083.051-.1.063l-.017.012h-.007l.007.009v-.009h-.007l.007.009v.009l.012-.015-.012,0v.017l.012-.015-.012.019h.017l0-.019-.012.019h0l.017.009V20h-.017l.017.009L599.307,20l-.011.009a.218.218,0,0,1,.011.069.25.25,0,0,1-.154.216.307.307,0,0,1-.165.045.476.476,0,0,1-.3-.129.5.5,0,0,1-.084-.144.442.442,0,0,1-.045-.185.329.329,0,0,1,.027-.135l.1-.134a.237.237,0,0,1,.185-.093l.021,0h.006v-.029l-.019.021s.043.051.093.117a.6.6,0,0,0,.249.153.228.228,0,0,0,.048,0,.2.2,0,0,0,.176-.125.492.492,0,0,0,.041-.117h-.017v.021a.561.561,0,0,0,.293-.135c.173-.132.192-.226.192-.235l-.024,0,.012.017.3-.216-.009-.014-.023.009a.528.528,0,0,0,.1.132.315.315,0,0,0,.1.057l.063.012,0-.021-.011.009a.612.612,0,0,0,.146.192.194.194,0,0,0,.125.041.108.108,0,0,0,.036-.005l0-.024-.019.012a.653.653,0,0,0,.121.142.266.266,0,0,0,.12.084.028.028,0,0,0,.02.012.189.189,0,0,0,.1-.048,1.233,1.233,0,0,0,.164-.221l-.019-.014.012.021a.516.516,0,0,1,.208-.043.6.6,0,0,1,.156.022.2.2,0,0,1,.113.089.253.253,0,0,1,.028.122c0,.015-.007.034-.007.046v.038l.015,0a.055.055,0,0,1,.048.036.041.041,0,0,1,.012.024v.009h.021l-.015-.015-.323.4.012.009.021.007V20.1a.145.145,0,0,0,0-.033.058.058,0,0,0-.044-.024.518.518,0,0,0-.081.027.185.185,0,0,1-.108.026.536.536,0,0,1-.146-.017.174.174,0,0,1-.045-.015H601.1l0,.019.017-.019a.562.562,0,0,1-.178-.213l-.031-.069a.052.052,0,0,1,0-.024v-.005a.024.024,0,0,0-.022-.022.027.027,0,0,0-.017.022h.005v0l-.005,0h.005v0l-.033-.021a.088.088,0,0,1-.036-.072h0a.026.026,0,0,0-.017-.024l-.185-.031a.021.021,0,0,0-.022.019c0,.012.007.021.015.021",
    transform: "translate(-546.274 13.542)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7860",
    "data-name": "Caminho 7860",
    d: "M599.76,18.417v.511s.06.453-.041.6-.458.113-.506-.009a1.843,1.843,0,0,1-.031-.518Z",
    transform: "translate(-545.798 13.155)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7861",
    "data-name": "Caminho 7861",
    d: "M599.768,18.439h-.024v.518a.668.668,0,0,1,.013.086,1.7,1.7,0,0,1,.012.2.6.6,0,0,1-.057.3.306.306,0,0,1-.228.086.472.472,0,0,1-.161-.029.155.155,0,0,1-.088-.063.564.564,0,0,1-.02-.129c-.005-.055-.005-.113-.005-.171,0-.113.005-.211.005-.211h-.024l.019.017.567-.583-.009-.015h0l-.024-.019-.57.59v.01s-.007.1-.007.211a1.585,1.585,0,0,0,.007.178.418.418,0,0,0,.024.137.236.236,0,0,0,.109.089.541.541,0,0,0,.177.024.3.3,0,0,0,.26-.1.534.534,0,0,0,.061-.317c0-.153-.015-.293-.015-.293l-.021,0h.021l-.005-.564-.04.034Z",
    transform: "translate(-545.805 13.133)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7862",
    "data-name": "Caminho 7862",
    d: "M598.791,20.437s-.168-.237-.075-.374.159-.06.2-.063.067-.1,0-.257-.173-.233-.228-.238a.49.49,0,0,0-.305.511.552.552,0,0,0,.413.422",
    transform: "translate(-546.373 13.931)",
    fill: "#252725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7863",
    "data-name": "Caminho 7863",
    d: "M600.36,20.235s.554.237.6-.334a.514.514,0,0,0-.337-.509c-.061,0-.1.029-.209.153s-.175.209-.136.254.209-.045.285.129a.2.2,0,0,1-.2.309",
    transform: "translate(-545.02 13.851)",
    fill: "#252725"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7864",
    "data-name": "Caminho 7864",
    d: "M599.285,19.344s-.076.134.16.149a.139.139,0,0,0,.14-.05.16.16,0,0,0,.05-.127.18.18,0,0,0,.191.2.2.2,0,0,0,.212-.225",
    transform: "translate(-545.729 13.779)",
    fill: "#eec747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7865",
    "data-name": "Caminho 7865",
    d: "M599.27,19.339a.222.222,0,0,0-.008.057.111.111,0,0,0,.039.084.28.28,0,0,0,.153.045h.021a.161.161,0,0,0,.137-.06.2.2,0,0,0,.053-.125V19.32a.03.03,0,0,0-.025-.021.043.043,0,0,0-.016.024v.012a.2.2,0,0,0,.213.2h.012a.207.207,0,0,0,.192-.1.237.237,0,0,0,.032-.135V19.3a.018.018,0,0,0-.024-.015s-.021.005-.015.017v.009a.208.208,0,0,1-.033.115.161.161,0,0,1-.153.074h-.012a.165.165,0,0,1-.147-.07.145.145,0,0,1-.024-.091v-.009l-.021,0-.021.007h0l0,.009a.2.2,0,0,1-.044.1.141.141,0,0,1-.108.046h-.021a.228.228,0,0,1-.126-.041.059.059,0,0,1-.026-.048.042.042,0,0,1,.005-.026l0,0v-.007a.026.026,0,0,0-.01-.029.031.031,0,0,0-.031.009",
    transform: "translate(-545.738 13.773)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7866",
    "data-name": "Caminho 7866",
    d: "M598.8,20.437a.55.55,0,0,1-.434-.523c0-.285.32-.41.32-.41s-.293.154-.3.4a.533.533,0,0,0,.413.535",
    transform: "translate(-546.379 13.931)",
    fill: "#4b433c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7867",
    "data-name": "Caminho 7867",
    d: "M598.267,19.885a.407.407,0,0,1-.281-.417c-.029-.363.571-.351.571-.351s-.571.033-.547.379.257.389.257.389",
    transform: "translate(-546.649 13.655)",
    fill: "#4b433c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7868",
    "data-name": "Caminho 7868",
    d: "M600.32,20.235a.523.523,0,0,0,.24.045.315.315,0,0,0,.338-.254.5.5,0,0,0-.115-.5c-.1-.132-.19-.132-.19-.132a.322.322,0,0,1,.179.141.488.488,0,0,1,.1.494.352.352,0,0,1-.385.242.723.723,0,0,1-.168-.033",
    transform: "translate(-544.982 13.851)",
    fill: "#4b433c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7869",
    "data-name": "Caminho 7869",
    d: "M603.218,19.95l-.38.254-.789-.225L600.4,18.352l-.61-.614.044-.723Z",
    transform: "translate(-545.36 12.154)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7870",
    "data-name": "Caminho 7870",
    d: "M604.167,19.761s-.847-.658-1.934-1.469-2.444-1.834-2.444-1.834l.063.874,2.789,2.563.924.447.47-.142.233-.247Z",
    transform: "translate(-545.36 11.756)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7871",
    "data-name": "Caminho 7871",
    d: "M599.817,17.269a14.8,14.8,0,0,0,1.717,1.661c.736.562,1.445,1.176,1.59,1.089s.1-.177.1-.177L599.8,17.048Z",
    transform: "translate(-545.356 12.177)",
    fill: "#774026"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7872",
    "data-name": "Caminho 7872",
    d: "M602.031,20.091l-.393-.165-2.08-2.122.1-.391.293.041,2.426,2.369Z",
    transform: "translate(-545.525 12.438)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7873",
    "data-name": "Caminho 7873",
    d: "M604.148,19.431s-.254.607-.8.461a29.169,29.169,0,0,1-3.524-2.973l-.005.3s3.022,2.769,3.605,2.878,1.064-.394,1-.447c-.041-.039-.277-.216-.277-.216",
    transform: "translate(-545.341 12.086)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7874",
    "data-name": "Caminho 7874",
    d: "M599.611,17.458a17.926,17.926,0,0,0,1.481,1.694c.509.454.942.814,1.151.771s-.12-.274-.12-.274l-1.462-1.437-.746-.754s-.293-.113-.305,0",
    transform: "translate(-545.488 12.434)",
    fill: "#774026"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7875",
    "data-name": "Caminho 7875",
    d: "M599.756,17.472s2.44,2.5,2.637,2.556c.415.117,1-.305,1-.305l-.216-.132-.025.084s-.108.25-.635.137-2.681-2.424-2.681-2.424Z",
    transform: "translate(-545.384 12.42)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7876",
    "data-name": "Caminho 7876",
    d: "M601.4,19.572l-.249.165-.217-.075-.172-.081-.892-1.025-.2-.341-.051-.432Z",
    transform: "translate(-545.478 12.702)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7877",
    "data-name": "Caminho 7877",
    d: "M602.358,19.666s-.215.317-.505.254a.9.9,0,0,1-.461-.278l-1.706-1.666-.038-.261a18.8,18.8,0,0,0,2.2,2.071c.245.063.418-.233.418-.233Z",
    transform: "translate(-545.461 12.654)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7878",
    "data-name": "Caminho 7878",
    d: "M601.4,19.442a.323.323,0,0,1-.334.214.54.54,0,0,1-.333-.137l-1.039-1.239-.024-.333a10.606,10.606,0,0,0,1.341,1.593.228.228,0,0,0,.3-.177Z",
    transform: "translate(-545.446 12.819)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7879",
    "data-name": "Caminho 7879",
    d: "M600.03,16.92s1.011.867,1.089.909.441.057.461.111-.229,0-.25.05a1.948,1.948,0,0,0,.6.5c.081.012.511.012.5.065s-.293,0-.3.06a1.669,1.669,0,0,0,.548.451,2.978,2.978,0,0,1,.623.06c0,.053-.434-.005-.425.087s.742.547.706.61-.874-.574-.9-.542-.049.237-.1.267,0-.267-.044-.387-.53-.5-.582-.461-.011.269-.06.269.007-.278-.041-.374a2.456,2.456,0,0,0-.576-.475c-.065,0-.022.2-.065.238s-.025-.238-.092-.322a12.9,12.9,0,0,1-1.081-1.113",
    transform: "translate(-545.188 12.086)",
    fill: "#a57132"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7880",
    "data-name": "Caminho 7880",
    d: "M599.324,18.964s0,.382-.171.439-.49-.7-.49-.7l-.078-.715.5.475Z",
    transform: "translate(-546.22 12.849)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7881",
    "data-name": "Caminho 7881",
    d: "M600.106,18.969a1.023,1.023,0,0,0-.007-.2c-.012-.089-.045-.237-.045-.237l-.029-.391-.1-.264-.078-.165-.107.007-.267.189-.089.254.144.482.132.434.194.063Z",
    transform: "translate(-545.647 12.649)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7882",
    "data-name": "Caminho 7882",
    d: "M599.969,19.539c.063-.015-.053-.545-.053-.545l-.317-.768-.083-.281-.25-.1-.171.194.034.305a7.409,7.409,0,0,0,.368.689c.113.185.372.533.473.5",
    transform: "translate(-545.857 12.749)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7883",
    "data-name": "Caminho 7883",
    d: "M599.575,18.645a.733.733,0,0,1,.216.41,3.13,3.13,0,0,1,.178.626c-.025.057-.149.063-.149.063s.278.286.358.254.051-.317.025-.381-.114-.021-.156-.081a2.493,2.493,0,0,1-.14-.674,1.365,1.365,0,0,1,.012-.434,1.526,1.526,0,0,1,.233.749l.092.11s-.054-.389-.092-.509-.108-.322-.108-.367a1.764,1.764,0,0,0,.045-.243.821.821,0,0,0-.013-.154.481.481,0,0,0,.153.069c.042-.009.108-.067.129-.312a7.354,7.354,0,0,0-.021-.969l-1.087,1.437Z",
    transform: "translate(-545.745 12.001)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7884",
    "data-name": "Caminho 7884",
    d: "M599.6,17.8a1.949,1.949,0,0,0,.1.782,2.169,2.169,0,0,0,.209.466,1.111,1.111,0,0,1-.024.523s-.276-.706-.377-1.059-.113-.482-.161-.511a.433.433,0,0,0-.132-.036Z",
    transform: "translate(-545.772 12.716)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7885",
    "data-name": "Caminho 7885",
    d: "M599.826,19.844c.036-.009.012-.165.012-.165l-.041-.372-.377-.783-.423-.37-.214-.341-.032.643a4.052,4.052,0,0,0,.5.831c.193.187.522.569.574.557",
    transform: "translate(-546.103 12.724)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7886",
    "data-name": "Caminho 7886",
    d: "M598.472,17.971a1.063,1.063,0,0,1,.063.285v.216s.153.31.29.559.276.5.39.442.161-.238.167-.257-.128.209-.2.171a6.608,6.608,0,0,1-.377-1.063c.008-.021-.084-.063-.147-.135a2.065,2.065,0,0,1-.186-.218",
    transform: "translate(-546.301 12.836)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7887",
    "data-name": "Caminho 7887",
    d: "M599.378,18.937s-.212-.357-.281-.509-.185-.273-.225-.273-.084-.314-.084-.314a.868.868,0,0,0,.264.278c.146.072.233.127.305.1a1.44,1.44,0,0,1,.044.326c0,.159-.024.393-.024.393",
    transform: "translate(-546.075 12.744)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7888",
    "data-name": "Caminho 7888",
    d: "M598.736,18.181a2.024,2.024,0,0,0,.221.434,4.672,4.672,0,0,0,.374.466,4.237,4.237,0,0,1-.391-.451,2.426,2.426,0,0,1-.231-.454Z",
    transform: "translate(-546.132 12.983)",
    fill: "#583c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7889",
    "data-name": "Caminho 7889",
    d: "M599.2,18.269s.069-.192.132-.2.185-.048.185-.048a.394.394,0,0,1-.2-.125c-.087-.111-.108-.1-.208-.213,0,0,.055.213.072.314a2.36,2.36,0,0,1,.015.273",
    transform: "translate(-545.847 12.631)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7890",
    "data-name": "Caminho 7890",
    d: "M599.135,18.062s.311.663.4.89a1.768,1.768,0,0,1,.056.55,2.208,2.208,0,0,0-.1-.429c-.072-.194-.357-.734-.377-.8a.45.45,0,0,1,.026-.209",
    transform: "translate(-545.852 12.901)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7891",
    "data-name": "Caminho 7891",
    d: "M599.821,18.826l.068-.97-.068-.35-.44-.972s-.021.149-.129.137a.935.935,0,0,1-.5-.286,1.586,1.586,0,0,1,.033.442,2.333,2.333,0,0,1-.057.333l.844,1.591Z",
    transform: "translate(-546.115 11.704)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7892",
    "data-name": "Caminho 7892",
    d: "M598.86,19.012s.132.156.206.137.051-.329-.046-.487a15.793,15.793,0,0,0-1.278-1.637,18.167,18.167,0,0,0,1.119,1.987",
    transform: "translate(-546.833 12.159)",
    fill: "#804428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7893",
    "data-name": "Caminho 7893",
    d: "M599.78,18.587c.019.063.1.5-.083.542-.249.057-1.378-1.505-1.554-1.721,0,0-.711-.442-.72-.555s.765.154.765.154l1.512,1.452a.676.676,0,0,1,.081.129",
    transform: "translate(-547.05 12.018)",
    fill: "#804428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7894",
    "data-name": "Caminho 7894",
    d: "M599.783,18.589l-.008,0a1.1,1.1,0,0,1,.04.269c0,.122-.031.25-.115.262l-.012.007c-.065,0-.185-.1-.329-.242a17.46,17.46,0,0,1-1.205-1.479.909.909,0,0,1-.117-.074c-.1-.06-.251-.168-.377-.257s-.231-.183-.231-.225c0-.007,0-.015.012-.015s.022-.007.044-.007a1.84,1.84,0,0,1,.413.091c.156.045.293.089.293.089v0l0,0,1.514,1.449a.159.159,0,0,1,.033.041.324.324,0,0,1,.042.091l.008,0a.493.493,0,0,0-.075-.134l-1.518-1.449a3.9,3.9,0,0,0-.706-.185c-.022,0-.038.005-.05.005a.029.029,0,0,0-.015.027.323.323,0,0,0,.121.141c.206.17.606.425.606.425v0c.081.1.4.535.733.933a5.9,5.9,0,0,0,.474.542c.143.147.262.242.334.242h.012c.1-.021.12-.153.12-.274a.951.951,0,0,0-.036-.273",
    transform: "translate(-547.053 12.016)",
    fill: "#583c24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7895",
    "data-name": "Caminho 7895",
    d: "M599.01,19.113a1.142,1.142,0,0,1-.137-.381,1.854,1.854,0,0,0-.069-.295c-.012-.051-.838-1.248-.925-1.327a2.794,2.794,0,0,0-.362-.23,2.305,2.305,0,0,1,.032.274.457.457,0,0,0,.007.108,6.027,6.027,0,0,0,.639.931c.372.43.814.919.814.919",
    transform: "translate(-546.983 12.058)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7896",
    "data-name": "Caminho 7896",
    d: "M599.745,19.121c.108-.063.065-.446.021-.566s-.715-1.522-.715-1.522l-.2.081-.378-.3-.22-.231a2.359,2.359,0,0,1,.069.5c-.005.161-.012.257-.012.257l.537.939Z",
    transform: "translate(-546.461 11.843)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7897",
    "data-name": "Caminho 7897",
    d: "M599.9,18.684l.159-.209-.082-.7-.439-1.524a.329.329,0,0,1-.231-.045,1.327,1.327,0,0,1-.225-.2l.112.907.464,1.281.02.379Z",
    transform: "translate(-545.863 11.433)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7898",
    "data-name": "Caminho 7898",
    d: "M599.382,18.407a7.339,7.339,0,0,1-.595-.73c-.144-.242-.267-.475-.267-.475a.4.4,0,0,1-.282-.015,1.252,1.252,0,0,1-.362-.288s-.125.243.518.905c.735.751.987.6.987.6",
    transform: "translate(-546.733 12.07)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7899",
    "data-name": "Caminho 7899",
    d: "M599.845,18.869c.188-.072.182-.862,0-1.4a5.161,5.161,0,0,0-.469-1,10.6,10.6,0,0,1,.444,1.209c.077.35,0,.6-.057.578s-.07-.209-.216-.545a1.287,1.287,0,0,0-.242-.427s.514,1.418.367,1.39a10.086,10.086,0,0,1-.888-1.639c-.033-.043-.057.06-.057.06s.64,1.959,1.113,1.771",
    transform: "translate(-546.115 11.766)",
    fill: "#804428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7900",
    "data-name": "Caminho 7900",
    d: "M599.822,15.646l.313.675.1.706.028.6s.017,1.183-.126,1.215a.2.2,0,0,1-.225-.141c-.012-.027-.271-1.334-.271-1.334l-.28-1.359.1-.1.027-.2.216-.01Z",
    transform: "translate(-545.667 11.176)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7901",
    "data-name": "Caminho 7901",
    d: "M599.745,18.811c.132-.015,0-.336,0-.336s-.1.153-.185.046a2.515,2.515,0,0,1-.22-.5l-.081-.233s-.1.264-.209.264-.733-1.039-.733-1.039l-.069.1s.859,1.783,1.5,1.694",
    transform: "translate(-546.461 12.152)",
    fill: "#804428"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7902",
    "data-name": "Caminho 7902",
    d: "M599.249,18.235a.988.988,0,0,0,.065-.482,4.92,4.92,0,0,0-.354-.816.447.447,0,0,1-.22-.022,2.254,2.254,0,0,1-.365-.2,5.991,5.991,0,0,0,.356.751c.184.317.518.77.518.77",
    transform: "translate(-546.371 11.939)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7903",
    "data-name": "Caminho 7903",
    d: "M599.481,18.111a4.116,4.116,0,0,0-.322-1.056,2.8,2.8,0,0,0-.413-.67,2.416,2.416,0,0,1,.008.314c0,.213,0,.252,0,.252a.888.888,0,0,1,.4.391,5.459,5.459,0,0,1,.322.77",
    transform: "translate(-546.106 11.704)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7904",
    "data-name": "Caminho 7904",
    d: "M599.76,17.687a5.666,5.666,0,0,0-.132-.927c-.089-.336-.19-.794-.19-.794a.108.108,0,0,1,.057-.065.115.115,0,0,1,.1-.007c.129.043.182.357.182.357s-.017-.485-.029-.5-.035-.084-.035-.084a.213.213,0,0,1-.1.021.981.981,0,0,1-.125-.021s.037.153-.027.221c-.045.045-.088-.045-.114-.06s-.024.069-.024.069a2.22,2.22,0,0,1,.057.317,1.112,1.112,0,0,1-.019.269,4.537,4.537,0,0,0,.191.569,4.657,4.657,0,0,1,.213.638",
    transform: "translate(-545.697 11.189)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7905",
    "data-name": "Caminho 7905",
    d: "M600.107,17.668a3.709,3.709,0,0,0-.092-1.392,1.805,1.805,0,0,0-.353-.687l-.089.1a3.087,3.087,0,0,1,.375.9c.091.446.159,1.077.159,1.077",
    transform: "translate(-545.515 11.135)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7906",
    "data-name": "Caminho 7906",
    d: "M599.614,17.826s-.1-.667-.213-1.1-.156-.583-.156-.583l-.182-.171a3.484,3.484,0,0,1,.1.59c-.012.132-.022.219-.022.219a3.071,3.071,0,0,0,.207.422,3.8,3.8,0,0,1,.267.619",
    transform: "translate(-545.879 11.411)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7907",
    "data-name": "Caminho 7907",
    d: "M599.865,18.756c.168.005.013-.955-.051-1.2s-.47-1.406-.47-1.406a17.746,17.746,0,0,1,.437,1.73c-.056.122-.242-.5-.278-.49s.362,1.109.214,1.128-.2-.235-.2-.235l.009.24a.394.394,0,0,0,.341.237",
    transform: "translate(-545.678 11.534)",
    fill: "#854729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7908",
    "data-name": "Caminho 7908",
    d: "M599.938,18.437c.124,0-.029-.912-.113-1.311s-.308-1.205-.308-1.205a7.762,7.762,0,0,1,.365,1.2c.132.634.216,1.469.1,1.481a.225.225,0,0,1-.191-.12l-.016-.149a.2.2,0,0,0,.168.108",
    transform: "translate(-545.555 11.371)",
    fill: "#854729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7909",
    "data-name": "Caminho 7909",
    d: "M599.138,18.124c.016.065.012.374-.152.353a.912.912,0,0,1-.53-.489s.36.4.478.4.127-.413.108-.516.1.252.1.252",
    transform: "translate(-546.313 12.752)",
    fill: "#32281e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7910",
    "data-name": "Caminho 7910",
    d: "M599.356,15.841a.415.415,0,0,0,.39.039.642.642,0,0,0,.278-.477.518.518,0,0,0-.117-.382c-.1-.144.171.113.164.367s.019.693-.386.787-.229-.024-.229-.024Z",
    transform: "translate(-545.669 10.7)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7911",
    "data-name": "Caminho 7911",
    d: "M599.17,15.032a3.745,3.745,0,0,1,.357.8c.1.377.077.525.018.53s-.086-.045-.1-.141-.273-1.185-.273-1.185",
    transform: "translate(-545.803 10.737)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7912",
    "data-name": "Caminho 7912",
    d: "M596.542,15.88l1.7,2.465,2.131-2.4-1.35-1.383Z",
    transform: "translate(-547.679 10.4)",
    fill: "#242626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7913",
    "data-name": "Caminho 7913",
    d: "M597.845,14.76l-.108.382.216.662.356.362.407.279.1-.309.1-.358.1-.039.262.1.168-.242.278-.5-.054-.192-.065-.144-.432-.746-.149.283-.135.082-.25-.142-.3.394-.363-.17Z",
    transform: "translate(-546.826 10.01)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7914",
    "data-name": "Caminho 7914",
    d: "M598.371,16.247a.388.388,0,0,0,.1-.245,4.384,4.384,0,0,0-.015-1.042,2.289,2.289,0,0,0-.242-.667,3.412,3.412,0,0,1,.209,1.1c-.045.586-.024.751-.149.811s.092.039.092.039",
    transform: "translate(-546.483 10.208)",
    fill: "#583a20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7915",
    "data-name": "Caminho 7915",
    d: "M598.365,15.341s.285.4.417.261.072-.653-.019-.855-.185-.492-.185-.492l.083-.086s.1.341.146.55.216.835.024.948-.459-.226-.459-.226Z",
    transform: "translate(-546.377 10.12)",
    fill: "#583a20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7916",
    "data-name": "Caminho 7916",
    d: "M597.836,15.081a.373.373,0,0,1,.218-.153c.132-.015.152.039.152.039l.118.334.19.338.168.168-.1.1-.141.024s-.4-.211-.406-.223-.111-.153-.111-.153Z",
    transform: "translate(-546.756 10.661)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7917",
    "data-name": "Caminho 7917",
    d: "M598.985,18.428c-.134.063-.437-.089-.607-.24s-1.081-1.08-1.081-1.08l-.133-.509.356.094.612-.267.121-.213.737-.386.408-.228.9-.012.206-.442a4.511,4.511,0,0,1,.356.739,2.033,2.033,0,0,1-.037.914c-.076.041-.366-.2-.413-.216s.223.915,0,.955-.582-.348-.582-.348.147.835-.027.842a1.543,1.543,0,0,1-.807-.413s.214.687-.01.811",
    transform: "translate(-547.235 10.818)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7918",
    "data-name": "Caminho 7918",
    d: "M598.355,16.538s.146.209.192.281a1.247,1.247,0,0,1-.036.533c-.051.156-.261-.183-.369-.468,0,0-.333-.547-.35-.612s.562.266.562.266",
    transform: "translate(-546.786 11.615)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7919",
    "data-name": "Caminho 7919",
    d: "M599.662,15.366s.317,1.3.164,1.353-.586-.417-.638-.478-.655-1.032-.655-1.032l-.124-.129.04-.07.257.1Z",
    transform: "translate(-546.345 10.721)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7920",
    "data-name": "Caminho 7920",
    d: "M598.353,17.3c-.068.051-.208-.168-.266-.228s-.281-.314-.485-.523a1.985,1.985,0,0,1-.356-.41c0-.043-.134-.177-.134-.177l.116-.137.141-.026a11.531,11.531,0,0,1,.924.8,1.808,1.808,0,0,1,.06.7",
    transform: "translate(-547.273 11.288)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7921",
    "data-name": "Caminho 7921",
    d: "M599.221,17.448a2.6,2.6,0,0,1-.854-.727,6.452,6.452,0,0,1-.55-.8l-.1-.3.173.036a19.282,19.282,0,0,1,1.335,1.79",
    transform: "translate(-546.844 11.159)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7922",
    "data-name": "Caminho 7922",
    d: "M598.927,16.672c-.028.036-.278-.149-.43-.353a.538.538,0,0,1-.072-.453,6.242,6.242,0,0,1,.5.806",
    transform: "translate(-546.35 11.333)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7923",
    "data-name": "Caminho 7923",
    d: "M599.4,17c-.075.039-.406-.362-.68-.807-.2-.326-.247-.381-.292-.408a.806.806,0,0,0-.22-.065l-.025-.041.147-.034.107-.129.169-.218.679,1.37s.169.309.114.333",
    transform: "translate(-546.504 10.926)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7924",
    "data-name": "Caminho 7924",
    d: "M598.822,17.833c0,.046-.006.1-.2.082a3.376,3.376,0,0,1-1.588-1.248c-.432-.711-.494-.8-.494-.8l.192-.221,1.54,1.75Z",
    transform: "translate(-547.678 11.173)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7925",
    "data-name": "Caminho 7925",
    d: "M598.773,17.888c.015.082-.084.106-.177.077a2.476,2.476,0,0,1-1.1-.845,5.278,5.278,0,0,1-.859-1.186c0-.01-.025-.29-.025-.29l.173-.079,1.052,1.608Z",
    transform: "translate(-547.63 11.118)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7926",
    "data-name": "Caminho 7926",
    d: "M598.942,17.3a3.521,3.521,0,0,1-.526-.466,3.763,3.763,0,0,1-.6-.922c.007-.12.18-.12.18-.12l-.01-.274.047-.1.3.12.371.461.141.185s.242.586.2.639-.394-.329-.433-.281.389.717.333.758",
    transform: "translate(-546.771 11.014)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7927",
    "data-name": "Caminho 7927",
    d: "M598.748,17.172s.112.161.06.269-.091.173-.249-.06a2.552,2.552,0,0,0-.358-.475c-.015.021.021.358-.06.358s-.32-.293-.48-.521-.394-.622-.394-.622a1.851,1.851,0,0,0,.008-.341,3.314,3.314,0,0,0-.032-.406,1.2,1.2,0,0,0,.051.147.386.386,0,0,0,.069.106l.574.677.16-.113.339.66Z",
    transform: "translate(-547.179 10.981)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7928",
    "data-name": "Caminho 7928",
    d: "M596.855,15.851a7.509,7.509,0,0,0,.852,1.215,2.927,2.927,0,0,0,.893.619L597.253,16.1Z",
    transform: "translate(-547.456 11.322)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7929",
    "data-name": "Caminho 7929",
    d: "M599.159,16.909a2.092,2.092,0,0,1-.469-.542,1.866,1.866,0,0,1-.3-.8c.012-.168.057-.559.057-.559a3.916,3.916,0,0,1,.549.7c.087.223.278.528.233.562s-.345-.209-.381-.153.354.765.312.794",
    transform: "translate(-546.361 10.721)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7930",
    "data-name": "Caminho 7930",
    d: "M599.4,16.646c-.053.027-.282-.24-.35-.41a2.667,2.667,0,0,1-.084-.506l-.2-.477.021-.538.2-.033.305.425a1.437,1.437,0,0,1,.117.614,4.165,4.165,0,0,1-.012.924",
    transform: "translate(-546.088 10.488)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7931",
    "data-name": "Caminho 7931",
    d: "M597.366,17.192a6.991,6.991,0,0,1-.663-.984l-.137-.456.077.058a2.619,2.619,0,0,0,.754,1.152,4.391,4.391,0,0,0,.775.675s.128.338.06.461a8.689,8.689,0,0,1-.867-.907",
    transform: "translate(-547.662 11.251)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7932",
    "data-name": "Caminho 7932",
    d: "M598.128,17.956a10,10,0,0,1-.972-1.02,7.6,7.6,0,0,1-.7-1.066l.192-.173a8.049,8.049,0,0,0,.61,1.171c.261.329.871,1.089.871,1.089",
    transform: "translate(-547.742 11.212)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7933",
    "data-name": "Caminho 7933",
    d: "M598.477,17.624s-.637-.617-.954-.977a3.332,3.332,0,0,1-.5-.711l.263.108a2.6,2.6,0,0,0,.333.559c.229.288.855,1.022.855,1.022",
    transform: "translate(-547.333 11.382)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7934",
    "data-name": "Caminho 7934",
    d: "M598.151,16.8s-.345-.422-.509-.686-.33-.6-.33-.6a3.492,3.492,0,0,0,.6.566c.135.031.129-.009.129-.009a.76.76,0,0,0-.009.35c.048.159.121.377.121.377",
    transform: "translate(-547.13 11.085)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7935",
    "data-name": "Caminho 7935",
    d: "M597.927,15.276a1.561,1.561,0,0,1,.021.465c-.036.173-.131.173-.131.173a3.037,3.037,0,0,0,.287.358,2.78,2.78,0,0,0,.356.288s-.207-.288-.288-.437-.209-.314-.152-.454.332.1.409.165.413.454.413.454a1.573,1.573,0,0,0-.286-.554c-.165-.149-.629-.458-.629-.458",
    transform: "translate(-546.769 10.911)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7936",
    "data-name": "Caminho 7936",
    d: "M599.11,16.427s-.173-.43-.272-.689-.261-.828-.261-.828.012.257,0,.449-.089.482-.168.526-.1.045-.259,0,.106.072.106.072a.342.342,0,0,0,.225-.079c.072-.077.083-.242.159-.221s.146.276.209.384.26.382.26.382",
    transform: "translate(-546.566 10.65)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7937",
    "data-name": "Caminho 7937",
    d: "M598.379,15.17s.329.374.47.213.056-.643.056-.643.2.075.269.024.033-.231.033-.231.354.518.528.855a3.86,3.86,0,0,1,.261.934,5.562,5.562,0,0,1-.446-.934c-.136-.417-.339-.6-.369-.566a.779.779,0,0,0-.047.483c.041.149.167.346.245.559s.176.547.176.547-.165-.254-.266-.393a1.6,1.6,0,0,0-.272-.267,1.189,1.189,0,0,0-.269-.226c-.1-.034-.293-.137-.293-.058s-.04-.156-.04-.156Z",
    transform: "translate(-546.367 10.38)",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7938",
    "data-name": "Caminho 7938",
    d: "M597.728,15.833a5.461,5.461,0,0,0,.326.55c.148.2.348.461.348.461a3.92,3.92,0,0,1-.432-.461,2.707,2.707,0,0,1-.242-.55",
    transform: "translate(-546.833 11.309)",
    fill: "#1d1d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7939",
    "data-name": "Caminho 7939",
    d: "M599.077,15.894c-.05.024-.206-.039-.214.024a.741.741,0,0,0,.193.381c.115.113.159.118.19.1s-.014-.115-.038-.231,0-.238-.013-.278-.119,0-.119,0",
    transform: "translate(-546.023 11.341)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7940",
    "data-name": "Caminho 7940",
    d: "M596.889,14.567l-.188.12-.23.466.061.854s.21.3.342.487.563.677.674.65.229-.369.245-.55.028-.521.028-.521a2.11,2.11,0,0,0,.284.377c.178.2.331.381.415.369s.339-.516.344-.578-.63-1.617-.63-1.617l-.28-.144Z",
    transform: "translate(-547.731 10.343)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7941",
    "data-name": "Caminho 7941",
    d: "M597.539,15.965s.111.4.183.595-.007.363.033.369a1.346,1.346,0,0,0,.37-.639,4.965,4.965,0,0,0-.083-1.022c-.093-.612.027-.789.027-.789l-.192-.156-.326.658Z",
    transform: "translate(-546.968 10.231)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7942",
    "data-name": "Caminho 7942",
    d: "M596.894,15.488s.076.6.113.8.16.526.219.523a1.633,1.633,0,0,0,.266-.708,2.048,2.048,0,0,1-.128-.895c0-.641-.063-.706-.063-.706Z",
    transform: "translate(-547.428 10.358)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7943",
    "data-name": "Caminho 7943",
    d: "M596.6,14.358a2.767,2.767,0,0,0-.485,1.128c.006.4.075.309.191.67a6.789,6.789,0,0,1,.177.934c.012.048.083-.022.1-.072s.021-2.661.021-2.661",
    transform: "translate(-547.989 10.256)",
    fill: "#453c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7944",
    "data-name": "Caminho 7944",
    d: "M596.558,14.407a2.582,2.582,0,0,0-.4,1.051,1.719,1.719,0,0,0,.22.7,3.5,3.5,0,0,1,.132.883.967.967,0,0,0,.293-.156,1.292,1.292,0,0,0,.3-.338l-.152-.341a1.255,1.255,0,0,1-.117-.3l-.124-.185.036-.65.115-.466v-.177Z",
    transform: "translate(-547.958 10.291)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7945",
    "data-name": "Caminho 7945",
    d: "M597.957,15.253a1.566,1.566,0,0,1-.305-.093.363.363,0,0,1-.135-.183l.059-.125Z",
    transform: "translate(-546.984 10.609)",
    fill: "#d1ab6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7946",
    "data-name": "Caminho 7946",
    d: "M596.56,14.454a3.077,3.077,0,0,0-.278,1.155,3.229,3.229,0,0,0,.322,1.073c.021.007.012-.045.021-.149s-.014-1.4-.014-1.4l.153-.454.008-.237Z",
    transform: "translate(-547.867 10.316)",
    fill: "#c8a369"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7947",
    "data-name": "Caminho 7947",
    d: "M597.063,14.686a.9.9,0,0,1,.018.288c-.029.089-.2.194-.269.329a4.51,4.51,0,0,0-.165.439,1.235,1.235,0,0,1,.18-.29c.1-.111.147-.189.171-.12a1.438,1.438,0,0,1,.032.382,1.257,1.257,0,0,0-.164.315.683.683,0,0,0,.012.377s.04-.228.069-.345a.273.273,0,0,1,.116-.156l.177.374a1.868,1.868,0,0,1,.027-.31.557.557,0,0,1,.214-.324c.051,0,.123-.029-.053-.117a1.694,1.694,0,0,1,.028-.715c.044-.024.289-.029.269-.129a1.965,1.965,0,0,0-.264-.35,3.133,3.133,0,0,0-.4.35",
    transform: "translate(-547.605 10.24)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7948",
    "data-name": "Caminho 7948",
    d: "M597.894,15.447s-.153-.031-.242-.041a.122.122,0,0,1-.093-.1l.029-.1.191.1Z",
    transform: "translate(-546.954 10.864)",
    fill: "#d1ab6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7949",
    "data-name": "Caminho 7949",
    d: "M596.808,16.085a.877.877,0,0,1-.089.237c-.036.12-.063.261-.063.261s-.044-.314-.064-.537a1.053,1.053,0,0,0-.05-.374c-.025-.012-.109.1-.109.1a1.261,1.261,0,0,1,.051-.365c.048-.118.084-.285.041-.31s-.132.045-.168.1-.109.2-.109.2a1.229,1.229,0,0,1,.093-.295,4.705,4.705,0,0,0,.334-.466.694.694,0,0,0,.039-.218l.169-.007s.167.139.172.252c0,.063-.161.137-.167.144s-.138-.015-.174.535.114.5.1.73",
    transform: "translate(-547.891 10.303)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7950",
    "data-name": "Caminho 7950",
    d: "M597.549,14.743a1.671,1.671,0,0,1,0,.382,2.181,2.181,0,0,1-.185.281,1.167,1.167,0,0,0-.057.4.736.736,0,0,1,.084-.223c.057-.086.092-.161.113-.161s.084.108.127.261.129.41.129.41-.04-.2.014-.2a.15.15,0,0,1,.139.036c.068.053.152.129.152.129a.408.408,0,0,0-.112-.183c-.1-.1-.152-.094-.185-.242a.951.951,0,0,1-.033-.341c.018-.057.081.033.144.108s.239.225.239.225-.084-.117-.1-.156a4.293,4.293,0,0,1,0-.478c.007-.161,0-.305.057-.35a.314.314,0,0,0,.036-.288,3.757,3.757,0,0,0-.562.389",
    transform: "translate(-547.129 10.251)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7951",
    "data-name": "Caminho 7951",
    d: "M598.817,14.572a4.42,4.42,0,0,0,.056.533c.052.189.177.612.177.612a3.2,3.2,0,0,1-.25-.586c-.079-.273-.147-.566-.219-.583s-.146.129-.146.24a2.025,2.025,0,0,0,.165.684,1.309,1.309,0,0,1-.2-.374c-.061-.185-.121-.346-.121-.346a.775.775,0,0,0-.04.329,1.562,1.562,0,0,0,.171.418,1.859,1.859,0,0,1-.149-.153.747.747,0,0,0-.115-.113.977.977,0,0,0,.079.338c.06.1.18.269.18.269a2.009,2.009,0,0,1-.2-.177.247.247,0,0,1-.068-.108,2.1,2.1,0,0,0,.1.518c.072.183.232.478.232.478a1.293,1.293,0,0,1-.324-.447,4.165,4.165,0,0,1-.154-1.317s.1-.168.182-.3a3.658,3.658,0,0,0,.207-.751,3.035,3.035,0,0,0,.242.682.581.581,0,0,0,.2.153",
    transform: "translate(-546.653 9.812)",
    fill: "#242626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7952",
    "data-name": "Caminho 7952",
    d: "M597.964,14.122a1.592,1.592,0,0,0,.12.223c.041.069.093.158.093.158s-.173.178-.366.336-.452.312-.509.223a.29.29,0,0,1-.057-.154,2.066,2.066,0,0,0,.382-.295,1.017,1.017,0,0,0,.259-.355.7.7,0,0,1,.077-.135",
    transform: "translate(-547.177 10.087)",
    fill: "#242626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7953",
    "data-name": "Caminho 7953",
    d: "M596.637,14.628s.032.358.184.358.6-.458.631-.483a.312.312,0,0,0,.062-.168.561.561,0,0,0-.029-.123s-.478.492-.654.513a.213.213,0,0,1-.192-.1",
    transform: "translate(-547.611 10.151)",
    fill: "#242626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7954",
    "data-name": "Caminho 7954",
    d: "M596.838,14.178a3.294,3.294,0,0,0-.053.326.564.564,0,0,0,.034.13s-.35.12-.4.007a.371.371,0,0,1-.023-.25,1.142,1.142,0,0,0,.25-.019c.091-.022.192-.194.192-.194",
    transform: "translate(-547.794 10.127)",
    fill: "#242626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7955",
    "data-name": "Caminho 7955",
    d: "M598.561,13.882s.149.374.233.521.236.451.236.451-.236-.269-.3-.326-.192-.165-.192-.165a.662.662,0,0,0,.034-.173c0-.075-.007-.309-.007-.309",
    transform: "translate(-546.256 9.916)",
    fill: "#242626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7956",
    "data-name": "Caminho 7956",
    d: "M596.376,14.921s.129.012.206.012a.252.252,0,0,0,.132-.043l.128-.19a.942.942,0,0,0-.017.4c.048.168.141.194.178.194a.627.627,0,0,0,.365-.19,3.525,3.525,0,0,1,.34-.3.811.811,0,0,0,.025.425c.079.209.192.209.363.075a3.442,3.442,0,0,0,.415-.456,1.129,1.129,0,0,0,.108-.166l.183-.147.158-.874-.089-.113-.221.113-.271-.113-.081-.1-.152.261-.165.108-.084.012-.19.036-.081-.168-.048-.129-.093-.048-.389.4-.225-.015-.222.345-.156.228-.165.379Z",
    transform: "translate(-547.83 9.6)",
    fill: "#d1ab6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7957",
    "data-name": "Caminho 7957",
    d: "M597.6,13.948a1.5,1.5,0,0,1-.072.583,3.33,3.33,0,0,1-.262.622,1.662,1.662,0,0,0,.579-.667,2.169,2.169,0,0,0,.145-.919Z",
    transform: "translate(-547.165 9.691)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7958",
    "data-name": "Caminho 7958",
    d: "M597.787,13.8s.045.065,0,.389a5.974,5.974,0,0,1-.12.65s.048.081.1.182.186.3.277.264a.676.676,0,0,0,.338-.362,3.23,3.23,0,0,1,.225-.459c.039-.033.056.022.072.034s.043.206.139.283.218.2.271.168a.259.259,0,0,0,.1-.2c-.012-.057-.209-.646-.209-.646l-.25-.638-.159-.247-.453.045Z",
    transform: "translate(-546.876 9.441)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7959",
    "data-name": "Caminho 7959",
    d: "M598.211,13.217a1.7,1.7,0,0,1,.14.571,3.522,3.522,0,0,1-.063.605,3,3,0,0,0-.013-.593c-.043-.221-.1-.365-.1-.434a.849.849,0,0,1,.036-.149",
    transform: "translate(-546.514 9.441)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7960",
    "data-name": "Caminho 7960",
    d: "M598.815,14.383a1.638,1.638,0,0,1,0,.381c-.027.122-.2-.082-.31-.483a6.857,6.857,0,0,0-.175-.687,3.279,3.279,0,0,1-.134-.362l.225-.033Z",
    transform: "translate(-546.499 9.427)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7961",
    "data-name": "Caminho 7961",
    d: "M597.975,15.12a1.214,1.214,0,0,0,.49-.991,2.645,2.645,0,0,0-.2-.912,3.275,3.275,0,0,1-.156.991c-.167.386-.3.643-.3.643a.414.414,0,0,0,.157-.111c.052-.06.124-.166.124-.166a.533.533,0,0,1-.017.257c-.04.142-.1.29-.1.29",
    transform: "translate(-546.774 9.441)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7962",
    "data-name": "Caminho 7962",
    d: "M598,13.791a.489.489,0,0,1-.2.31,3.525,3.525,0,0,1-.516.309,1.552,1.552,0,0,0,.331-.418.373.373,0,0,0,.021-.321.374.374,0,0,1-.129.189.622.622,0,0,1-.26.093.386.386,0,0,1,.1-.2c.021-.027.016-.072.028-.115a2.376,2.376,0,0,1,.19-.379,1.368,1.368,0,0,0,.207.334l.222.2",
    transform: "translate(-547.177 9.469)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7963",
    "data-name": "Caminho 7963",
    d: "M598.716,13.074a2.7,2.7,0,0,1,.144.639,4.145,4.145,0,0,1-.007.79,5.018,5.018,0,0,1-.274-.485c-.058-.142-.058-.353-.108-.458a.44.44,0,0,0-.171-.165.424.424,0,0,0-.157-.026.254.254,0,0,0,.137-.177.62.62,0,0,0,0-.168.785.785,0,0,0,.219.06.509.509,0,0,0,.218-.012",
    transform: "translate(-546.537 9.304)",
    fill: "#242626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7964",
    "data-name": "Caminho 7964",
    d: "M598.065,14.661a1.957,1.957,0,0,0,.3-.746.926.926,0,0,0-.015-.543.417.417,0,0,1-.172-.093,2.093,2.093,0,0,1-.209-.279,1.408,1.408,0,0,1-.007.465,1.212,1.212,0,0,1-.281.509.323.323,0,0,0,.233-.019.452.452,0,0,0,.219-.4s.05.034.05.353a4.189,4.189,0,0,1-.122.758",
    transform: "translate(-546.864 9.286)",
    fill: "#242626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7965",
    "data-name": "Caminho 7965",
    d: "M596.272,15.016c-.051-.009.158-.333.3-.554s.339-.531.339-.531a.163.163,0,0,0,.12.029.6.6,0,0,0,.389-.266,1.573,1.573,0,0,0,.158-.393.848.848,0,0,0,.146.466c.163.187.156.168.225.156a2.04,2.04,0,0,1-.068.453c-.06.214-.122.528-.122.528a1.556,1.556,0,0,0-.044-.526c-.063-.118-.1.01-.163.159a.684.684,0,0,1-.182.254,2.62,2.62,0,0,0,.156-.367c.064-.2.032-.2.017-.2s-.044-.01-.117.065a.3.3,0,0,1-.132.108.368.368,0,0,0,.1-.168,1.131,1.131,0,0,1,.154-.29.275.275,0,0,0,.079-.146c0-.038-.007-.123-.04-.123s-.072.053-.225.194-.173.153-.2.207a2.805,2.805,0,0,0-.144.418,1.864,1.864,0,0,1-.173.442.273.273,0,0,1-.083.067s.056-.159.128-.377a2.092,2.092,0,0,0,.161-.55.066.066,0,0,0-.115,0c-.021.041-.174.226-.327.449s-.146.5-.186.507c0,0-.1,0-.152-.009",
    transform: "translate(-547.878 9.497)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7966",
    "data-name": "Caminho 7966",
    d: "M598.794,12.922a.228.228,0,0,1-.149.24.582.582,0,0,1-.384-.027.93.93,0,0,1-.021-.23Z",
    transform: "translate(-546.466 9.218)",
    fill: "#7f4f28"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7967",
    "data-name": "Caminho 7967",
    d: "M596.859,13.217a1.413,1.413,0,0,1-.12.336c-.085.187-.233.346-.221.37a.313.313,0,0,0,.237.1c.125,0,.177-.775.177-.775l-.024-.027Z",
    transform: "translate(-547.697 9.441)",
    fill: "#a67032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7968",
    "data-name": "Caminho 7968",
    d: "M598.841,13.228s-.06,1.032-.346,1.032-.422-.523-.422-.523-.025.7-.393.7c-.173,0-.345-.538-.309-.634a1.04,1.04,0,0,1-.245.509c-.345.276-.563.137-.575.1a1.9,1.9,0,0,0,.332-.737s.05.012.138-.1.132-.254.218-.23a1.9,1.9,0,0,0,.5-.173l.221-.273s.028.086.185-.021a.618.618,0,0,0,.212-.269l.432.358Z",
    transform: "translate(-547.673 8.998)",
    fill: "#d1ab6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7969",
    "data-name": "Caminho 7969",
    d: "M597.227,12.521s.264.393.434.614c.011.012.1-.084.1-.084.057.081.089.146.075.189a.659.659,0,0,0-.1.6.483.483,0,0,1,.021-.29c.068-.168.111-.223.146-.216s.108.943.165.936.144-.422.144-.72.061-.051.087.009.285.473.5.406.192-.442.186-.535-.156-.6-.156-.6l-.977-.615s-.032.077-.083.25-.542.051-.542.051",
    transform: "translate(-547.19 8.728)",
    fill: "#a67032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7970",
    "data-name": "Caminho 7970",
    d: "M598.268,12.494a1.241,1.241,0,0,1,.152.3c.094.245.1,1.029-.022,1.025a.663.663,0,0,1-.42-.254c-.039-.1.015-.494-.066-.605a1.265,1.265,0,0,1-.187-.446c0-.077.019-.31.019-.31l.218-.081Z",
    transform: "translate(-546.835 8.66)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7971",
    "data-name": "Caminho 7971",
    d: "M598.122,12.244l.422.622.365.533a1.22,1.22,0,0,1,.182.074.4.4,0,0,1-.5.079c-.142-.079-.072-.329-.257-.734a1.292,1.292,0,0,0-.508-.574l.114-.113Z",
    transform: "translate(-546.764 8.665)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7972",
    "data-name": "Caminho 7972",
    d: "M598.081,12a1.736,1.736,0,0,1,.5.518,5.842,5.842,0,0,0,.372.689,1.62,1.62,0,0,0,.322.362.2.2,0,0,1-.2-.019.733.733,0,0,1-.225-.252c-.068-.118-.3-.552-.389-.663a1.348,1.348,0,0,0-.371-.305c0,.019.085.081.246.338a1.369,1.369,0,0,1,.191.494,2.753,2.753,0,0,1-.191-.329c-.136-.233-.438-.531-.453-.487s.148.317.229.473a2.719,2.719,0,0,1,.206.531c-.009,0-.106-.206-.273-.466a1.552,1.552,0,0,0-.267-.314c-.07-.079-.216-.276-.216-.276a.381.381,0,0,0,.293-.048.71.71,0,0,0,.222-.245",
    transform: "translate(-546.948 8.571)",
    fill: "#242626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7973",
    "data-name": "Caminho 7973",
    d: "M597.312,12.4a1.288,1.288,0,0,0,.369.041,1.153,1.153,0,0,1,.173-.01.42.42,0,0,1,.083.226.631.631,0,0,1-.125.353c-.034,0-.027-.206-.087-.281s-.413-.329-.413-.329",
    transform: "translate(-547.13 8.859)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7974",
    "data-name": "Caminho 7974",
    d: "M597.581,12.768a1.606,1.606,0,0,1,.017.622,1.438,1.438,0,0,1-.324.739c-.057,0-.032-.413-.06-.631,0-.021,0-.043,0-.063s-.085.276-.093.245.072-.379.067-.406a1.28,1.28,0,0,0-.016-.135l.266-.319Z",
    transform: "translate(-547.268 9.12)",
    fill: "#a67032"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7975",
    "data-name": "Caminho 7975",
    d: "M597.387,13.094c-.068.093-.182.069-.284.1s-.134.177-.134.177.074-.057.113-.041.084.015.007.189a3.377,3.377,0,0,1-.345.49,2.194,2.194,0,0,0,.422-.406.835.835,0,0,0,.108-.288.352.352,0,0,1,.164-.12c.026-.005.086,0,.11.108a3.929,3.929,0,0,0,.084.422,1.605,1.605,0,0,0,.132-.422,2.753,2.753,0,0,0,.028-.458l-.093-.021a1.567,1.567,0,0,1-.252-.137.669.669,0,0,1-.06.406",
    transform: "translate(-547.536 9.063)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7976",
    "data-name": "Caminho 7976",
    d: "M598.594,11.923a.385.385,0,0,1-.114.422.323.323,0,0,1-.223.084.854.854,0,0,1-.281-.084l-.623-.262-.326-.1-.165-.045.024-.183.49.022.48.19.209.06.178.036h.144l.108-.036s.054-.014.067-.045a.405.405,0,0,0,.029-.057",
    transform: "translate(-547.45 8.394)",
    fill: "#d1ab6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7977",
    "data-name": "Caminho 7977",
    d: "M598.55,11.931a.257.257,0,0,1-.089.2.462.462,0,0,1-.317.012c-.187-.041-.377-.161-.59-.221a1.926,1.926,0,0,0-.524-.1c-.165.005-.082-.07-.082-.07a1.693,1.693,0,0,1,.692.082,1.922,1.922,0,0,0,.625.2c.245,0,.286-.1.286-.1",
    transform: "translate(-547.406 8.387)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7978",
    "data-name": "Caminho 7978",
    d: "M596.874,11.751a.388.388,0,0,0,.136.005.189.189,0,0,0,.109-.045s.009.087-.033.115a.5.5,0,0,1-.185.012c-.021,0-.027-.087-.027-.087",
    transform: "translate(-547.442 8.366)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7979",
    "data-name": "Caminho 7979",
    d: "M598.162,12.4s.216.2.16.394l-.423-.2-.687-.281-.37-.11-.046-.06a.745.745,0,0,0,.1-.127.209.209,0,0,0,.022-.125l.458.057.474.149Z",
    transform: "translate(-547.5 8.496)",
    fill: "#d1ab6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7980",
    "data-name": "Caminho 7980",
    d: "M598.017,12.537s.394.509.3.675l-.912-.579-.324.533-.748-.375s.607-.466.67-.547.077-.123.077-.123l.345.067.533.17Z",
    transform: "translate(-547.827 8.657)",
    fill: "#d1ab6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7981",
    "data-name": "Caminho 7981",
    d: "M597.221,11.927a2.964,2.964,0,0,1,.518.185,1.559,1.559,0,0,0,.5.132.5.5,0,0,1-.337.132,1.132,1.132,0,0,1-.332-.207,2.1,2.1,0,0,0-.407-.161Z",
    transform: "translate(-547.237 8.519)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7982",
    "data-name": "Caminho 7982",
    d: "M596.868,11.829a2.14,2.14,0,0,1,.37.113c.144.06.156.048.188.027s.043-.027.043-.027.033.135-.081.135a.714.714,0,0,1-.3-.1.238.238,0,0,0-.231,0Z",
    transform: "translate(-547.453 8.449)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7983",
    "data-name": "Caminho 7983",
    d: "M598.231,12.53s.165.1.135.123a.635.635,0,0,1-.259.07.562.562,0,0,1-.31-.057c-.1-.045-.165-.226-.407-.322s-.285-.1-.452-.147a.867.867,0,0,0-.209-.038l.156-.069.528.11.449.132.268.129Z",
    transform: "translate(-547.545 8.636)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7984",
    "data-name": "Caminho 7984",
    d: "M597.335,12.609l.1.413-.053.25-.141.087-.132-.053-.04-.075a.176.176,0,0,0,0-.182c-.053-.084-.322-.183-.322-.183s.108-.206.229-.25.061-.2.061-.2Z",
    transform: "translate(-547.532 8.866)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7985",
    "data-name": "Caminho 7985",
    d: "M596.845,12.035a.48.48,0,0,0,.252.093,1.611,1.611,0,0,1,.35.072c.044.015.157-.051.168-.045l-.1.06a3.73,3.73,0,0,1,.406.141.913.913,0,0,1,.312.214c-.01,0-.1-.058-.312-.146a2.811,2.811,0,0,0-.485-.153,6.945,6.945,0,0,0-.694-.063c-.062-.021.027-.026.06-.06a.176.176,0,0,0,.04-.113",
    transform: "translate(-547.55 8.596)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7986",
    "data-name": "Caminho 7986",
    d: "M597.906,12.914s.1.1-.007.144a.611.611,0,0,1-.523-.115.64.64,0,0,0-.083-.2,2.417,2.417,0,0,0-.379-.269c-.124-.077.042-.081.042-.081s.429.159.586.245a2.908,2.908,0,0,1,.365.276",
    transform: "translate(-547.448 8.852)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7987",
    "data-name": "Caminho 7987",
    d: "M598.155,13.017a1.873,1.873,0,0,0-.8-.526c-.015,0,.2-.033.18-.036s-.279,0-.305,0a1.009,1.009,0,0,0-.139-.048c-.311-.1-.331-.087-.353-.129s-.06.005-.086.057a1.044,1.044,0,0,1-.116.156,1.011,1.011,0,0,1,.4-.015c.173.036.166.1.154.171s-.23.329-.2.334.141-.249.307-.209a.294.294,0,0,1,.206.125.254.254,0,0,0-.033-.132c-.03-.041-.207-.2-.159-.2a1.662,1.662,0,0,1,.534.185,1.386,1.386,0,0,1,.41.269",
    transform: "translate(-547.685 8.758)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7988",
    "data-name": "Caminho 7988",
    d: "M596.922,12.437a.6.6,0,0,1,.427.6c-.022.475-.367.389-.4.218s.044.079.169.055.161-.163.153-.345a.464.464,0,0,0-.153-.369c-.11-.1-.2-.161-.2-.161",
    transform: "translate(-547.408 8.884)",
    fill: "#d1ab6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7989",
    "data-name": "Caminho 7989",
    d: "M596.191,11.768s.042.033-.083.374a1.817,1.817,0,0,1-.394.669c-.36.391-.518.4-.478.571a.156.156,0,0,0,.208.122c.03.007.682-.951.682-.951l.148-.578-.04-.158Z",
    transform: "translate(-548.617 8.406)",
    fill: "#664121"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7990",
    "data-name": "Caminho 7990",
    d: "M597.745,11.381a1.286,1.286,0,0,1,.133.818c-.062.53-.763,1-.763,1l-1.025.706-.425-.021a.481.481,0,0,1-.132-.01c-.065-.017-.132-.084-.149-.084s-.076-.182-.076-.182l.137-.168.372-.37.229-.333a1.178,1.178,0,0,0,.122-.382.6.6,0,0,0-.033-.279l.087.132.042.281-.037.314.269-.177.354-.158s.1-.019.169-.216a2.353,2.353,0,0,0,.127-.615,2.468,2.468,0,0,0-.012-.291.09.09,0,0,1,.044.015.612.612,0,0,1,.113.269c0,.1.067.441.067.441l.157-.165a1.039,1.039,0,0,0,.152-.233.694.694,0,0,0,.076-.288",
    transform: "translate(-548.56 8.101)",
    fill: "#d1ab6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7991",
    "data-name": "Caminho 7991",
    d: "M597.085,12.981s.063.06.041.254a.352.352,0,0,1-.259.3l0-.273-.227-.18-.24-.075a.554.554,0,0,0,.041-.038,1.622,1.622,0,0,1,.279-.139Z",
    transform: "translate(-547.779 9.167)",
    fill: "#854729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7992",
    "data-name": "Caminho 7992",
    d: "M596.853,13.028a.2.2,0,0,0,.185.036.2.2,0,0,0,.1-.278c-.061-.069-.04.173-.108.2s-.153-.183-.25-.2a.355.355,0,0,0-.3.113c-.033.063.164.012.164.012l.1.031.079.014Z",
    transform: "translate(-547.727 9.124)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7993",
    "data-name": "Caminho 7993",
    d: "M596.087,13.292a.821.821,0,0,0,.278.024,2.892,2.892,0,0,0,.5-.17,1.536,1.536,0,0,0,.279-.207,1.259,1.259,0,0,0,.547-.823,1.924,1.924,0,0,0-.062-.751,1.06,1.06,0,0,1,.072,1.317,1.714,1.714,0,0,1-.592.59s.538-.156.589-.024a.592.592,0,0,1-.042.369s.305.065.356.221c.024.1-.356-.108-.638-.039a.764.764,0,0,0-.406.237s-.051-.081-.312-.081c-.242,0-.365.117-.507.108a1.332,1.332,0,0,1-.682-.225s.11-.132.3-.353c.133-.249.317-.192.317-.192",
    transform: "translate(-548.447 8.118)",
    fill: "#854729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7994",
    "data-name": "Caminho 7994",
    d: "M596.511,12.02a1.831,1.831,0,0,0,.293-.37.9.9,0,0,0,.081-.285.589.589,0,0,1-.1.37,2.178,2.178,0,0,1-.271.326Z",
    transform: "translate(-547.702 8.118)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7995",
    "data-name": "Caminho 7995",
    d: "M596.909,11.468s.18.7-.012.981a3.493,3.493,0,0,1-1.023.662,2.393,2.393,0,0,0,.826-.735,1.634,1.634,0,0,0,.185-.722Z",
    transform: "translate(-548.158 8.191)",
    fill: "#854729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7996",
    "data-name": "Caminho 7996",
    d: "M595.991,12.66a1.036,1.036,0,0,0,.418-.1,2.951,2.951,0,0,0,.364-.278s-.2.177-.252.177-.1-.1-.079-.161a.459.459,0,0,1-.167.218,1.063,1.063,0,0,1-.285.144",
    transform: "translate(-548.073 8.774)",
    fill: "#242626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7997",
    "data-name": "Caminho 7997",
    d: "M596.354,12.467a1.045,1.045,0,0,0,.218-.718c-.005-.49-.186-.4-.186-.4s.153.111.12.489a2.062,2.062,0,0,1-.152.634",
    transform: "translate(-547.814 8.099)",
    fill: "#242626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7998",
    "data-name": "Caminho 7998",
    d: "M596.515,12.29a.592.592,0,0,0,.334-.206.975.975,0,0,0,.091-.435,1.072,1.072,0,0,1-.1.357,3.208,3.208,0,0,1-.326.285",
    transform: "translate(-547.699 8.321)",
    fill: "#242626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_7999",
    "data-name": "Caminho 7999",
    d: "M596.428,13s.125-.249.29-.185a.23.23,0,0,1,.171.2.255.255,0,0,0-.192-.111.564.564,0,0,0-.269.1",
    transform: "translate(-547.761 9.144)",
    fill: "#242626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8000",
    "data-name": "Caminho 8000",
    d: "M596.154,12.8s.365-.1.586-.161.47-.175.47-.175a1.984,1.984,0,0,1-.455.381,1.181,1.181,0,0,1-.5.165s.514-.225.55-.314a2.428,2.428,0,0,1-.655.1",
    transform: "translate(-547.957 8.901)",
    fill: "#242626"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8001",
    "data-name": "Caminho 8001",
    d: "M596.01,12.325a.419.419,0,0,1,.029.6.454.454,0,0,1-.52.1",
    transform: "translate(-548.409 8.804)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8002",
    "data-name": "Caminho 8002",
    d: "M595.979,12.353a.361.361,0,0,1,.008.526.383.383,0,0,1-.454.075",
    transform: "translate(-548.399 8.824)",
    fill: "#e06a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8003",
    "data-name": "Caminho 8003",
    d: "M595.759,12.471a.154.154,0,0,1,.132.168.149.149,0,0,1-.171.125.118.118,0,0,1-.106-.069",
    transform: "translate(-548.343 8.908)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8004",
    "data-name": "Caminho 8004",
    d: "M595.749,12.608a.045.045,0,0,1-.057.033.043.043,0,0,1-.039-.051.05.05,0,0,1,.057-.041.053.053,0,0,1,.039.06",
    transform: "translate(-548.316 8.963)",
    fill: "#d2d1c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8005",
    "data-name": "Caminho 8005",
    d: "M596.133,12.76a1.18,1.18,0,0,0,.3-.562,1.535,1.535,0,0,0,.019-.506l.137.141.051.245-.081.4a.352.352,0,0,0,.266-.127,2.014,2.014,0,0,0,.185-1.013,1.04,1.04,0,0,1-.025.615.786.786,0,0,1-.521.706,1.516,1.516,0,0,0-.61.679,2.983,2.983,0,0,1-.377.492c-.007,0,.173-.252.262-.434a1.96,1.96,0,0,1,.28-.447Z",
    transform: "translate(-548.44 8.101)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8006",
    "data-name": "Caminho 8006",
    d: "M595.8,12.651a2.279,2.279,0,0,0,.108-.5.971.971,0,0,0-.113-.381s.152-.027.165.36-.07.406-.16.523",
    transform: "translate(-548.216 8.406)",
    fill: "#854729"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8007",
    "data-name": "Caminho 8007",
    d: "M596.11,12.393a1.537,1.537,0,0,0,.1-.477.688.688,0,0,0-.165-.37s.192.039.216.386-.051.348-.153.461",
    transform: "translate(-548.033 8.247)",
    fill: "#4a2d1d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8008",
    "data-name": "Caminho 8008",
    d: "M595.509,13.536a.39.39,0,0,1-.084-.2c.016-.091.007-.108.23-.339a2.067,2.067,0,0,0,.4-.5c.057-.127.237-.47.1-.727a.9.9,0,0,1-.127.686,2.446,2.446,0,0,1-.529.6c-.185.132-.2.2-.2.274s.022.154.055.173a.39.39,0,0,0,.161.036",
    transform: "translate(-548.572 8.405)",
    fill: "#a06c32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8009",
    "data-name": "Caminho 8009",
    d: "M596.91,13.476a.086.086,0,0,0,.075-.053.236.236,0,0,0-.043-.255.508.508,0,0,0-.281-.189c-.108-.029-.317-.057-.317-.057a.593.593,0,0,0,.209.206c.071.043.191-.009.264.063s.093.285.093.285",
    transform: "translate(-547.821 9.23)",
    fill: "#664322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8010",
    "data-name": "Caminho 8010",
    d: "M596.674,13.461a.391.391,0,0,0,.261-.321.46.46,0,0,0-.021-.2.219.219,0,0,0,.137.108l.087-.036s-.151.454-.464.446",
    transform: "translate(-547.586 9.245)",
    fill: "#664322"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8011",
    "data-name": "Caminho 8011",
    d: "M595.668,13.357a.373.373,0,0,1,.137.123,1.056,1.056,0,0,0,.139.141l.6-.156.19-.189-.165-.255h-.426Z",
    transform: "translate(-548.304 9.301)",
    fill: "#b37f36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8012",
    "data-name": "Caminho 8012",
    d: "M597.748,13.328l-.116-.156a.262.262,0,0,0-.114-.1,1.557,1.557,0,0,0-.449-.045l-.257.06a.291.291,0,0,1-.21.036,3.523,3.523,0,0,1-.419-.151l-.293-.129s-.218-.093-.269-.069a1.329,1.329,0,0,0-.228.213s-.033.108.036.108-.107.036-.107.036a1.118,1.118,0,0,0-.527.694c-.072.442.751,1.1,1.051.763,0,0-.444-.326-.356-.607a.653.653,0,0,1,.643-.459.729.729,0,0,0,.521-.166.483.483,0,0,1,.643.045c.211.218-.8.425-.8.425l.113.156s1.236-.425,1.135-.653",
    transform: "translate(-548.931 9.122)",
    fill: "#efc745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8013",
    "data-name": "Caminho 8013",
    d: "M597.76,13.342l.017-.015-.113-.156-.02.015.027-.009a.3.3,0,0,0-.127-.117.2.2,0,0,0-.1-.031,2.818,2.818,0,0,0-.345-.017h-.02l-.277.057h0v0a.166.166,0,0,1-.119.039.218.218,0,0,1-.063-.007c-.057-.012-.167-.053-.254-.081l-.164-.062-.007.026.007-.026-.288-.129-.1-.036a.676.676,0,0,0-.165-.043l-.028,0a.354.354,0,0,0-.063.045c-.072.065-.176.18-.176.18h0v.009a.17.17,0,0,0-.012.06.125.125,0,0,0,.014.053.068.068,0,0,0,.055.039h.012v-.017l-.006.017h.006v-.017l-.006.017.015-.029-.021.017.006.012.015-.029-.021.017.021-.021h-.028l.007.021.021-.021h0l-.021-.009-.007.009h.028l-.021-.009.014.009-.014-.019v.01l.014.009-.008-.019a.048.048,0,0,1-.024.01.459.459,0,0,1-.05.009.071.071,0,0,0-.04.009,1.308,1.308,0,0,0-.249.183.981.981,0,0,0-.3.531c0,.019,0,.039,0,.06a.888.888,0,0,0,.3.557.915.915,0,0,0,.565.274.372.372,0,0,0,.244-.094l.021-.031-.021-.024-.019-.005a1.375,1.375,0,0,1-.2-.192.512.512,0,0,1-.141-.3.5.5,0,0,1,0-.072.741.741,0,0,1,.216-.314.724.724,0,0,1,.4-.125,1.276,1.276,0,0,0,.348-.06.767.767,0,0,0,.192-.117.536.536,0,0,1,.293-.089.419.419,0,0,1,.311.13c.019.022.021.031.021.043a.068.068,0,0,1-.025.051.53.53,0,0,1-.18.106c-.121.048-.266.093-.38.127-.062.014-.117.033-.146.038a.305.305,0,0,1-.063.01l-.051.005.151.218.026-.005s.284-.1.568-.225a3.432,3.432,0,0,0,.395-.2.577.577,0,0,0,.136-.11.178.178,0,0,0,.053-.113.092.092,0,0,0,0-.039l-.007-.007-.017.015-.031.015.007.015a.173.173,0,0,1-.041.074,1.371,1.371,0,0,1-.256.177c-.168.087-.374.177-.533.24-.089.029-.158.057-.209.074a.819.819,0,0,0-.083.031l.011.027.023-.015-.108-.168-.021.027.005.026s.206-.041.41-.106c.1-.036.208-.079.29-.118a.67.67,0,0,0,.1-.074.154.154,0,0,0,.038-.093.113.113,0,0,0-.038-.084.475.475,0,0,0-.35-.149.585.585,0,0,0-.329.1.77.77,0,0,1-.18.113,1.129,1.129,0,0,1-.326.046.826.826,0,0,0-.432.146.685.685,0,0,0-.229.345.188.188,0,0,0-.019.086.633.633,0,0,0,.192.377,1.465,1.465,0,0,0,.185.175l.019-.027-.021-.015a.264.264,0,0,1-.2.075.864.864,0,0,1-.526-.257.781.781,0,0,1-.277-.513v-.053a.98.98,0,0,1,.285-.5,1.6,1.6,0,0,1,.164-.125.355.355,0,0,1,.05-.036l.016-.01v0l-.016-.024.01.029a.393.393,0,0,0,.062-.017c.013,0,.031,0,.043-.007l.014-.005.012,0,.007-.012.012-.017-.012-.012c0-.015-.007-.015-.013-.022h-.026c-.013,0-.013,0-.013-.009a.042.042,0,0,1-.005-.021c0-.015.005-.019.005-.027V13l-.024,0,.019.021s.044-.053.1-.1c.025-.024.053-.051.077-.072a.289.289,0,0,1,.041-.033h.011a.748.748,0,0,1,.143.033c.022.012.047.021.071.031l.028.005.289.132a2.685,2.685,0,0,0,.432.144.154.154,0,0,0,.072.012.247.247,0,0,0,.153-.051l-.012-.017v.024l.266-.055-.008-.029v.029h.02c.04,0,.122,0,.213.009a.74.74,0,0,1,.12.012c.038.01.07.012.084.019a.237.237,0,0,1,.077.062.039.039,0,0,1,.015.024l.005.007,0,0,0,0,0,0,0,0v0l.12.156.024-.019-.031.015Z",
    transform: "translate(-548.943 9.109)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8014",
    "data-name": "Caminho 8014",
    d: "M595.358,14.348s-.5-.122-.458-.586a.78.78,0,0,1,.53-.65c.077-.017.06-.25.14-.281a.387.387,0,0,1,.317.072,1.038,1.038,0,0,0,.225.132s-.879.394-.892.907c-.007.331.137.406.137.406",
    transform: "translate(-548.854 9.158)",
    fill: "#f9f2d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8015",
    "data-name": "Caminho 8015",
    d: "M597.494,13.277s-.065.039-.083.005a.52.52,0,0,0-.485-.214c-.233,0-.386.086-.539.086s-.108-.026-.293-.029-.562-.3-.649-.267a.185.185,0,0,0-.11.19c.005.053-.159.053-.187.014s.14-.285.292-.285c.425,0,.735.285.933.285s.276-.12.548-.12.563.12.575.336",
    transform: "translate(-548.677 9.126)",
    fill: "#f8e9ae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8016",
    "data-name": "Caminho 8016",
    d: "M595.708,13.354a1.934,1.934,0,0,0,.354-.108,3.1,3.1,0,0,1,.35-.117s-.18.117-.313.185a1.561,1.561,0,0,1-.333.087Z",
    transform: "translate(-548.275 9.378)",
    fill: "#4e392a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8017",
    "data-name": "Caminho 8017",
    d: "M595.654,14.5a.82.82,0,0,1-.5-.177.917.917,0,0,1-.35-.506.72.72,0,0,1,.23-.617c.281-.3.333-.218.351-.206s-.019.029-.019.029l-.25.211-.127.209-.114.2.014.228.12.223.4.249Z",
    transform: "translate(-548.926 9.269)",
    fill: "#efc745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8018",
    "data-name": "Caminho 8018",
    d: "M595.272,12.886l-.012-.041v.045l.012,0-.012-.041v0l-.027.033a.039.039,0,0,0,.019.012l.009-.045-.027.033.027-.033h-.045a.033.033,0,0,0,.018.033l.027-.033h-.007l-.033-.015,0,.015h.038l-.033-.015.031.012-.031-.019v.007l.031.012-.031-.019.013,0-.013,0,.013,0-.013,0-.021.024a.794.794,0,0,0-.053.081.158.158,0,0,0-.039.1v.019a.093.093,0,0,0,.06.077.157.157,0,0,0,.093.024.483.483,0,0,0,.132-.024.036.036,0,0,0,.025-.048.039.039,0,0,0-.053-.029.3.3,0,0,1-.1.021.1.1,0,0,1-.053-.015c-.012-.005-.019-.005-.019-.024A.043.043,0,0,1,595.2,13a.31.31,0,0,1,.054-.079.29.29,0,0,1,.024-.033l.01-.009v0l0,0,.007-.012v-.014a.044.044,0,0,0-.012-.031.123.123,0,0,0-.027-.015l-.016.01a.04.04,0,0,0-.024.057.038.038,0,0,0,.052.021",
    transform: "translate(-548.704 9.142)",
    fill: "#81512a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8019",
    "data-name": "Caminho 8019",
    d: "M595.958,13.158s-.6.165-.613.177c-.042.029.191,0,.377-.012a.681.681,0,0,1,.212.033.588.588,0,0,0,.149-.033c.232-.089.71-.269.754-.06.036.18-.667.338-.667.338l0,.067.566-.141.288-.153.094-.153-.278-.2h-.417l-.19.053Z",
    transform: "translate(-548.538 9.301)",
    fill: "#efc745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8020",
    "data-name": "Caminho 8020",
    d: "M595.473,13.723a.67.67,0,0,0,.254.357s.022.005.012.017-.086.063-.278.015a.846.846,0,0,1-.662-.665l.007.12.1.209.185.192.3.183.2.053.172-.045.077-.057-.173-.159-.216-.37a.291.291,0,0,0,.024.149",
    transform: "translate(-548.925 9.605)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8021",
    "data-name": "Caminho 8021",
    d: "M596.4,16.733l0,.2-.108-.012.014-.242Z",
    transform: "translate(-547.861 11.912)",
    fill: "#f2c948"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8022",
    "data-name": "Caminho 8022",
    d: "M596.054,13.574l-.2-.221-.122.021.193.278Z",
    transform: "translate(-548.261 9.538)",
    fill: "#f2c948"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8023",
    "data-name": "Caminho 8023",
    d: "M596.623,17.085a1.677,1.677,0,0,0-.272-.149,1.585,1.585,0,0,0-.377-.108l-.012.048a.15.15,0,0,1,.033.005,1.494,1.494,0,0,1,.343.1c.071.036.141.072.186.1.025.017.044.026.053.033a.034.034,0,0,1,.02.017Z",
    transform: "translate(-548.095 12.02)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8024",
    "data-name": "Caminho 8024",
    d: "M596.616,16.69s-.111-.007-.229-.007a.932.932,0,0,0-.219.019.546.546,0,0,0-.218.1l.026.045h.006a.459.459,0,0,1,.2-.1,1.334,1.334,0,0,1,.208-.017,1.079,1.079,0,0,1,.158.009.4.4,0,0,1,.067.005Z",
    transform: "translate(-548.102 11.916)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8025",
    "data-name": "Caminho 8025",
    d: "M596.585,16.437a3.837,3.837,0,0,0-.41.216c-.12.084-.257.194-.257.194l.029.039s.036-.027.079-.063a1.506,1.506,0,0,1,.182-.129c.06-.041.159-.089.243-.137l.15-.072Z",
    transform: "translate(-548.126 11.741)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8026",
    "data-name": "Caminho 8026",
    d: "M596.379,16.182h0a.531.531,0,0,1-.048.194c-.015.019-.055.063-.1.12-.069.081-.177.192-.257.278s-.14.156-.14.156l.029.036s.116-.117.236-.245c.063-.065.121-.134.171-.189a1.093,1.093,0,0,0,.1-.125.436.436,0,0,0,.063-.225Z",
    transform: "translate(-548.189 11.559)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8027",
    "data-name": "Caminho 8027",
    d: "M596.069,16.072v.012a.456.456,0,0,1,.012.122.6.6,0,0,1-.039.228,3.351,3.351,0,0,1-.152.345c-.033.057-.061.111-.078.144s-.032.065-.032.065l.044.019a4.68,4.68,0,0,0,.266-.554.926.926,0,0,0,.04-.247.762.762,0,0,0-.015-.146Z",
    transform: "translate(-548.224 11.471)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8028",
    "data-name": "Caminho 8028",
    d: "M595.831,16.043s0,.026,0,.053.005.084.005.134a.812.812,0,0,1-.04.281c-.022.084-.068.2-.1.291l-.056.156.044.019s.1-.274.164-.453a.855.855,0,0,0,.04-.295,1.406,1.406,0,0,0-.013-.189Z",
    transform: "translate(-548.323 11.458)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8029",
    "data-name": "Caminho 8029",
    d: "M595.65,16.042s0,.089,0,.194a1.735,1.735,0,0,1-.035.31c-.037.168-.077.4-.077.4l.045.012s.012-.065.027-.141.036-.177.051-.262a2.842,2.842,0,0,0,.044-.518Z",
    transform: "translate(-548.399 11.459)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8030",
    "data-name": "Caminho 8030",
    d: "M595.47,16.07a.626.626,0,0,1,0,.084,1.239,1.239,0,0,1,.007.173.789.789,0,0,1-.016.2,2.784,2.784,0,0,0-.068.4l.051.009s.006-.063.017-.144a1.76,1.76,0,0,1,.044-.25.78.78,0,0,0,.019-.219c0-.135-.011-.261-.011-.261Z",
    transform: "translate(-548.497 11.476)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8031",
    "data-name": "Caminho 8031",
    d: "M595.381,16.089a.056.056,0,0,1,.007.033,1.376,1.376,0,0,1-.051.353c-.027.1-.057.209-.084.305s-.044.159-.044.159l.051.014s.071-.269.129-.47a1.345,1.345,0,0,0,.046-.362v-.036Z",
    transform: "translate(-548.633 11.49)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8032",
    "data-name": "Caminho 8032",
    d: "M595.348,16.09v.033a.278.278,0,0,1,.006.081.7.7,0,0,1-.07.333,1,1,0,0,1-.218.245.547.547,0,0,0-.1.075.1.1,0,0,0-.043.017l-.008,0,.027.051a1.284,1.284,0,0,0,.386-.369.759.759,0,0,0,.077-.357c0-.072,0-.117,0-.118Z",
    transform: "translate(-548.843 11.489)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8033",
    "data-name": "Caminho 8033",
    d: "M595.292,16.06a.318.318,0,0,1-.016.036,1.294,1.294,0,0,1-.146.3,1.026,1.026,0,0,1-.216.178.32.32,0,0,1-.087.063c-.021.009-.038.015-.038.021l.029.045a1.294,1.294,0,0,0,.344-.273,1.063,1.063,0,0,0,.173-.358Z",
    transform: "translate(-548.932 11.471)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8034",
    "data-name": "Caminho 8034",
    d: "M595.113,15.994l-.017.024c-.019.024-.035.06-.061.1a.371.371,0,0,1-.079.1.843.843,0,0,1-.154.1.91.91,0,0,1-.1.062l.024.045.1-.062a1.246,1.246,0,0,0,.159-.108.582.582,0,0,0,.117-.147c.024-.05.048-.093.048-.093Z",
    transform: "translate(-548.99 11.424)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8035",
    "data-name": "Caminho 8035",
    d: "M595.012,15.9l-.035.039a1.4,1.4,0,0,1-.152.161c-.029.029-.057.057-.078.074a.21.21,0,0,1-.07.036l.019.048a.293.293,0,0,0,.1-.069,2.853,2.853,0,0,0,.252-.257Z",
    transform: "translate(-549.013 11.361)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8036",
    "data-name": "Caminho 8036",
    d: "M594.97,15.844a.28.28,0,0,1-.04.031c-.032.026-.089.069-.133.1a.6.6,0,0,1-.138.051v.05a.212.212,0,0,0,.1-.033,1.7,1.7,0,0,0,.233-.161Z",
    transform: "translate(-549.024 11.317)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8037",
    "data-name": "Caminho 8037",
    d: "M594.932,15.782a.944.944,0,0,1-.12.063c-.033.014-.065.036-.1.051a.247.247,0,0,1-.063.021v.051c.028-.005.052-.015.084-.024.092-.045.221-.117.221-.117Z",
    transform: "translate(-549.03 11.273)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8038",
    "data-name": "Caminho 8038",
    d: "M594.878,15.652l-.005.005c-.014.012-.046.048-.083.079a.293.293,0,0,1-.141.048v.053a.355.355,0,0,0,.184-.074.458.458,0,0,0,.083-.075Z",
    transform: "translate(-549.031 11.18)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8039",
    "data-name": "Caminho 8039",
    d: "M594.893,15.447s-.045.039-.089.084a.39.39,0,0,0-.124.156.055.055,0,0,1-.016.017l-.012.012h0v.055a.044.044,0,0,0,.045-.024.114.114,0,0,0,.028-.046.487.487,0,0,1,.109-.13c.027-.024.051-.043.065-.058a.178.178,0,0,0,.027-.024Z",
    transform: "translate(-549.03 11.034)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8040",
    "data-name": "Caminho 8040",
    d: "M595.8,14.274h.236l.006-.007h.006v-.005h.012l0-.015,0-.014-.012-.012h-.012v.029l0,.024h0V14.25l0,.024,0-.024,0,.017v.007l0-.024,0,.017,0-.021-.008.021h0l0-.021-.008.021.008-.021-.015.015.007.005.008-.021-.015.015,0-.007.019-.009h-.023l0,.009.019-.009h-.023l0-.014.011-.012.008.026,0-.026h0l.008.026,0-.026,0,.021v-.021h0l0,.021v-.021H595.8Z",
    transform: "translate(-548.211 10.158)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8041",
    "data-name": "Caminho 8041",
    d: "M595.8,14.263h.017a.231.231,0,0,0,.108-.033c.057-.027.108-.069.16-.1a.359.359,0,0,1,.072-.051.125.125,0,0,1,.049-.014v-.048a.213.213,0,0,0-.1.036c-.048.026-.1.065-.156.1a.222.222,0,0,1-.132.058h0Z",
    transform: "translate(-548.211 10.013)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8042",
    "data-name": "Caminho 8042",
    d: "M595.787,14.139a.374.374,0,0,0,.12-.045c.064-.036.132-.081.191-.12a.387.387,0,0,1,.153-.072v-.048a.334.334,0,0,0-.115.033c-.06.036-.125.087-.19.129a.435.435,0,0,1-.159.072Z",
    transform: "translate(-548.219 9.896)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8043",
    "data-name": "Caminho 8043",
    d: "M595.745,14.058a1.83,1.83,0,0,0,.249-.173,3.066,3.066,0,0,1,.257-.192l-.027-.039c-.072.039-.165.12-.262.189a2.316,2.316,0,0,1-.24.177Z",
    transform: "translate(-548.266 9.752)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8044",
    "data-name": "Caminho 8044",
    d: "M595.651,13.911c.12-.087.406-.3.521-.365l-.027-.045c-.113.072-.4.281-.523.369Z",
    transform: "translate(-548.337 9.644)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8045",
    "data-name": "Caminho 8045",
    d: "M595.52,13.77c.081-.069.192-.141.3-.213s.2-.122.248-.158l-.036-.039c-.042.029-.135.087-.24.156a2.363,2.363,0,0,0-.3.209Z",
    transform: "translate(-548.433 9.543)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8046",
    "data-name": "Caminho 8046",
    d: "M595.419,13.682l.245-.173c.065-.048.132-.091.185-.132s.105-.069.124-.072l-.024-.045c-.02.009-.066.039-.123.075-.173.113-.439.305-.439.305Z",
    transform: "translate(-548.506 9.471)",
    fill: "#7c6c31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8047",
    "data-name": "Caminho 8047",
    d: "M596.26,13.236a.192.192,0,0,1,.031.027,2.474,2.474,0,0,1,.394.394,1.15,1.15,0,0,1,.287.667v.069a1.6,1.6,0,0,1-.395.814,11.358,11.358,0,0,1-1.14,1.02,3.046,3.046,0,0,0-.47.5.934.934,0,0,0-.2.552v.027a1.034,1.034,0,0,0,.18.55.715.715,0,0,0,.507.309c.04,0,.079,0,.116,0,.292,0,.6-.1.907-.1a.9.9,0,0,1,.706.3,1.408,1.408,0,0,1,.268.926,3.746,3.746,0,0,1-.067.663,1.746,1.746,0,0,1-.044.216c-.009.05-.015.077-.015.077l.051.015a4.456,4.456,0,0,0,.121-.972,1.432,1.432,0,0,0-.274-.962.926.926,0,0,0-.746-.307c-.31,0-.627.082-.907.082h-.109a.661.661,0,0,1-.47-.283,1,1,0,0,1-.175-.525v-.027a1.088,1.088,0,0,1,.319-.693c.286-.329.732-.638,1.116-.987a2.058,2.058,0,0,0,.769-1.207c0-.024.007-.05.007-.072a1.307,1.307,0,0,0-.375-.778,3.112,3.112,0,0,0-.364-.351Z",
    transform: "translate(-548.945 9.425)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8048",
    "data-name": "Caminho 8048",
    d: "M595.663,13.18l.056.057a.37.37,0,0,0-.072-.015c-.02,0,.016-.041.016-.041",
    transform: "translate(-548.324 9.414)",
    fill: "#efc745"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8049",
    "data-name": "Caminho 8049",
    d: "M595.732,13.219a.822.822,0,0,1-.1.015c-.028.009.032-.031.032-.031Z",
    transform: "translate(-548.338 9.431)",
    fill: "#844629"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8050",
    "data-name": "Caminho 8050",
    d: "M596.246,17.335a.164.164,0,0,0,.093-.045c.027-.039-.016.065-.016.065l-.044.015Z",
    transform: "translate(-547.891 12.344)",
    fill: "#907c35"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8051",
    "data-name": "Caminho 8051",
    d: "M595.466,13.528l-.063-.051-.049.015.094.081Z",
    transform: "translate(-548.529 9.626)",
    fill: "#a5ab72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8052",
    "data-name": "Caminho 8052",
    d: "M595.543,13.615l-.048-.048-.024.009.04.057Z",
    transform: "translate(-548.445 9.691)",
    fill: "#a5ab72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8053",
    "data-name": "Caminho 8053",
    d: "M595.671,13.76l-.04-.048-.026.031.045.045Z",
    transform: "translate(-548.348 9.794)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8054",
    "data-name": "Caminho 8054",
    d: "M595.772,13.911l-.024-.053-.051.009.06.062Z",
    transform: "translate(-548.283 9.898)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8055",
    "data-name": "Caminho 8055",
    d: "M595.814,14.057l-.027-.072,0,.015,0,.05Z",
    transform: "translate(-548.225 9.989)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8056",
    "data-name": "Caminho 8056",
    d: "M595.814,14.2l.007-.063-.034-.024.007.091Z",
    transform: "translate(-548.219 10.082)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8057",
    "data-name": "Caminho 8057",
    d: "M595.807,14.294l0-.075-.021-.017v.1Z",
    transform: "translate(-548.217 10.144)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8058",
    "data-name": "Caminho 8058",
    d: "M594.672,15.693a.413.413,0,0,1,.027-.113c.009-.055-.055.026-.055.026l0,.072Z",
    transform: "translate(-549.038 11.115)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8059",
    "data-name": "Caminho 8059",
    d: "M594.664,15.727l-.031.012.012.072.019-.024Z",
    transform: "translate(-549.043 11.233)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8060",
    "data-name": "Caminho 8060",
    d: "M594.661,15.921l0-.069-.017,0v.1Z",
    transform: "translate(-549.038 11.321)",
    fill: "#767334"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_520",
    "data-name": "Ret\\xE2ngulo 520",
    width: 0.027,
    height: 0.059,
    transform: "translate(45.609 27.344) rotate(-11.34)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8061",
    "data-name": "Caminho 8061",
    d: "M594.7,16.143l-.017-.06-.01.012,0,.06Z",
    transform: "translate(-549.014 11.488)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8062",
    "data-name": "Caminho 8062",
    d: "M594.745,16.286l-.027-.081-.018.005.024.082Z",
    transform: "translate(-548.995 11.575)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8063",
    "data-name": "Caminho 8063",
    d: "M594.838,16.459l-.033-.051-.032-.005.044.062Z",
    transform: "translate(-548.943 11.716)",
    fill: "#a5ab72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8064",
    "data-name": "Caminho 8064",
    d: "M594.989,16.6a.506.506,0,0,1-.072-.053c-.051-.043-.021.038-.021.038l.065.031Z",
    transform: "translate(-548.862 11.807)",
    fill: "#a5ab72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8065",
    "data-name": "Caminho 8065",
    d: "M595.889,16.651a.572.572,0,0,1-.06-.036s.012,0,.029.06.03-.024.03-.024",
    transform: "translate(-548.189 11.868)",
    fill: "#a5ab72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8066",
    "data-name": "Caminho 8066",
    d: "M595.967,16.723a.289.289,0,0,0-.048-.051c-.021-.014-.009.039-.009.039l.029.017Z",
    transform: "translate(-548.133 11.907)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8067",
    "data-name": "Caminho 8067",
    d: "M595.971,16.742c-.019-.027-.036.029-.036.029l.052.051s0-.063-.016-.081",
    transform: "translate(-548.113 11.953)",
    fill: "#a5ab72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8068",
    "data-name": "Caminho 8068",
    d: "M595.968,16.9a.415.415,0,0,0,.012-.081c-.007-.027-.027.012-.027.012V16.9Z",
    transform: "translate(-548.1 12.009)",
    fill: "#a5ab72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8069",
    "data-name": "Caminho 8069",
    d: "M595.924,17.017l.016-.051h-.022l-.009.058Z",
    transform: "translate(-548.132 12.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8070",
    "data-name": "Caminho 8070",
    d: "M594.526,12.123s.087-.019.024.087.04-.094.04-.094l-.036-.012Z",
    transform: "translate(-549.121 8.646)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_830",
    "data-name": "Grupo 830",
    transform: "translate(57.775 32.947)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_829",
    "data-name": "Grupo 829",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_8071",
    "data-name": "Caminho 8071",
    d: "M602.7,18.833l1.125,1.341-1.335,1.154-1.125-1.341Z",
    transform: "translate(-602.011 -19.494)",
    fill: "url(#radial-gradient-3)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMex);
export default __webpack_public_path__ + "static/media/flag_MEX.a9cd20fe84979a0d305fdc63a67581d6.svg";
export { ForwardRef as ReactComponent };